/** @format */

import privacyPolicy from "../components/Common/privacyPolicy";
import { Data } from "../types";

export const tosData: Data[] = [
   {
      title: "쯩 for 공공기관’ 서비스 이용약관",
      desc: `
         <html>
<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:"Malgun Gothic";
	panose-1:2 11 5 3 2 0 0 2 0 4;}
@font-face
	{font-family:"IBM Plex Sans KR";}
@font-face
	{font-family:"\@Malgun Gothic";}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin:0cm;
	line-height:115%;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;}
.MsoChpDefault
	{font-size:11.0pt;
	font-family:"Malgun Gothic",sans-serif;}
.MsoPapDefault
	{line-height:115%;}
@page WordSection1
	{size:595.45pt 841.7pt;
	margin:72.0pt 72.0pt 72.0pt 72.0pt;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0cm;}
ul
	{margin-bottom:0cm;}
-->
</style>

</head>

<body lang=en-KR style='word-wrap:break-word'>

<div class=WordSection1>

<p class=MsoNormal align=center style='margin-top:10.0pt;margin-right:0cm;
margin-bottom:10.0pt;margin-left:0cm;text-align:center;background:white'><b><span
lang=KO style='font-size:14.0pt;line-height:115%;font-family:"IBM Plex Sans KR";
color:black'>‘쯩 for 공공기관’ 서비스 이용약관</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제1조 (목적)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>본 약관은 주식회사 파라메타(이하 ‘회사’라 한다)가 제공하는 &quot;쯩 for 공공기관&quot; 서비스 이용과 관련하여
회사, 발급기관, 이용기관, 사용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제2조 (용어의 정의)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</span></p>

<ol style='margin-top:0cm' start=1 type=1>
 <li class=MsoNormal style='margin-top:19.0pt;text-align:justify;text-justify:
     inter-ideograph;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>쯩 for 공공기관: 개인의 신원, 자격, 경력 등 개인의 속성과 관련된 정보(이하 '신원 등'이라 한다)에 대한
     인증을 거쳐  발급된 크레덴셜 등을 사용자가 제어할 수 있는 개인 저장공간에 안전하게 저장, 관리 및 제출할 수 있는 기능을 제공하는
     블록체인 기반의 신원증명 모바일 애플리케이션을 말합니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>쯩 for 공공기관 서비스:  쯩 for 공공기관 애플리케이션에서 제공되는 모든 서비스에 대한 총칭입니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>DID(Decentralized ID): 쯩 for 공공기관 서비스의 각 주체 (발급기관, 이용기관, 사용자)
     가 블록체인 상에서 생성한  고유한 식별값입니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>지갑 개인키: 지갑 소유자가 전자서명을 하기 위해 사용하는 키. 개인 키와 쌍을 이루는 공개 키는 블록체인에 공개되어
     누구나 메세지의 위변조를 검증할 수 있습니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>DID 개인키: DID 소유자가 전자서명을 하기 위해 사용하는 키. 개인 키와 쌍을 이루는 공개 키는 블록체인에
     공개되어 누구나 메세지의 위변조를 검증할 수 있습니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>크레덴셜(Credential): 사용자의 신원 등에 대한 데이터가 발급기관의 인증 또는 사용자의 자기증명을 거친
     후 발급자의 개인키로 서명되어 발급된 DID 기반의 인증서.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>발급기관:  사용자의 요청에 따라 신원 등을 인증하고 개인키로 서명하여 크레덴셜을 발급하는 주체.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>이용기관: 서비스 제공 등의 목적으로 사용자로부터 크레덴셜을 제출받아 크레덴셜 위변조 및 제출자 소유의 크레덴셜
     여부를 검증하는 주체.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>사용자: 본 약관에 따라 회사가 제공하는 쯩 for 공공기관 서비스를 이용하는 주체.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>사용자 저장 데이터: 사용자가 쯩 for 공공기관 서비스를 이용하기 위한 목적으로 생성한 개인 데이터로서<b>
     </b>지갑 개인키, DID, DID 개인키, 쯩 for 공공기관 서비스를 통해 발급받은 크레덴셜, 크레덴셜 안의 개인 신원 정보 등을
     포함합니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>블록체인 저장 데이터: 제출된 크레덴셜의 검증을 목적으로 블록체인에 기록되는 데이터를 의미하며 DID, DID
     공개 키, 크레덴셜 상태값 등을 포함합니다(사용자의 신원 등에 관한 개인 정보는 블록체인 기록 대상이 아닙니다).</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>개인저장공간 (Personal Data Storage): 사용자 본인과 권한을 부여받은 사람만 읽고 쓸 수 있는
     개인키로 암호화된 클라우드 저장공간.</span></li>
</ol>

<p class=MsoNormal style='margin-top:19.0pt;margin-right:0cm;margin-bottom:
19.0pt;margin-left:0cm;background:white'><b><span lang=KO style='font-family:
"IBM Plex Sans KR";color:#333333'>제3조 (회사정보 등의 제공)<br>
</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";color:#333333'>회사는
다음 각 호의 사항을 사용자가 알아보기 쉽도록 서비스 내에 표시합니다. <br>
다만, 이용약관은 사용자가 연결 화면을 통하여 볼 수 있도록 할 수 있습니다.</span></p>

<ol style='margin-top:0cm' start=1 type=1>
 <li class=MsoNormal style='margin-top:19.0pt;background:white'><span lang=KO
     style='font-family:"IBM Plex Sans KR";color:#333333'>상호 및 대표자의 성명</span></li>
 <li class=MsoNormal style='background:white'><span lang=KO style='font-family:
     "IBM Plex Sans KR";color:#333333'>본사 주소지 주소</span></li>
 <li class=MsoNormal style='background:white'><span lang=KO style='font-family:
     "IBM Plex Sans KR";color:#333333'>전화번호, 이메일 주소</span></li>
 <li class=MsoNormal style='background:white'><span lang=KO style='font-family:
     "IBM Plex Sans KR";color:#333333'>사업자등록번호</span></li>
 <li class=MsoNormal style='background:white'><span lang=KO style='font-family:
     "IBM Plex Sans KR";color:#333333'>서비스 이용약관</span></li>
 <li class=MsoNormal style='margin-bottom:19.0pt;background:white'><span
     lang=KO style='font-family:"IBM Plex Sans KR";color:#333333'>개인정보 처리방침</span></li>
</ol>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제4조 (약관의 효력 및 변경)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>①  회사는 본 약관의 내용을 사용자가 알 수 있도록 쯩 for 공공기관 서비스 내 또는 별도의 연결화면에 게시합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>②  회사는 ‘약관의 규제에 관한 법률’ ‘정보통신망이용촉진 및 정보보호 등에 관한 법률’ 등 관련 법령을 위배하지 않는
범위에서 본 약관을 개정할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③  회사가 본 약관을 개정할 경우에는 적용일자 및 개정 내용, 개정 사유 등을 명시하여 제1항의 방식에 따라 그 개정
약관을 <span style='background:white'>적용일 7일 </span>이전부터 공지합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>④  회사는 전항에 따라 개정약관을 공지하면서 사용자가 개정약관에 대해 동의 또는 거부의 의사표시를 하지 않으면 동의한
것으로 볼 수 있다는 내용도 함께 공지를 하며, 사용자가 개정약관 시행일까지 거부의 의사표시를 하지 않는다면 개정약관에 동의한 것으로 볼 수 있습니다.
사용자가 개정약관에 대해 동의하지 않는 경우 회사 또는 사용자는 서비스 이용계약을 해지할 수 있습니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>  </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제5조 (쯩 for 공공기관 서비스 이용 절차) </span></b></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>①  <span style='background:white'>회사는
사용자가 되고자 하는 자가 본 약관 및 이용하고자 하는 쯩 for 공공기관 서비스의 종류에 따라 개별 약관이 존재하는 경우 그 개별 약관에 동의하고
본인확인을 거쳐 PIN 또는 생체인식 정보 등록을 마친 후, 쯩 for 공공기관 서비스의 이용을 승낙함으로써 쯩 for 공공기관 서비스 이용계약을
체결하는 것을 원칙으로 합니다.  </span></span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>②  <span style='background:white'>사용자는
쯩 for 공공기관 서비스 이용에 필요한 정보를 회사 또는 발급기관 또는 이용기관에 제공함으로써 쯩 for 공공기관 서비스를 이용할 수 있습니다.
</span></span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>③  <span style='background:white'>쯩
for 공공기관 서비스 이용에 필요한 정보는 서비스 내용 변경, 회사나 발급기관 또는 이용기관의 정책 변경 및 관련 법령에 따라 달라질 수 있습니다.</span></span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>④  사용자가 제1항이나 제2항에서 요청하는 정보를 사실대로
정확하게 제공하지 않은 경우 사전적 또는 사후적으로 서비스 이용에 제한을 받을 수 있습니다.</span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>⑤  타인의 명의나 정보를 도용하여 이용신청을 한 사용자는
사전적 또는 사후적으로 회사가 제공하는 서비스 전체 또는 일부가 제한될 수 있으며 관계법령에 따라 처벌을 받을 수 있습니다.</span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>⑥  회사는 사용자가 본 조의 절차에 위반하여 이용신청을 한
경우 이로 인해 발생한 피해에 대하여 책임을 지지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>⑦  회사는 사용자의 신청에 대하여 승낙함을 원칙으로 합니다.
다만, 회사는 다음 각 호의 어느 하나에 해당하는 이용 신청에 대해서는 승낙을 거절할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-top:19.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:72.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
조의 절차에 위반하여 이용신청을 한 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>기재
내용에 허위, 기재누락, 오기 등이 있거나 이용신청 요건을 충족하지 못한 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>회사가
서비스를 제공하지 않은 국가에서 비정상적이거나 우회적인 방법을 통해 서비스를 이용하는 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>사회의
안녕과 질서 또는 미풍양속을 저해할 목적으로 신청한 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
약관에 위배되거나 위법 또는 부당한 목적의 이용신청임이 확인된 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>영리를
추구할 목적으로 쯩 for 공공기관 서비스를 이용하고자 하는 경우</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:19.0pt;
margin-left:72.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:
-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>7.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
lang=KO style='font-family:"IBM Plex Sans KR";color:black'>그 밖에 각 호에 준하는 사유로서 승낙이
부적절하다고 판단되는 경우</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>        <span style='background:white'>⑧</span> 회사는 다음 각 호의 어느 하나에
해당하는 경우 그 사유가 해소될 때까지 승낙을 유보할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:72.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>회사의
설비에 여유가 없거나, 특정 모바일 기기의 지원이 어렵거나, 기술적 장애가 발생한  경우</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;
margin-left:72.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:
-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
lang=KO style='font-family:"IBM Plex Sans KR";color:black'>그 밖의 각 호에 준하는 사유로서 이용신청의
승낙이 어렵다고 판단되는 경우</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>          </span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black;background:white'>⑨</span><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> 회사는 일부 서비스 이용에 대해서 사용자에게 수수료를 부과할 수 있습니다. 회사는 건당 과금, 무료이용 조건 설정, 월
이용료 등 수수료 정책을 사전에 앱과 홈페이지를  통해 고지하고 시행합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제6조 (개인정보의 보호 및 사용)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>① 회사는 관련 법령이 정하는 바에 따라 사용자의 개인정보를 보호하기 위해 노력하며, 개인정보의 보호 및 사용에 대해서는
관련 법령에 따릅니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>② 사용자 저장 데이터는 사용자 동의 하에  쯩 for 공공기관 서비스 내에 저장됩니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③ 쯩 for 공공기관 사용자가 크레덴셜을 받기 위해 발급기관에 직접 제출하는 개인정보의 수집 및 보관에 대한 책임은 발급기관에
있으며 회사는 이에 대한 일체의 책임을 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>④ 쯩 for 공공기관 사용자가 검증 받기 위해 이용기관에 직접 제출하는 크레덴셜 및 개인정보의 수집, 보관 및 활용에
대한 책임은 이용기관에 있으며 회사는 이에 대한 일체의 책임을 부담하지 않습니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>⑤ 회사는 사용자의 귀책사유로 사용자 저장 데이터 및 개인정보가 유출되어 발생한 피해에 대하여 책임을 지지 않습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제7조  (자기주권형 개인정보 관리) </span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>① 쯩 for 공공기관 서비스는 정보 주체인 사용자가 크레덴셜와 크레덴셜에 담긴 신원 등에 관한 개인정보를 사용자 저장
데이터 형태로 본인이 제어할 수 있는  개인 저장공간에 직접 저장, 관리, 제출하는 자기주권형 신원증명 서비스입니다. 사용자는 사용자 저장 데이터의
안전한 보관 및 관리에 대한 책임이 있으며 제3자에게 데이터가 유출되거나 도용되지 않도록 할 책임이 있습니다. 사용자의 고의 또는 과실로 사용자
저장 데이터가 유출 또는 도용되어 발생한 책임에 대해 회사는 책임을 부담하지 않습니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>② 사용자 모바일 기기의 바이러스 감염,<span style='background:white'> 해킹, </span>비밀번호
유출 또는 생체인식 오류 등 각종 원인으로 사용자가 사용자 저장 데이터를 이용할 수 없게 되거나 제3자에게 노출된 경우 회사는 이에 대한 일체의
책임을 부담하지 않습니다. 단, 회사의 고의 또는 중과실의 경우에는 그렇지 아니합니다.  </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③ <span style='background:white'> 사용자는 블록체인 저장 데이터에 대한 소유권, 이동권, 삭제권
등의 권리를 주장할 수 없습니다.</span></span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제8조 (회사의 의무)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>①  회사는 관련 법령 및 본 약관에서 정하는 권리의 행사 및 의무의 이행을 신의에 따라 성실하게 준수합니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>②  회사는 사용자가 안전하게 쯩 for 공공기관 서비스를 이용할 수 있도록 개인정보(사용자 저장 데이터 포함)보호를 위해
필요한 보안시스템을 갖추어야 합니다. 회사는 사용자의 개인정보가 사용자의 동의없이 제 3자에게 제공되지 않도록 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③ 회사는 계속적이고 안정적인 쯩 for 공공기관 서비스의 제공을 위하여 최선을 다하여 노력합니다. 서비스 또는 설비에
장애가 생겼을 경우 천재지변, 비상사태, 현재의 기술로는 해결이 불가능한 장애나 결함 등 부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구하도록
최선의 노력을  다합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>④ 회사는 쯩 for 공공기관 서비스 이용과 관련하여 사용자가 장애나 개선사항에 대해 회사에 전달할 수 있는 방법을 서비스
내에 고지합니다. </span></p>

<p class=MsoNormal style='margin-left:18.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제9조 (사용자의 의무)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>①</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> 사용자는 본 약관 및 개정약관, 회사가 쯩 for 공공기관 서비스 화면에서 고지하는 내용을 확인하고 준수하여야 하며,
본 약관, 개정약관 및 고지 내용을 위반하거나 이행하지 아니하여 발생하는 손실 및 손해에 대하여 책임을 부담합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>②</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>  사용자는 쯩 for 공공기관 서비스 내에서 발급기관 또는 이용기관이 제공하는 상품 등을 가입 또는 구매 시 스스로의
책임 하에 가입 또는 구매하여야 하며, 회사는 상품 등의 내용과 거래 조건에 대해서 어떠한 보증이나 책임도 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>  사용자는 자신의 명의가 도용되거나 제3자에게 부정하게 사용된 것을 인지한 경우 즉시 그 사실을 회사에 통보하여야 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>④</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> 사용자는 쯩 for 공공기관 서비스를 이용하여 얻은 정보를 회사의 사전 동의 없이 영리목적으로 이용하거나 제3자에게 이용하게
하는 행위를 할 수 없으며, 쯩 for 공공기관 서비스의 이용권한 및 기타 이용계약상 지위를 타인에게 양도, 증여할 수 없습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>⑤</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>  사용자는 회사가 쯩 for 공공기관 서비스를 안전하게 제공할 수 있도록 회사에 협조하여야 하며, 회사가 사용자의 본
약관 위반행위를 발견하여 회원에게 해당 위반행위에 대하여 소명을 요청할 경우 회사의 요청에 적극 응하여야 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> <b><span style='background:white'>제10조 (사용자의 금지행위)</span></b></span></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR";background:white'>① 회사는 쯩 for 공공기관 서비스의 신뢰성을 제공하고 안전한 쯩 for 공공기관
서비스 이용이 이루어 질 수 있도록 아래와 같은 사용자의 행위를 금지합니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>1. 회사가 제공하는 쯩 for 공공기관 서비스
이용방법에 의하지 아니하고 비정상적인 방법으로 쯩 for 공공기관 서비스를 이용하거나 시스템에 접근하는 행위 </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>2. 회사에서 제공하는 서비스를 본래의 이용 목적 이외의 용도로 사용하는
행위. </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>3. 타인의 명의, 휴대폰 정보, 계좌 정보,
생체인식 정보, 신분증 등을 도용하여 쯩 for 공공기관 </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>서비스를 이용신청하거나 이용하는 행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'> 4. 회사 및 기타 제3자의 명예를 손상시키거나
업무를 방해하는 행위. </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>5. 회사 및 기타 제3자의 저작권, 초상권
등 지적재산권에 대한 침해행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>6. 회사가 제공하는 쯩 for 공공기관 서비스를
이용하여 얻은 회사 또는 제3자의 정보를 정보 소유자의 사전 동의 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>7. </span><span
lang=KO style='font-family:"IBM Plex Sans KR"'>회사의 동의 없이 영리, 영업, 광고, 정치활동, 불법선거운동
등을 목적으로 서비스를 이용하는 행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR";background:white'>           8. 기타 </span><span lang=KO
style='font-family:"IBM Plex Sans KR"'>공공질서 및 미풍양속을 위반하거나 불법적, 부당한 행위 및 법령에 위배되는
행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR";background:white'>&nbsp;</span></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR";background:white'>② 회사는 사용자가 본 조의 금지행위를 행하는 경우</span><span
lang=KO style='font-family:"IBM Plex Sans KR"'> 제11조에 <span style='background:
white'>따라 쯩 for 공공기관 서비스 이용을 제한할 수 있으며, 회사는 필요한 경우 사용자의 금지행위 사실을 관련 정부기관 또는 사법기관에
통지할 수 있습니다.</span></span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제11조 (사용자에 대한 서비스 이용 제한)  </span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>① 사용자는 다음 각 호의 어느하나에 해당하는 사유가 발생하는 경우 사용자의 서비스 이용제한 및 기타 조치를 포함한 이용제한
조치를 할 수 있습니다. </span></p>

<p class=MsoNormal style='margin-top:19.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:72.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
약관 제5조 제4항 및 제5항에 해당하는 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
약관 제9조의 사용자의 의무를 이행하지 않은 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
약관 제10조 제2항에 해당하는 경우</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:19.0pt;
margin-left:72.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:
-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
lang=KO style='font-family:"IBM Plex Sans KR";color:black'>기타 사용자가 본 약관을 위반하거나 부당한
행위를 한 경우</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>② 제1항의 이용제한이 정당한 경우에 회사는 이용제한으로 인하여 사용자가 입은 손해를 배상하지 않습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제12조 (서비스의 변경 및 중단)</span></b></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR"'>① 회사는 다음 각 호의 경우에는 서비스의 전부 또는 일부를 일시 중단할 수 있습니다. 이 경우 회사는 사전에
그 정지의 사유와 기간을 쯩 for 공공기관 초기화면이나 서비스 공지사항 등에 공지합니다. 다만, 사전에 공지할 수 없는 부득이한 사정이 있는
경우 사후에 공지할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:72.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>회사
또는 발급기관 또는 이용기관의 시스템 정기점검, 서버의 증설 및 교체, 네트워크의 불안정 등의 시스템 운영상 필요한 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>정전,
서비스 설비의 장애, 서비스 이용 폭주, 기간통신사업자의 설비 보수 또는 장애 및 점검 등으로 인하여 정상적인 서비스 제공이 불가능한 경우</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:19.0pt;
margin-left:72.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:
-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
lang=KO style='font-family:"IBM Plex Sans KR";color:black'>천재지변, 전쟁, 폭동, 테러, 해킹,
DDOS, 또는 이에 준하는 국가비상사태 등 회사가 통제할 수 없는 상황이 발생한 경우</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>② 쯩 for 공공기관
서비스는 관련 법령이나 정책 변경에 따라 달라질 수 있습니다. 회사는 쯩 for 공공기관 서비스 제공을 위해 계약을 체결하고 있는 발급기관 또는
이용기관 등의 시스템 운영 상황이나 계약 체결 상황에 따라서 쯩 for 공공기관 서비스 운영상 상당한 이유가 있는 경우에는 쯩 for 공공기관
서비스의 전체 또는 일부의 제공을 일시적으로 중단할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>③ 회사는 파산 신청,
기업회생절차 개시 신청, 현저한 수익 악화 등 정상적인 영업활동이 곤란하여 쯩 for 공공기관 서비스를 지속할 수 <span
style='background:white'>없는 때에는 사용자에게 이를 통지한 날로부터 30일이 경과한 때부터 쯩 for 공공기관 서비스를 중단할
수 있습니다.</span></span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>&nbsp;</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>④ <span
style='background:white'>회사는 원활한 서비스 제공을 위해 운영상 또는 기술상의 필요에 따라 서비스를 변경할 수 있으며, 변경
전에 해당 내용을 쯩 for 공공기관 서비스 내에 공지합니다. 다만, 버그․오류 등의 수정이나 긴급 업데이트 등 부득이하게 변경할 필요가 있는
경우 또는 중대한 변경에 해당하지 않는 경우에는 사후에 공지할 수 있습니다.</span></span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제13조 (정보의 제공 및 광고의 게재)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>① 회사는 사용자가 서비스 이용을 위해 필요하다고 인정되는 다양한 정보를 쯩 for 공공기관 서비스 내 혹은 별도의 홈페이지에
게시하거나 기타 방법으로 사용자에게 제공할 수 있습니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>② 회사는 본 서비스 등을 유지하기 위하여 광고를 게재할 수 있으며, 사용자는 서비스 이용 시 노출되는 광고게재에 대하여
동의합니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③ 쯩 for 공공기관 내에 노출되는 제3자가 주체인 제2항의 광고에 사용자가 참여하거나 거래를 함으로써 발생하는 손실과
손해에 대해서 회사는 어떠한 책임도 부담하지 않습니다, </span></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><b><span
lang=KO style='font-family:"IBM Plex Sans KR"'> </span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제14조 (손해배상)</span></b></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>① 회사 또는 사용자는
본 약관을 위반하여 상대방에게 손해를 입힌 경우에는 그 손해를 배상할 책임이 있습니다. 다만, 고의 또는 과실이 없는 경우에는 그러하지 아니 합니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>② 사용자가 서비스를
이용함에 있어 행한 불법행위 또는 본 약관을 위반한 행위로 회사가 당해 사용자 외의 제3자로부터 손해배상청구 또는 소송 등 각종 이의제기를 받는
경우 당해 사용자는 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 당해 사용자는 그로 인하여 회사에 발생한 모든 손해를
배상할 책임이 있습니다.</span></p>

<p class=MsoNormal style='margin-bottom:19.0pt;text-align:justify;text-justify:
inter-ideograph;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제15조 (회사의 면책)</span></b></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>① 회사는 사용자와
발급기관 또는 이용기관 상호간의 거래에 대한 어떠한 책임도 부담하지 않으며, 회사의 귀책사유가 아닌 사유로 발생한 서비스의 이용장애에 대하여 책임을
부담하지 않습니다. 또한<span style='background:white'> 회사는 사용자 또는 발급기관 또는 이용기관의 귀책사유로 인하여
발생한 손해에 대하여 회사의 귀책 사유가 없는 경우 책임을 부담하지 않습니다</span></span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>② 회사는 사용자가 쯩 for 공공기관 서비스를 이용하여 기대하는 수익을 달성하지 못했거나 상실한 것에 대해서
책임을 지지 않으며, 그 밖에 쯩 for 공공기관 서비스를 통하여 얻은 정보로 인하여 발생한 손해에 대하여도 책임을 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>③ 사용자가 자신의 개인정보, 사용자 저장 데이터, 비밀번호 (생체등록 정보 포함), 쯩 for 공공기관 서비스
이용 관련 정보 등을 타인에게 제공하거나, 사용자의 관리소홀로 유출됨으로써 발생하는 피해에 대해서 회사는 책임을 지지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>④ 회사는 사용자가 본인의 모바일 기기 내에 있는 사용자 저장 데이터의 전부나 일부를 삭제하여 서비스 이용에 제한이
되는 경우  회사는 이에 대해 책임을 지지 않습니다. </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>⑤ 회사는 발급기관이 크레덴셜을 발급하는 과정에서 발급기관의 고의 또는 과실로 인한 서비스의 이용장애 및 이로
인해 발생한 피해에 대해서 책임을 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>⑥ 회사는 이용기관이 크레덴셜을 검증하는 과정에서 이용기관의 고의 또는 과실로 인한 서비스의 이용장애 및 이로
인해 발생한 피해에 대해서 책임을 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>⑦ 회사는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 기타 이에 준하는 사유로 발생한 손해에 대하여 </span><span
lang=KO style='font-family:"IBM Plex Sans KR"'>책임을 지지 않습니다. 다만, 회사의 고의 또는 과실에 의한
경우에는 그러하지 아니합니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>⑧ 사용자가 모바일
기기의 변경, 모바일 기기의 번호 변경, 운영체제(OS) 버전의 변경, 해외 로밍, 통신사 변경 등으로 인해 콘텐츠 전부나 일부의 기능을 이용할
수 없는 경우 회사는 이에 대해 책임을 지지 않습니다<span style='background:white'>.</span></span></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
lang=KO style='font-family:"IBM Plex Sans KR"'> </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제16조 (재판권 및 준거법)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>이 약관은 대한민국 법률에 따라 규율되고 해석됩니다. 회사와 사용자 간에 발생한 분쟁으로 소송이 제기되는 경우에는 법령에
정한 절차에 따른 법원을 관할 법원으로 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
line-height:112%'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>v1.1.0</span></b></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
line-height:112%'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>개정일자 : 2025.01.14</span></b></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
line-height:112%'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>시행일자 : 2025.01.21</span></b></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
line-height:130%'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>&nbsp;</span></b></p>


</div>

</body>

</html>

      `,
   },
   {
      title: "증명서 이용약관",
      desc: `
      <h1>broof 이용약관</h1>
      <h2><제1장 총칙></h2>
      <h2>제1조 (목적)</h2>
      <p>
        본 약관은 파라메타(이하 회사라 함)가 제공하는 broof 이용과 관련하여, 회사와
        회원 및 이용자와의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을
        목적으로 합니다.
      </p>

      <h2>제2조 (용어의 정의)</h2>
      <ol>
        <li>
          ① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
          <ol class="sub">
            <li>
              서비스 : 회사가 웹사이트를 통해 제공하는 블록체인 증서 발급 서비스
              broof를 말합니다.
            </li>
            <li>
              유료서비스 : 회사가 제공하는 서비스 중 이용자가 회사에 일정 금액을
              결제하거나, 이용자가 회사 또는 제3자와의 거래 내지 약정 조건을 수락하는
              경우에 이용할 수 있는 회사의 서비스를 말합니다.
            </li>
            <li>이용자 : 서비스를 이용하는 회원 또는 비회원을 말합니다.</li>
            <li>
              회원 : 서비스에 접속하여 본 약관에 따라 회사와 이용계약을 체결하고
              회사가 제공하는 서비스를 이용하는 자를 말합니다.
            </li>
            <li>
              비회원 : 서비스에 가입하지 않고 서비스가 제공하는 정보 및 서비스를
              이용하는 자를 말합니다.
            </li>
            <li>유료회원 : 유료서비스를 이용하는 회원을 말합니다.</li>
            <li>
              개인정보 : 서비스를 이용하기 위해 회원 또는 비회원이 입력하여 서비스에
              기재되는 기관명, 성명, 이메일 주소 등 회원 또는 비회원의 개인정보를
              말합니다.
            </li>
            <li>발급기관 : 수령자에게 증서를 발급하는 회원을 말합니다.</li>
            <li>
              수령자 : 발급기관으로부터 증서를 발급받을 수 있는 권한을 부여받고 이를
              발급받으려는 이용자를 말합니다.
            </li>
            <li>
              발급 이용권 : 증서 발급을 요청하기 위해 구매하는 이용권을 말합니다.
            </li>
            <li>웹사이트 : https://broof.io 를 의미합니다.</li>
          </ol>
        </li>
        <li>
        ② 이 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는
          관련법령에서 정하는 바에 의하며, 관련 법령에서 정하지 않는 것은 일반적인
          상관례에 의합니다.
        </li>
      </ol>

      <h2>제3조 (약관의 게시와 개정)</h2>
      <ol>
        <li>
          ① 회사는 이 약관의 내용과 상호, 대표자의 성명, 영업소 소재지 주소,
          통신판매업 신고번호, 사업자등록번호, 연락처 등을 이용자가 알 수 있도록
          서비스 초기화면에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여
          볼 수 있도록 할 수 있습니다.
        </li>
        <li>
          ② 회사는 전자상거래 등에서의 소비자보호에 관한 법률, 소비자기본법, 약관의
          규제에 관한 법률, 전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및
          정보보호 등에 관한 법률 등 관련 법령을 위배하지 않는 범위에서 이 약관을
          개정할 수 있습니다.
        </li>
        <li>
          ③ 회사가 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과
          함께 개정약관의 적용일자 7일전부터 적용일자 전일까지 서비스 초기화면에
          공지합니다. 단 회원의 권리, 의무에 중대한 영향을 주는 변경의 경우에는
          적용일자 30일 전부터 공지하도록 합니다.
        </li>
        <li>
          ④ 회원은 변경된 약관에 대해 거부할 권리가 있습니다. 회사가 제3항의 공지 또는
          통보를 하면서 개정 약관의 적용/시행일까지 회원이 거부 의사를 표시하지 아니할
          경우 약관의 개정에 동의한 것으로 간주한다는 내용을 고지하였으나, 회원이
          명시적으로 약관 변경에 대한 거부의사를 표시하지 아니하면, 회사는 회원이
          적용/시행일자 부로 변경 약관에 동의한 것으로 간주합니다. 개정/변경 약관에
          대하여 거부의사를 표시한 회원은 계약의 해지 또는 회원 탈퇴를 선택할 수
          있습니다.
        </li>
      </ol>

      <h2>제4조 (약관의 해석)</h2>
      <ol>
        <li>
          ① 회원이 회사와 개별서비스에 대한 계약을 체결하는 경우 회사는 개별 서비스에
          대한 이용약관 또는 운영정책 등(이하 운영정책 등)을 둘 수 있으며, 해당 내용이
          본 약관과 상충되는 경우 개별서비스에 대한 운영정책 등이 본 약관보다
          우선합니다.
        </li>
        <li>
          ② 이 약관에서 규정하지 않은 사항에 관해서는 약관의 규제에 관한 법률,
          전기통신기본법, 전기통신사업법, 정보통신망 이용촉진 및 정보보호 등에 관한
          법률 등의 관계법령에 따릅니다.
        </li>
      </ol>

      <h2>제5조 (이용계약의 성립)</h2>
      <ol>
        <li>
          ① 회사와 회원 사이의 서비스 이용계약(이하 이용계약이라 함)은 서비스를
          이용하고자 하는 자(이하 가입신청자라 함)의 회원가입의 이용신청 및 본 약관과
          개인정보 처리방침의 내용에 대한 동의에 대한 회사의 이용승낙으로 성립합니다.
        </li>
        <li>
          ② 본 약관 및 개인정보처리방침에 대한 동의의 의사표시는 가입신청자가 가입신청
          당시 회원가입 버튼을 누름으로써 성립합니다. 이와 동시에 위 가입신청자가 본
          약관 및 개인정보처리방침에 대하여 동의한 것으로 간주합니다.
        </li>
        <li>
          ③ 회사는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다.
          다만, 회사는 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에
          이용계약을 해지할 수 있습니다.
          <ol class="sub">
            <li>
              가입신청자가 이 약관에 의하여 이전에 회원자격을 상실한 적이 있는 경우
            </li>
            <li>실명이 아니거나 타인의 명의를 이용한 가입신청의 경우</li>
            <li>
              허위의 정보를 기재하거나, 회사가 제시하는 내용을 기재하지 않은 경우
            </li>
            <li>
              만 14세 미만 아동이 정보통신망 이용촉진 및 정보보호 등에 관한 법률에서
              정한 개인정보 입력 시 법정대리인의 동의를 얻지 아니한 경우
            </li>
            <li>
              가입신청자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반
              사항을 위반하며 신청하는 경우
            </li>
          </ol>
        </li>
        <li>
          ④ 회사는 서비스관련설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는
          경우에는 승낙을 유보할 수 있습니다.
        </li>
        <li>
          ⑤ 회사가 제2항, 제3항 및 제4항에 따라 회원가입신청을 승낙하지 아니하거나
          유보한 경우, 회사는 원칙적으로 그 사실을 가입신청자에게 알리도록 합니다.
        </li>
        <li>
          ⑥ 이용계약의 성립 시기는 회사의 승낙이 가입신청자에게 도달한 시점으로
          합니다.
        </li>
        <li>
          ⑦ 회사는 회원에 대해 회사정책에 따라 등급별로 구분하여 이용시간, 이용횟수,
          서비스 메뉴 등을 세분하여 이용에 차등을 둘 수 있습니다.
        </li>
        <li>
          ⑧ 이 약관은 회원이 이 약관에 동의한 날로부터 회원 탈퇴 시까지 적용하는 것을
          원칙으로 합니다. 단, 이 약관의 일부 조항은 회원이 탈퇴 후에도 유효하게
          적용될 수 있습니다.
        </li>
      </ol>

      <h2>제6조 (이용자 정보의 제공)</h2>
      <ol>
        <li>
          ① 회원으로 가입하여 서비스를 이용하고자 하는 이용자는 이메일, 이름 등 회사가
          정한 가입 양식에 따라 정보를 제공하여야 합니다.
        </li>
        <li>
          ② 이용자가 제1항에서 정한 인증을 거치지 않은 경우 서비스 이용이 제한될 수
          있으며, 실명으로 등록하지 않은 이용자 또는 회원은 일체의 권리를 주장할 수
          없습니다.
        </li>
        <li>
          ③ 타인의 명의를 도용하여 이용신청을 한 회원의 모든 ID는 삭제되며, 관계법령에
          따라 처벌을 받을 수 있습니다.
        </li>
      </ol>

      <h2>제7조 (개인 정보의 보호 및 관리)</h2>
      <ol>
        <li>
          ① 회사는 관계 법령이 정하는 바에 따라 계정정보를 포함한 이용자의 개인정보를
          보호하기 위하여 노력합니다. 이용자의 개인정보 보호 및 사용에 대해서는 회사가
          별도로 고지하는 개인정보 처리방침에 따릅니다. 다만, 회사가 제공하는 공식
          서비스 사이트 이외의 링크된 사이트에서는 회사의 개인정보처리방침이 적용되지
          않습니다.
        </li>
        <li>
          ② 회사는 이용자의 귀책사유로 인하여 노출된 이용자의 계정정보를 포함한 모든
          정보에 대해서는 일체의 책임을 지지 않습니다.
        </li>
      </ol>

      <h2>제8조 (회원의 계정 및 비밀번호)</h2>
      <ol>
        <li>
          ① 회원은 서비스의 원활한 이용 및 회원의 정보보호, 서비스 이용안내 등의
          편의를 위하여 이용자가 선정한 이메일 주소를 계정으로 사용합니다. 다만,
          회사는 회원의 계정이 반사회적이거나 미풍양속을 해치거나 또는 운영자로 오인할
          우려가 있는 경우 등에는 해당 계정의 사용을 거부하거나 제한할 수 있습니다
        </li>
        <li>
          ② 회사는 계정정보를 통하여 당해 회원의 서비스 이용가능여부 등 제반 이용자
          관리 업무를 수행합니다.
        </li>
        <li>
          ③ 회원은 자신의 계정정보를 선량한 관리자로서의 주의의무를 다하여 관리 하여야
          합니다. 회원이 본인의 계정정보를 소홀히 관리하거나 제3자에게 이용을
          승낙함으로써 발생하는 손해에 대하여는 회원에게 책임이 있습니다.
        </li>
        <li>
          ④ 회원은 회사가 정한 기준을 충족하는 범위 내에서 자유롭게 비밀번호를 정할 수
          있으며, 정해진 비밀번호는 회원이 원하는 경우 언제든지 변경이 가능합니다.
        </li>
        <li>
          ⑤ 회원은 서비스의 이용을 위하여 사용하는 비밀번호에 대한 보호 및 관리 책임을
          부담합니다. 다만, 회사는 보안 등을 이유로 회원에게 정기적 또는 비정기적으로
          비밀번호의 변경을 권고할 수 있습니다.
        </li>
      </ol>

      <h2>제9조 (회원에 대한 통지)</h2>
      <ol>
        <li>
          ① 회사가 회원에 대한 통지를 하는 경우 회원이 회원가입시 지정한 이메일 주소로
          할 수 있습니다.
        </li>
        <li>
          ② 회사는 회원 전체에 대한 통지의 경우 7일 이상 회사의 홈페이지 또는 공지사항
          게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.
        </li>
      </ol>

      <h2>제10조 (서비스의 제공시간 및 중지)</h2>
      <ol>
        <li>
          ① 회사는 회원의 회원가입을 승낙한 때부터 서비스를 개시합니다. 단, 일부
          서비스의 경우, 회사의 필요에 따라 지정된 일자부터 서비스를 제공할 수
          있습니다.
        </li>
        <li>
          ② 제1항 단서의 경우 회사는 그 내용 및 시간을 홈페이지에 공지합니다. 다만,
          회사가 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수
          있습니다.
        </li>
        <li>
          ③ 회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며,
          정기점검시간은 홈페이지에 공시한 바에 따릅니다.
        </li>
      </ol>

      <h2>제11조 (서비스의 내용 및 변경)</h2>
      <ol>
        <li>
          ① 이용자는 회사가 제공하는 서비스를 이 약관, 운영정책 등 회사가 정한 규칙에
          따라 이용할 수 있습니다.
        </li>
        <li>
          ② 회사가 이용자에게 제공하는 서비스에 대하여 회사는 제작, 변경, 유지, 보수에
          관한 포괄적인 권한을 가집니다.
        </li>
        <li>
          ③ 회사는 새로운 서비스 내용, 각종 버그 패치 등 서비스의 운영상 또는 기술상의
          필요한 경우, 제공하고 있는 서비스의 전부 또는 일부를 상시적으로 수정, 추가,
          폐지 등 변경할 수 있습니다.
        </li>
        <li>
          ④ 회사는 무료로 제공되는 서비스의 일부 또는 전부를 회사의 정책 기획이나
          운영상 또는 회사의 긴박한 상황 등 필요에 의해 수정, 중단, 변경할 수 있으며,
          이에 대하여 관련 법령상 특별한 규정이 없는 한 이용자에게 별도의 보상을 하지
          않습니다.
        </li>
        <li>
          ⑤ 회사는 다음 각호에 해당하는 경우 서비스의 전부 또는 일부를 제한하거나
          중지할 수 있습니다.
          <ol class="sub">
            <li>
              전시, 사변, 천재지변 또는 국가비상사태 등 불가항력적인 사유가 있는 경우
            </li>
            <li>
              정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 이용에
              지장이 있는 경우
            </li>
            <li>서비스용 설비의 보수 등 공사로 인한 부득이한 경우</li>
            <li>기타 회사의 제반 사정으로 서비스를 할 수 없는 경우</li>
          </ol>
        </li>
        <li>
          ⑥ 회사는 서비스가 변경되거나 중지된 원인이 회사의 고의 또는 중대한 과실로
          인한 경우를 제외하고는 서비스의 변경 및 중지로 발생하는 문제에 대해서 책임을
          부담하지 않습니다.
        </li>
      </ol>

      <h2>제12조 (정보의 제공 및 광고의 게재)</h2>
      <ol>
        <li>
          ① 회사는 이용자가 서비스 이용 중 필요하다고 인정되는 다양한 정보를 회사의
          홈페이지에 게시하거나 이메일 등을 이용하여 이용자에게 제공할 수 있습니다.
          다만, 이용자는 관련 법령에 따른 거래관련 정보, 고객센터 답변 등을 제외한
          정보의 전송에 대하여 언제든지 이메일 등을 통하여 수신거절의 의사표시를 할 수
          있습니다.
        </li>
        <li>
          ② 회사는 본 서비스 등을 유지하기 위하여 광고를 게재할 수 있으며, 이용자는
          서비스 이용 시 노출되는 광고게재에 대하여 동의합니다.
        </li>
        <li>
          ③ 회사가 제공하는, 제3자가 주체인, 제2항의 광고에 이용자가 참여하거나 교신
          또는 거래를 함으로써 발생하는 손실과 손해에 대해서 회사는 어떠한 책임도
          부담하지 않습니다.
        </li>
        <li>
          ④ 회사는 적법하게 수집한 이용자의 개인정보를 활용하여 제2항의 광고 등을
          메일주소 등을 활용하여 발송할 수 있으며, 이용자가 원하지 않는 경우에는
          언제든지 수신을 거부할 수 있습니다.
        </li>
      </ol>

      <h2>제13조 (권리의 귀속)</h2>
      <ol>
        <li>
          ① 서비스 및 서비스 내 회사가 제작한 콘텐츠 등에 대한 저작권 및 지적재산권은
          회사에 귀속됩니다.
        </li>
        <li>
          ② 이용자는 서비스를 이용함으로써 얻은 정보 중 회사에게 지적재산권이 귀속된
          정보를 회사의 사전 승낙 없이 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여
          영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.
        </li>
      </ol>

      <h2>제14조 (회원의 탈퇴)</h2>
      <ol>
        <li>
          ① 회원은 홈페이지에 개제된 회사 연락처에 연락하거나 서비스 내 탈퇴 기능을
          통해 탈퇴 신청을 할 수 있으며, 회사는 관련법령 등에서 정하는 바에 따라 이를
          즉시 처리하여야 합니다.
        </li>
        <li>
          ② 다음 각호에 해당하는 경우를 제외하고, 이용자의 모든 정보는 탈퇴 시점 이후
          바로 삭제되며 복구할 수 없습니다.
          <ol class="sub">
            <li>발급 완료된 문서 및 각종 정보</li>
            <li>
              관련법령 및 회사의 개인정보 처리방침에서 정한 바에 따라 특별히 이용자와
              관계된 정보를 저장해야할 때
            </li>
          </ol>
        </li>
        <li>③ 회원은 탈퇴 시점 이후 동일한 이메일 주소로 다시 가입할 수 없습니다.</li>
      </ol>

      <h2>제15조 (이용제한 등)</h2>
      <ol>
        <li>
          ① 회사는 회원이 다음 각 호의 사유에 해당하는 경우, 회원자격을 제한 및
          정지시킬 수 있습니다.
          <ol class="sub">
            <li>가입 신청 시에 허위 내용을 등록한 경우</li>
            <li>
              다른 사람의 서비스 이용을 방해하거나 그 정보를 도용하는 등 전자상거래
              질서를 위협하는 경우
            </li>
            <li>
              서비스 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우
            </li>
            <li>
              서비스를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는
              행위를 하는 경우
            </li>
          </ol>
        </li>
        <li>
          ② 회사가 제1항에 따라 회원 자격을 제한 및 정지시킨 후 동일한 행위가 2회 이상
          반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 회사는 회원자격을
          상실시킬 수 있습니다.
        </li>
        <li>
          ③ 회사는 전1,2항의 규정에도 불구하고, 주민등록법을 위반한 명의도용 및
          결제도용, 저작권법 및 컴퓨터프로그램보호법을 위반한 불법프로그램의 제공 및
          운영방해, 정보통신망 이용촉진 및 정보보호 등에 관한 법률을 위반한 불법통신
          및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법령을 위반한
          경우에는 즉시 계약을 해지 할 수 있습니다. 이에 따른 계약해지시 서비스 이용을
          통해 획득한 혜택 등은 모두 소멸되며, 회사는 이에 대해 별도로 보상하지
          않습니다.
        </li>
        <li>
          ④ 회사가 위 회원자격을 상실시키는 경우에는 회원 등록을 말소합니다. 이 경우
          회원에게 이를 통지하고, 회원등록 말소 전에 최소한 15일 기간을 정하여 소명할
          기회를 부여합니다.
        </li>
      </ol>

      <h2><제2장 서비스 이용 일반></h2>
      <h2>제16조(증서 발급 이용)</h2>
      <ol>
        <li>
          ① 발급기관이 증서 발급을 요청하는 시점에 발급 건당 이용권 1건이 차감됩니다.
        </li>
        <li>
          ② 발급기관의 증서 미발급, 발급 취소, 발급 거절발급 요청 취소 시 이용권은
          반환되지 않습니다.
        </li>
      </ol>

      <h2>제 17조 (회원의 게시물)</h2>
      <ol>
        <li>
          ① 회원이 서비스 이용 과정에서 등록 또는 게시한 증서 등 일체의 게시물 (이하
          게시물이라 함)에 대한 모든 책임은 회원에게 있으며, 회사는 회원의 게시물이
          다음 각 항에 해당한다고 판단되는 경우에 사전통지 없이 삭제할 수 있고, 이에
          대하여 회사는 어떠한 책임도 지지 않습니다.
          <ol class="sub">
            <li>타인을 모욕, 비방, 비하하거나 타인의 명예를 훼손하는 게시물</li>
            <li>범죄 및 불법 행위에 악용될 수 있는 정보를 담고 있는 게시물</li>
            <li>타인의 저작권, 상표권 등 권리를 침해하는 게시물</li>
            <li>
              음란물 또는 일반인의 성적 굴욕감이나 수치심을 유발할 수 있는 내용의
              게시물(그러한 내용이 담긴 웹사이트, 앱 등으로 연결될 수 있는 게시물을
              포함)
            </li>
            <li>
              어린이와 청소년의 정신적, 신체적 건강을 해칠 우려가 있는 선정적인 내용을
              담은 게시물
            </li>
            <li>특정인의 개인정보가 노출된 게시물</li>
            <li>
              특정 상품 등을 소개하여 판매하거나, 이를 구매, 사용하도록 권하거나
              연락을 유도하는 등 직간접적으로 영리추구를 위한 내용을 담고 있는 게시물
            </li>
            <li>
              서비스의 이용 목적에 부합하지 않거나 해당 서비스의 취지와 무관한 내용의
              게시물
            </li>
            <li>
              악성코드나 스파이웨어 등이 실행되어 다른 회원, 회사 기타 제3자의 시스템
              성능 저하, 개인정보 유출 등의 피해를 줄 수 있는 악의적인 코드를 담고
              있는 게시물
            </li>
            <li>정당한 사유 없이 회사의 영업을 방해하는 내용의 게시물</li>
            <li>
              기타 이 약관 또는 법령에 위배되거나 공서양속에 반하는 내용의 게시물
            </li>
          </ol>
        </li>
      </ol>

      <h2><제3장 유료서비스 이용></h2>
      <h2>제18조 (유료서비스 이용 계약)</h2>
      <ol>
        <li>
          ① 회사가 유료회원의 이용신청을 승낙한 때(일부 서비스의 경우, 이용 신청 접수
          후 사전 공지한 지정된 일자)로부터 유료서비스는 개시되며, 회사의 기술적 사유
          등 기타 사정에 의하여 유료서비스를 개시할 수 없는 경우에는 제9조의 방법에
          따라 회원에게 사전 공지합니다.
        </li>
        <li>
          ② 회사는 회원의 유료서비스 이용신청이 있게 되는 경우, 해당 회원에게
          이용신청의 내용을 통지합니다. 회사의 통지를 받은 회원은 의사표시의 불일치
          등이 있는 경우 회사에 정정 또는 수정을 요청하여야 하며, 회사는 회원의 요청에
          따라 처리하여야 합니다. 다만, 이미 대금을 지불한 경우에는 이 약관의 청약
          철회 등에 관한 규정에 따릅니다.
        </li>
        <li>
          ③ 회사는 회사의 사정, 기타 제반 여건에 따라 유료서비스 내용을 추가하거나
          변경할 수 있습니다.
        </li>
      </ol>

      <h2>제19조 (청약 철회 및 서비스 이용계약의 해제 • 해지)</h2>
      <ol>
        <li>
          ① 유료회원은 유료서비스 공급일 이후 제공되는 발급 이용 건을 사용하지 않았을
          경우 7일 이내에 회사에 결제 취소(청약 철회)를 요청할 수 있습니다.
        </li>
        <li>
          ② 유료회원이 유료서비스 공급일 이후 제공되는 발급 이용 건을 사용하지
          않았더라도 청약 철회가 가능한 기간(유료서비스 공급일로부터 7일 이내)을
          경과하여 청약 철회를 신청하면 환불은 불가능합니다.
        </li>
        <li>
          ③ 유료회원이 이미 결제한 서비스 이용 계약을 해제, 해지 했을 때, 남은 계약
          기간 동안 유료서비스를 이용할 수 있습니다.
        </li>
        <li>
          ④ 청약의 철회는 유료회원이 서비스 홈페이지를 통해 할 수 있으며, 회사에
          의사를 표시하여 회사에 도달될 때 그 효력이 발생하고, 회사는 유료회원의
          의사표시를 수령한 후 지체 없이 이러한 사실을 유료회원에게 회신합니다.
        </li>
        <li>
          ⑤ 회사는 유료회원이 청약 철회, 해지/해제 신청을 확인 후 환불 금액이 있을
          경우, 원칙적으로 유료회원의 해당 의사표시를 수령한 날로부터 3영업일 이내에
          결제수단 별 사업자에게 대금의 청구 정지 내지 취소를 요청하고, 유료회원이
          결제한 동일 결제수단으로 환불함을 원칙으로 합니다. 단, 회사가 사전에
          유료회원에게 전자메일, 서비스 홈페이지로 공지한 경우 및 아래의 각 호의
          경우와 같이 개별 결제 수단별 환불 방법, 환불 가능 기간 등이 차이가 있을 수
          있습니다.
          <ol class="sub">
            <li>
              신용카드 등 수납 확인이 필요한 결제수단의 경우에는 수납 확인일로부터
              3영업일 이내
            </li>
            <li>
              결제수단 별 사업자가 회사와의 약정을 통하여 사전에 대금 청구 정지 내지
              결제 취소 가능 기한 등을 미리 정하여 둔 경우로 해당 기한을 지난 환불의
              경우
            </li>
            <li>
              유료회원이 환불 처리에 필요한 정보 내지 자료를 회사에 즉시 제공하지 않는
              경우(현금 환불 시 신청인의 계좌 및 신분증 사본을 제출하지 아니하거나,
              타인 명의의 계좌를 제공하는 경우 등)
            </li>
            <li>해당 회원의 명시적 의사표시가 있는 경우</li>
          </ol>
        </li>
        <li>
          ⑥ 회사는 「콘텐츠산업 진흥법」제28조에 따라 제정된 「콘텐츠이용자보호지침」
          등에 따라, 회사가 부담하였거나 부담할 부대비용, 수수료를 차감하여 환불할 수
          있습니다.
        </li>
        <li>
          ⑦ 회원이 유료서비스를 선물 받거나, 프로모션 등을 통해 무상으로 취득하는 등
          회원이 직접 비용을 지불하지 아니하고 이용하는 유료서비스에 대하여 회사는
          회원에게 유료서비스 결제 대금을 환불할 의무를 부담하지 않습니다.
        </li>
        <li>
          ⑧ 회원이 이 약관에서 정하는 회원의 의무를 위반하였을 경우, 계약을 해제,
          해지하거나 서비스 이용 제한, 손해배상 청구 등의 조치를 취할 수 있으며, 계약
          해지 후 환불하여야 할 금액이 있을 경우에는 일정한 범위 내에서 회원이 부담할
          금액을 공제하고 환불합니다. 이 경우 회원은 해당 회사의 조치에 대하여 회사가
          정한 절차에 따라 이의 신청을 할 수 있으며, 회사는 정당하다고 확인하는 경우
          서비스 이용 재개 등을 할 수 있으며, 이용자가 자신의 고의, 과실이 없었음을
          입증한 경우 회사는 서비스를 정지한 기간만큼 이용 기간을 연장합니다.
        </li>
        <li>
          ⑨ 유료회원의 신청 또는 동의에 따라 월 정기결제 중인 유료서비스의 경우, 해당
          회원이 유료서비스의 이용요금을 체납하는 경우 연체가 발생한 날 회사로부터
          납입 요구 고지가 이루어진 이후에도 1주일 이내에 해당 회원이 납입하지 않는
          경우 회사에 의해 자동으로 이용권 해지가 될 수 있으므로, 유료서비스를
          유지하고자 하는 유료회원은 이용요금의 체납 또는 결제수단의 연체가 발생하지
          않도록 사전에 조치하여야 합니다.
        </li>
        <li>
          ⑩ 유료서비스를 이용 중인 유료회원이 탈퇴하는 경우 유료서비스는 즉시 해지되며
          환불은 불가능합니다. 이 경우 유료회원의 정보와 서비스이용내용은 관련 법령이
          정하는 경우를 제외하고는 약관 및 이 약관에 따라 처리됩니다.
        </li>
      </ol>

      <h2>제20조 (유료서비스 가액 변경)</h2>
      <p>
        회사는 운영상, 기술상의 필요에 따라 공급하는 유료서비스 가액을 변경할 수
        있으며, 제9조에서 정한 방법에 따라 유료회원에게 사전공지합니다.
      </p>

      <h2>제21조(과오금)</h2>
      <ol>
        <li>
          ① 회사는 유료서비스 결제와 관련하여 과오금이 발생한 경우 이용대금의 결제와
          동일한 방법으로 과오금 전액을 환불합니다. 다만, 동일한 방법으로 환불이
          불가능할 때는 이를 사전에 고지합니다.
        </li>
        <li>
          ② 회사의 귀책사유로 과오금이 발생한 경우 과오금 전액을 환불합니다. 단,
          회원의 귀책사유로 과오금이 발생한 경우, 회사가 과오금을 환불하는데 소요되는
          비용은 합리적인 범위 내에서 이용자가 부담하여야 하며, 회사는 해당 비용을
          차감 후 과오금을 환불할 수 있습니다.
        </li>
        <li>
          ③ 회사는 회원이 과오금을 주장하며 환불을 요구하는 경우, 정당하게 유료서비스
          요금이 부과되었음을 입증하면 환불을 거부할 수 있습니다.
        </li>
        <li>
          ④ 회사는 과오금의 세부 환불절차 및 기타 사항에 대하여 다음과 같이
          「콘텐츠이용자보호지침」이 정하는 바에 따릅니다.
          <ol class="sub">
            <li>
              회사나 회원이 과오금의 발생사실을 안 때에는 이메일, 서비스 홈페이지 등
              회사가 제시한 방법에 따라 상대방에게 통보
            </li>
            <li>
              회사는 회원에게 환불에 필요한 정보를 요청(회원 성명, 결제증빙서류,
              전화번호, 환불 요청 계좌 등)
            </li>
            <li>회원은 환불에 필요한 2호의 정보를 회사에 제공</li>
            <li>
              회사는 이용자의 정보 제공일로부터 7일 이내 환불 처리 (회원의 명시적
              의사표시가 있는 경우 차회 요금에서 상계)
            </li>
          </ol>
        </li>
      </ol>

      <h2><제4장 기타></h2>
      <h2>제22조 (최소 사용 환경)</h2>
      <ol>
        <li>
          ① 이용자는 아래 각 호에 해당하는 최소 사용 환경에서 서비스를 이용해야
          합니다.
          <ol class="sub">
            <li>운영체제 : Mac(Mavericks 이상), Windows7 이상</li>
            <li>
              브라우저 : Internet Explorer(11 이상), Edge(25.1 이상), Chrome(49 이상),
              Safari(9.0 이상) Opera(37 이상), Firefox(43.0 이상)
            </li>
            <li>쿠키 : 모든 쿠키 허용</li>
          </ol>
        </li>
        <li>
          ② 최소 사용 환경을 충족하지 못하는 환경에서 서비스를 이용할 경우, 이와
          발생하는 문제에 대해 회사는 책임지지 않습니다.
        </li>
      </ol>

      <h2>제23조 (회사의 의무)</h2>
      <ol>
        <li>
          ① 회사는 본 약관 및 관련법령에서 금지하는 행위 및 미풍양속에 반하는 행위를
          하지 않으며, 계속적이고 안정적인 서비스의 제공을 위하여 최선을 다하여
          노력합니다.
        </li>
        <li>
          ② 회사는 이용자가 안전하게 서비스를 이용할 수 있도록 신용정보를 포함한
          일체의 개인정보 보호를 위한 보안시스템을 갖추어야 하며 개인정보처리방침을
          공시하고 준수합니다.
        </li>
        <li>
          ③ 회사는 이용자로부터 제기되는 의견이나 불만이 정당하다고 객관적으로 인정될
          경우에는 합리적인 기간 내에 신속하게 처리하여야 합니다. 다만, 처리에
          장기간이 소요되는 경우 이용자에게 게시판 또는 이메일 등을 통하여 지체 사유를
          안내하고 처리과정 및 처리결과를 전달합니다.
        </li>
        <li>
          ④ 회사는 이용계약의 체결, 계약사항의 변경 및 해지 등 이용자와의 계약관련
          절차 및 내용 등에 있어 이용자에게 편의를 제공하도록 노력합니다.
        </li>
      </ol>

      <h2>제24조 (이용자의 의무)</h2>
      <ol>
        <li>
          ① 회원은 회사에서 제공하는 서비스를 본래의 이용 목적 이외의 용도로
          사용하거나 다음 각 호에 해당하는 행위를 해서는 안됩니다.
          <ol class="sub">
            <li>
              가입신청 또는 정보 변경을 목적으로 회사에 개인정보 등록시 실명이 아닌
              정보 또는 다른 사람의 정보를 사용하거나 허위 사실을 기재하는 행위
            </li>
            <li>
              타인으로 가장하거나 타인과의 관계를 허위로 명시하는 행위, 다른 회원의
              계정 및 비밀번호를 도용, 부정하게 사용하는 행위
            </li>
            <li>알려지거나 알려지지 않은 버그를 악용하여 서비스를 이용하는 행위</li>
            <li>
              회사 및 제3자의 명예를 훼손하거나 업무를 방해하거나 회사 및 제3자에게
              손해를 가하는 행위
            </li>
            <li>
              회사의 지적재산권, 제3자의 지적재산권, 초상권 등 기타 권리를 침해하거나
              회사의 승인을 받지 않고 다른 회원의 개인정보를 수집, 저장, 유포,
              게시하는 행위
            </li>
            <li>
              제3자를 기망하여 이득을 취하거나 회사가 제공하는 서비스를 불건전하게
              이용하거나 하여 제3자에게 피해를 주는 행위
            </li>
            <li>
              회사로부터 특별한 권리를 부여받지 않고 사이트를 변경하거나 사이트에 다른
              프로그램을 추가 또는 삽입하거나 서버를 해킹, 역설계, 소스코드의 유출 및
              변경, 별도의 서버를 구축하거나 웹사이트의 일부분을 임의로 변경 또는
              도용하여 회사를 사칭하는 행위
            </li>
            <li>
              회사의 직원이나 운영자를 가장, 사칭하거나 또는 타인의 명의를 도용하여
              문서를 등록하거나 메일을 발송하는 행위
            </li>
            <li>
              회사의 동의 없이 영리, 영업, 광고, 정치활동, 불법선거운동 등을 목적으로
              서비스를 이용하는 행위
            </li>
            <li>
              기타 공공질서 및 미풍양속을 위반하거나 불법적, 부당한 행위 및 법령에
              위배되는 행위
            </li>
          </ol>
        </li>
        <li>
        ② 이용자는 회사 홈페이지 상의 공지사항 및 이용약관의 수정사항 등을 확인하고
          이를 준수할 의무가 있으며 기타 회사의 업무에 방해되는 행위를 하여서는 안
          됩니다.
        </li>
        <li>
        ③ 이용자의 계정에 관한 관리 책임은 이용자에게 있으며, 이를 제3자가
        이용하도록 하여서는 안 됩니다. 회원은 자신의 계정이 도난당하거나
        제3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의
        안내가 있는 경우에는 그에 따라야 합니다.
        </li>
        <li>
        ④ 회사는 제1항, 제2항 및 다음 각 호의 어느 하나에 해당하는 행위의
        구체적인 유형을 운영 정책에서 정할 수 있으며, 이용자는 이를 준수할
        의무가 있습니다.
          <ol class="sub">
            <li>이용자의 계정명, 비밀번호의 정함에 대한 제한</li>
            <li>
              기타 이용자의 서비스 이용에 대한 본질적인 권리를 침해하지 않는 범위
              내에서 회사가 운영상 필요하다고 인정되는 사항
            </li>
          </ol>
        </li>
      </ol>

      <h2>제25조 (손해배상)</h2>
      <ol>
        <li>
          ① 회사가 제공하는 유료서비스의 하자 등에 의하여 이용자에게 피해가 발생한
          경우, 이용자에 대한 피해보상의 기준, 범위, 방법 및 절차에 관한 사항은
          디지털콘텐츠 이용자보호지침에 따릅니다.
        </li>
        <li>
          ② 이용자가 본 약관의 의무를 위반함으로 인하여 회사에 손해를 입힌 경우 또는
          이용자가 서비스의 이용과 관련하여 회사에 손해를 입힌 경우 이용자는 회사에
          대하여 손해를 배상하여야 합니다.
        </li>
        <li>
          ③ 이용자가 서비스를 이용함에 있어 행한 불법행위 또는 본 약관을 위반한 행위로
          회사가 당해 이용자 외의 제3자로부터 손해배상청구 또는 소송 등 각종
          이의제기를 받는 경우 당해 이용자는 자신의 책임과 비용으로 회사를 면책시켜야
          하며, 회사가 면책되지 못한 경우 당해 이용자는 그로 인하여 회사에 발생한 모든
          손해를 배상할 책임이 있습니다.
        </li>
      </ol>

      <h2>제26조 (책임의 한계)</h2>
      <ol>
        <li>
          ① 회사는 천재지변 또는 국가 정책 등 이에 준하는 불가항력으로 인하여 서비스를
          제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.
        </li>
        <li>
          ② 회사는 이용자의 귀책사유로 인한 서비스 중지 또는 이용의 장애,
          기간통신사업자가 전기통신서비스를 중지하거나 정상적으로 제공하지 아니하여
          이용자에게 손해가 발생한 경우에는 책임이 면제됩니다.
        </li>
        <li>
          ③ 회사는 이용자가 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성
          등의 내용에 관하여는 책임을 지지 않습니다.
        </li>
        <li>
          ④ 회사는 이용자 간 또는 이용자와 제3자 상호간에 서비스를 매개로 하여 거래
          등을 한 경우에는 책임이 면제됩니다.
        </li>
        <li>
          ⑤ 이용자는 무료로 제공되는 서비스 이용과 관련하여 관련법령에 특별한 규정이
          없는 한 책임을 지지 않습니다.
        </li>
      </ol>

      <h2>제 27조 (연결서비스와 피연결서비스간의 관계)</h2>
      <ol>
        <li>
          ① 회사의 서비스와 타 회사의 서비스가 하이퍼링크 방식 등으로 연결된 경우,
          전자를 연결서비스라 하고 후자를 피연결서비스라 합니다.
        </li>
        <li>
          ② 연결서비스는 피연결서비스가 독자적으로 제공하는 서비스에 의하여 회원과
          행하는 거래에 대해서 보증 책임을 지지 않습니다.
        </li>
      </ol>

      <h2>제28조 (준거법 및 재판관할)</h2>
      <ol>
        <li>① 회사와 이용자 간 제기된 소송은 대한민국법을 준거법으로 합니다.</li>
        <li>
          ② 회사와 이용자 간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에
          제소합니다.
        </li>
      </ol>
      <h1 id="privacy-policy">broof 개인정보 수집 및 이용 동의</h1>

      <p>파라메타(이하 ‘회사’)는 개인정보를 아래와 같이 수집 및 이용합니다.</p>

      <table>
        <tbody>
          <tr>
            <td style="width: 22%;"><strong>목적</strong></td>
            <td style="width: 56%"><strong>수집 항목</strong></td>
            <td style="width: 22%"><strong>보유 기간</strong></td>
          </tr>
          <tr>
            <td rowspan="2" style="width: 22%;"><strong>증명서 조회에 필요한 본인확인</strong><br/> *기존 broof 개인회원 또는 기관에서 발급받은 증서가 있는 경우</td>
            <td rowspan="2" style="width: 56%;">이메일주소</td>
            <td rowspan="2" style="width: 22%;">본인확인 후 즉시 파기</td>
          </tr>
          
        </tbody>
      </table>

      <ol>
        <li>* 증명서 종류에 따라 수집하는 내용이 상이할 수 있습니다.</li>
        <li>* 수령자(개인)의 경우, 각 기관에서 발급받은 본인의 인증서 및 개인정보를 자체 관리할 수 있습니다.</li>
        <li>* 서비스 제공을 위한 최소한의 개인정보이므로 동의를 해주셔야 서비스 이용이 가능합니다.</li>
      </ol>

      <br />
    `,
   },
   {
      title: "개인정보 처리방침",
      desc: `
  <h1>개인정보 처리방침</h1>
  <div class="divider"></div>
  <ol class="sub">
    <li>개인정보 처리 목적 및 보유기간</li>
    <li>개인정보 제3자 제공에 관한 사항</li>
    <li>개인정보 위탁</li>
    <li>개인정보 파기</li>
    <li>개인정보의 안전성 확보조치에 관한 사항</li>
    <li>개인정보 자동 수집 장치의 설치 및 운영 및 그 거부에 관한 사항</li>
    <li>개인정보 보호업무 및 관련 고충 문의</li>
    <li>권익침해 구제방법</li>
    <li>개인정보 처리방침 변경에 관한 사항</li>
  </ol>
  <p>
    본 개인정보처리방침은 파라메타(이하 ‘회사’)의 웹사이트, 모바일 앱 등에서
    처리되는 정보에 대해 설명합니다. 회사는 ‘이용자의 동의’를 기반으로 개인정보를
    처리하고 있으며 관련 국내/외 법령 및 기타 개인정보보호 관련 가이드라인을
    준수하고 있습니다.
  </p>
  <div class="divider"></div>
  <h2>1. 개인정보 처리 목적 및 보유기간</h2>
  <table>
    <tbody>
      <tr>
        <td style="width: 25%">서비스</td>
        <td style="width: 25%">수집·이용 목적</td>
        <td style="width: 25%">수집·이용 항목</td>
        <td style="width: 25%">보유 기간</td>
      </tr>
      <tr>
        <td style="width: 25%">쯩 온보딩 시</td>
        <td style="width: 25%">만 14세 미만 및 법정대리인 여부 확인</td>
        <td style="width: 25%">(필수) 본인 정보(이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인), 법정대리인 정보(보호자 이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인)</td>
        <td style="width: 25%">만 14세 미만 및 법정대리인 여부 확인 후 즉시 파기하며, 정보를 저장하지 않음</td>
      </tr>
      <tr>
        <td style="width: 25%">휴대폰 본인확인</td>
        <td style="width: 25%">휴대폰 본인확인</td>
        <td style="width: 25%">(필수) 이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인, 주민등록번호</td>
        <td style="width: 25%">통신사 중계업체에 제공하며, 정보를 저장하지 않음</td>
      </tr>
        <td rowspan="2" style="width: 25%">운전면허인증</td>
        <td style="width: 25%">운전면허증 위·변조 판별</td>
        <td style="width: 25%">(필수) 운전면허증 OCR 정보 (이름, 생년월일, 운전면허번호, 운전면허 일련번호)</td>
        <td style="width: 25%">운전면허증 위·변조 판별 후 즉시 파기</td>
      </tr>
      <tr>
        <td style="width: 25%">중복 가입 식별</td>
        <td style="width: 25%">(필수) 개인식별자 (CI를 가공한 값)</td>
        <td style="width: 25%">서비스 탈퇴 시 까지</td>
      </tr>
    </tbody>
  </table>
  <p>
  서비스 제공 시 앱에서 아래와 같은 접근권한을 요구합니다. 
  </p>
  <table>
    <tbody>
      <tr>
        <td style="width: 25%">앱 접근권한</td>
        <td style="width: 25%">이용근거</td>
        <td style="width: 25%">이용목적</td>
        <td style="width: 25%">이용기간</td>
      </tr>
      <tr>
        <td style="width: 25%">CAMERA (필수)</td>
        <td style="width: 25%">정보주체의 동의</td>
        <td style="width: 25%">QR코드 촬영, 신분증 촬영</td>
        <td style="width: 25%">앱 실행 시</td>
      </tr>
    </tbody>
  </table>
  <p>
    <strong>개인정보를 수집하는 방법은 다음과 같습니다.</strong> <br />
    회사는 개인정보 수집 시 반드시 이용자에게 해당 사실을 알리고 동의를 구하고
    있으며, 아래와 같은 방법으로 수집합니다.
  </p>
  <ol>
    <li>
      - 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고
      직접 정보를 입력하는 경우
    </li>
    <li>- 제휴 서비스 또는 단체 등으로부터 개인정보를 제공받은 경우</li>
    <li>
      - 고객센터를 통한 상담 과정에서 웹페이지, 메일, 전화 등으로 이용자가 직접
      제공하는 경우
    </li>
    <li>- 온·오프라인에서 진행되는 이벤트/행사 등 참여</li>
  </ol>

  <p>
    <strong
      >서비스 이용 과정에서 자동 생성된 정보를 이용자로부터 수집할 수
      있습니다.</strong
    ><br />
    PC웹, 모바일 웹 이용 과정에서 단말기정보(OS, 화면사이즈, 디바이스 아이디),
    IP주소, 쿠키, 방문일시, 부정이용기록, 서비스 이용 기록 등의 정보가 자동으로
    생성되어 수집될 수 있습니다.
  </p>
  <p>
    <strong
      >수집한 개인정보는 회사의 서비스 제공 등 이용자가 요청한 목적을 위해
      이용합니다.</strong
    ><br />
    회사는 개인정보 보호 관련 법령 및 GDPR 등 각 회원국의 법률을 준수를 위하여
    필요한 최소한의 목적으로 이용자의 정보를 이용합니다. 이용자의 회원가입 및
    서비스 이용 과정에서 수집한 정보를 아래와 같은 서비스를 제공하기 위해
    이용합니다.
  </p>
  <ol>
    <li>- 회원 식별/가입의사 확인, 부정이용 방지</li>
    <li>- 신규 서비스 개발, 다양한 서비스 제공, 문의사항 또는 불만처리</li>
    <li>
      - 서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시 보호
      측면의 서비스 환경 구축, 맞춤형 서비스, 서비스 개선에 활용
    </li>
    <li>- 준거법 또는 법적 의무의 준수</li>
    <li>
      - 공익적 직무의 실행을 위하여 처리가 필요한 경우 또는 회사에게 부여된 공적
      권한의 행사에 처리가 필요한 경우
    </li>
    <li>
      - 회사나 제3자가 추구하는 정당한 이익 목적을 위하여 처리가 필요한 경우
      (다만, 특히 이용자가 아동인 경우와 같이 개인정보 보호를 요구하는 이용자의
      이익이나 기본권과 자유가 해당 이익에 우선하는 경우에는 그러하지 아니함)
    </li>
  </ol>

  <h2>2. 개인정보 제3자 제공에 관한 사항</h2>

  <p>
    <strong>이용자의 별도 동의가 있는 경우나 법령에 규정된 경우를 제외하고는 이용자의 개인정보를 제3자에게 제공하지 않습니다.</strong>
  </p>
  
  <h2>3. 개인정보 위탁</h2>
  <p>
    <strong
      >회사는 편리하고 더 나은 서비스를 제공하기 위해 업무 중 일부를 외부에
      위탁하고 있습니다. </strong
    ><br />
    서비스 향상을 위해서 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될
    수 있도록 필요한 사항을 규정하고 있습니다.<br />
    회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.
  </p>
  <table>
    <tbody>
      <tr>
        <td style="width: 30%">위탁받는 자</td>
        <td style="width: 40%">위탁하는 업무의 내용</td>
        <td style="width: 30%">보유 기간</td>
      </tr>
      <tr>
        <td style="width: 30%">다날</td>
        <td style="width: 40%">휴대폰 본인확인 서비스</td>
        <td style="width: 30%">위탁 계약 종료 시 까지</td>
      </tr>
      <tr>
        <td style="width: 30%">(주)쿠프마케팅</td>
        <td style="width: 40%">이벤트 운영, 교환권 발송 및 기타 고객 상담</td>
        <td style="width: 30%">위탁 계약 종료 시 까지</td>
      </tr>
      <tr>
        <td style="width: 30%">코드에프</td>
        <td style="width: 40%">운전면허인증 위변조 판별</td>
        <td style="width: 30%">운전면허증 위·변조 판별 후 즉시 파기</td>
      </tr>
    </tbody>
  </table>

  <h2>4. 개인정보 파기</h2>

  <p>
    <strong
      >개인정보는 수집 및 이용목적이 달성되면 별도의 동의 및 법령근거가 없는 경우
      지체없이 파기합니다.</strong
    ><br />
    회사는 수집 및 이용 목적이 달성된 개인정보(회원 탈퇴, 서비스 종료 등)는 아래의
    방법에 따라 지체없이 파기합니다.
  </p>
  <ol>
    <li>- 전자적 파일 : 복구 및 재생되지 않도록 안전하게 삭제</li>
    <li>- 그 밖에 기록물, 인쇄물, 서면 등 : 분쇄하거나 소각</li>
  </ol>


  <h2>5. 개인정보의 안전성 확보조치에 관한 사항</h2>
  <p>
    <strong
      >이용자의 개인정보를 안전하게 보호하기 위해 필요한 조치를 운영하고
      있습니다.</strong
    >
    <br />회사는 이용자의 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록
    안전성 확보를 위하여 다음과 같은 기술적, 관리적, 물리적 조치를 운영하고
    있습니다
  </p>
  <table>
    <tbody>
      <tr>
        <td style="width: 25%">항목</td>
        <td style="width: 75%">내용</td>
      </tr>
      <tr>
        <td style="width: 25%">기술적 조치</td>
        <td style="width: 75%">
          <ol>
            <li>- 개인정보 암호화 조치</li>
            <li>- 백신 소프트웨어 등 설치 및 운영</li>
            <li>- 접근통제시스템 설치 및 운영</li>
            <li>- 개인정보처리시스템에 대한 접근기록의 보관 등</li>
            <li>- 개인정보처리시스템에 대한 접근권한 차별화</li>
          </ol>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">관리적 조치</td>
        <td style="width: 75%">
          <ol>
            <li>- 개인정보보호 조직 구성</li>
            <li>- 내부관리계획의 수립 및 시행</li>
            <li>- 개인정보처리자의 정기 교육 및 점검</li>
            <li>- 수탁사의 개인정보 처리 업무 관리 감독</li>
          </ol>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">물리적 조치</td>
        <td style="width: 75%">
          <ol>
            <li>- 개인정보를 보관 시설에 대한 출입통제 절차 수립 및 운영</li>
            <li>
            - 개인정보가 포함된 서류나 보조기억매체 등은 잠금장치가 부착되어 있는
              안전한 장소에 보관
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
  <h2>6. 개인정보 자동 수집 장치의 설치 및 운영 및 그 거부에 관한 사항</h2>
  <p>
    <strong>이용자에게 편의 제공을 위하여 쿠키 정보를 이용할 수 있습니다.</strong>
    <br />
    쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 작은
    텍스트 파일로 이용자 컴퓨터에 자동 저장됩니다.
  </p>
  <ol>
    <li>
      | 쿠키 사용 목적 <br />
      이용자가 웹사이트를 이용하는 경우 웹 사이트 서버는
      이용자의 디바이스에 저장된 쿠키를 사용하게 됩니다. 회사는 웹 분석 Tool 등을
      통해 쿠키를 활용하여 이용자의 웹사이트 방문 기록, 이용 형태 등을 파악하고
      이용자에 맞는 맞춤형 광고 정보 제공 및 서비스 개선을 수행하고 있습니다. 쿠키
      정보는 이용자의 디바이스 식별용도로만 활용되며 개개인을 식별하지 않습니다.
    </li>
    <li>
      | 쿠키 수집 거부 <br />
      이용자는 웹 브라우저에서 아래와 같이 옵션을 설정함으로써
      쿠키 정보의 저장을 제한할 수 있습니다. 단, 쿠키 정보의 저장을 거부하면
      로그인 정보 저장 및 맞춤형 광고 차단 등 일부 서비스의 이용이 어려울 수
      있습니다. <br />
      1) Internet Explorer <br />
      &nbsp&nbsp&nbsp 웹 브라우저 상단의 도구 메뉴 > 인터넷 옵션 > 개인정보
      > 설정 <br />
      2) Chrome <br />
      &nbsp&nbsp&nbsp 웹 브라우저 우측의 설정 메뉴 > 화면 하단의 고급 설정 표시 >
      개인정보의 콘텐츠 설정 버튼 > 쿠키 <br /><br />
      모바일 앱의 경우 아래의 방법을 통해 맞춤형 광고 설정을 해제할 수 있습니다.
      <br />
      1) Android <br />
      &nbsp&nbsp&nbsp 설정 > Google 설정 > 광고 > ‘광고 맞춤설정 선택 해제’ 활성화
      <br />
      2) IOS<br />
      &nbsp&nbsp&nbsp 설정 > 개인정보보호 > 광고 > ‘광고 추적 제한’ 활성화
    </li>
  </ol>

  <h2>7. 개인정보 보호업무 및 관련 고충 문의</h2>
  <p>
    <strong
      >이용자의 권리를 보호하기 위해 적극적으로 필요한 조치를 운영하고
      있습니다.</strong
    ><br />
    이용자는 언제든지 자신의 개인정보를 조회하거나 수정, 이동, 삭제 등이
    가능합니다. 또, 원하는 때에 동의 철회 또는 가입 해지를 요청할 수도 있습니다.
  </p>

  <p>
    <strong
      >개인정보보호와 관련해서 궁금하신 사항이 있으시면 언제든 문의 주시기
      바랍니다.</strong
    ><br />
    서비스를 이용하면서 발생하는 모든 개인정보보호 관련 문의, 불만, 조언이나 기타
    사항은 개인정보 보호책임자 및 담당부서로 연락해 주시기 바랍니다.
  </p>
  <ol>
    <li>
      | 개인정보보호 책임자(CPO, DPO) 및 담당부서<br />
      책임자: 천경민<br />
      담당부서: 정보보호팀<br />
      문의: privacy@iconloop.com <br />
    </li>
  </ol>

  <h2>8. 권익침해 구제방법</h2>
  <p>
    <strong
      >개인정보가 침해되어 이에 대한 신고나 전문적인 상담이 필요하신 경우에는 아래
      기관에 문의하셔서 도움을 받으실 수 있습니다.</strong
    >
  </p>

  <ol>
    <li>
    | 개인정보침해 신고센터<br />
      (국번없이)118<br />
      https://privacy.kisa.or.kr<br />
    </li>
    <li>
    | 개인정보 분쟁조정위원회<br />
      1833-6972<br />
      https://www.kopico.go.kr<br />
    </li>
    <li>
    | 대검찰청 사이버수사과<br />
      (국번없이)1301<br />
      cid@spo.go.kr
    </li>
    <li>
    | 경찰청 사이버안전국 <br />
      (국번없이)182<br />
      https://cyberbureau.police.go.kr
    </li>
  </ol>

  <h2>9. 개인정보 처리방침 변경에 관한 사항</h2>
  <p>
    <strong>개인정보 처리방침이 변경되는 경우에 홈페이지에 게시됩니다.</strong
    ><br />
    법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인정보 처리방침이
    변경되는 경우, 회사는 변경내용을 홈페이지에 게시하여 이용자가 언제든 확인할 수
    있도록 하겠습니다.
  </p>
  <ol>
    <li>| 공고일자: 2022년 06월 08일</li>
    <li>| 시행일자: 2022년 06월 15일</li>
    <li><div style="margin-top : 20px; display : flex; justify-content : space-between; align-items : center; width : 300px; padding : 8px; border : 1px solid rgb(138, 138, 138);" onClick={window.location.href="${window.location.origin}${window.location.pathname}#/prev"}>변경 전 개인정보 처리방침 보기<div>></div></div></li>
  </ol>
  `,
   },
   {
      title: "개인정보 처리방침",
      desc: privacyPolicy,
   },
];

export function tosDataHandler(tosIndex: number, version: number) {
   const v10601 = [tosData[0], tosData[1], tosData[3]];
   const v10602 = [tosData[0], tosData[1], tosData[2]];

   return version >= 10602 ? v10602[tosIndex] : v10601[tosIndex];
}

export const agrTosData: Data[] = [
   {
      title: "‘쯩 for 공공기관’ 서비스 이용약관",
      desc: `
      <h1>‘쯩 for 공공기관’ 서비스 이용약관</h1>
       <html>

<head>
<meta http-equiv=Content-Type content="text/html; charset=utf-8">
<meta name=Generator content="Microsoft Word 15 (filtered)">
<style>
<!--
 /* Font Definitions */
 @font-face
	{font-family:"Cambria Math";
	panose-1:2 4 5 3 5 4 6 3 2 4;}
@font-face
	{font-family:"Malgun Gothic";
	panose-1:2 11 5 3 2 0 0 2 0 4;}
@font-face
	{font-family:"IBM Plex Sans KR";}
@font-face
	{font-family:"\@Malgun Gothic";}
 /* Style Definitions */
 p.MsoNormal, li.MsoNormal, div.MsoNormal
	{margin:0cm;
	line-height:115%;
	font-size:11.0pt;
	font-family:"Arial",sans-serif;}
.MsoChpDefault
	{font-size:11.0pt;
	font-family:"Malgun Gothic",sans-serif;}
.MsoPapDefault
	{line-height:115%;}
@page WordSection1
	{size:595.45pt 841.7pt;
	margin:72.0pt 72.0pt 72.0pt 72.0pt;}
div.WordSection1
	{page:WordSection1;}
 /* List Definitions */
 ol
	{margin-bottom:0cm;}
ul
	{margin-bottom:0cm;}
-->
</style>

</head>

<body lang=en-KR style='word-wrap:break-word'>

<div class=WordSection1>


<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제1조 (목적)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>본 약관은 주식회사 파라메타(이하 ‘회사’라 한다)가 제공하는 &quot;쯩 for 공공기관&quot; 서비스 이용과 관련하여
회사, 발급기관, 이용기관, 사용자 간의 권리, 의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제2조 (용어의 정의)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.</span></p>

<ol style='margin-top:0cm' start=1 type=1>
 <li class=MsoNormal style='margin-top:19.0pt;text-align:justify;text-justify:
     inter-ideograph;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>쯩 for 공공기관: 개인의 신원, 자격, 경력 등 개인의 속성과 관련된 정보(이하 '신원 등'이라 한다)에 대한
     인증을 거쳐  발급된 크레덴셜 등을 사용자가 제어할 수 있는 개인 저장공간에 안전하게 저장, 관리 및 제출할 수 있는 기능을 제공하는
     블록체인 기반의 신원증명 모바일 애플리케이션을 말합니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>쯩 for 공공기관 서비스:  쯩 for 공공기관 애플리케이션에서 제공되는 모든 서비스에 대한 총칭입니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>DID(Decentralized ID): 쯩 for 공공기관 서비스의 각 주체 (발급기관, 이용기관, 사용자)
     가 블록체인 상에서 생성한  고유한 식별값입니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>지갑 개인키: 지갑 소유자가 전자서명을 하기 위해 사용하는 키. 개인 키와 쌍을 이루는 공개 키는 블록체인에 공개되어
     누구나 메세지의 위변조를 검증할 수 있습니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>DID 개인키: DID 소유자가 전자서명을 하기 위해 사용하는 키. 개인 키와 쌍을 이루는 공개 키는 블록체인에
     공개되어 누구나 메세지의 위변조를 검증할 수 있습니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>크레덴셜(Credential): 사용자의 신원 등에 대한 데이터가 발급기관의 인증 또는 사용자의 자기증명을 거친
     후 발급자의 개인키로 서명되어 발급된 DID 기반의 인증서.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>발급기관:  사용자의 요청에 따라 신원 등을 인증하고 개인키로 서명하여 크레덴셜을 발급하는 주체.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>이용기관: 서비스 제공 등의 목적으로 사용자로부터 크레덴셜을 제출받아 크레덴셜 위변조 및 제출자 소유의 크레덴셜
     여부를 검증하는 주체.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>사용자: 본 약관에 따라 회사가 제공하는 쯩 for 공공기관 서비스를 이용하는 주체.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>사용자 저장 데이터: 사용자가 쯩 for 공공기관 서비스를 이용하기 위한 목적으로 생성한 개인 데이터로서<b>
     </b>지갑 개인키, DID, DID 개인키, 쯩 for 공공기관 서비스를 통해 발급받은 크레덴셜, 크레덴셜 안의 개인 신원 정보 등을
     포함합니다.</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>블록체인 저장 데이터: 제출된 크레덴셜의 검증을 목적으로 블록체인에 기록되는 데이터를 의미하며 DID, DID
     공개 키, 크레덴셜 상태값 등을 포함합니다(사용자의 신원 등에 관한 개인 정보는 블록체인 기록 대상이 아닙니다).</span></li>
 <li class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
     background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
     color:black'>개인저장공간 (Personal Data Storage): 사용자 본인과 권한을 부여받은 사람만 읽고 쓸 수 있는
     개인키로 암호화된 클라우드 저장공간.</span></li>
</ol>

<p class=MsoNormal style='margin-top:19.0pt;margin-right:0cm;margin-bottom:
19.0pt;margin-left:0cm;background:white'><b><span lang=KO style='font-family:
"IBM Plex Sans KR";color:#333333'>제3조 (회사정보 등의 제공)<br>
</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";color:#333333'>회사는
다음 각 호의 사항을 사용자가 알아보기 쉽도록 서비스 내에 표시합니다. <br>
다만, 이용약관은 사용자가 연결 화면을 통하여 볼 수 있도록 할 수 있습니다.</span></p>

<ol style='margin-top:0cm' start=1 type=1>
 <li class=MsoNormal style='margin-top:19.0pt;background:white'><span lang=KO
     style='font-family:"IBM Plex Sans KR";color:#333333'>상호 및 대표자의 성명</span></li>
 <li class=MsoNormal style='background:white'><span lang=KO style='font-family:
     "IBM Plex Sans KR";color:#333333'>본사 주소지 주소</span></li>
 <li class=MsoNormal style='background:white'><span lang=KO style='font-family:
     "IBM Plex Sans KR";color:#333333'>전화번호, 이메일 주소</span></li>
 <li class=MsoNormal style='background:white'><span lang=KO style='font-family:
     "IBM Plex Sans KR";color:#333333'>사업자등록번호</span></li>
 <li class=MsoNormal style='background:white'><span lang=KO style='font-family:
     "IBM Plex Sans KR";color:#333333'>서비스 이용약관</span></li>
 <li class=MsoNormal style='margin-bottom:19.0pt;background:white'><span
     lang=KO style='font-family:"IBM Plex Sans KR";color:#333333'>개인정보 처리방침</span></li>
</ol>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제4조 (약관의 효력 및 변경)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>①  회사는 본 약관의 내용을 사용자가 알 수 있도록 쯩 for 공공기관 서비스 내 또는 별도의 연결화면에 게시합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>②  회사는 ‘약관의 규제에 관한 법률’ ‘정보통신망이용촉진 및 정보보호 등에 관한 법률’ 등 관련 법령을 위배하지 않는
범위에서 본 약관을 개정할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③  회사가 본 약관을 개정할 경우에는 적용일자 및 개정 내용, 개정 사유 등을 명시하여 제1항의 방식에 따라 그 개정
약관을 <span style='background:white'>적용일 7일 </span>이전부터 공지합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>④  회사는 전항에 따라 개정약관을 공지하면서 사용자가 개정약관에 대해 동의 또는 거부의 의사표시를 하지 않으면 동의한
것으로 볼 수 있다는 내용도 함께 공지를 하며, 사용자가 개정약관 시행일까지 거부의 의사표시를 하지 않는다면 개정약관에 동의한 것으로 볼 수 있습니다.
사용자가 개정약관에 대해 동의하지 않는 경우 회사 또는 사용자는 서비스 이용계약을 해지할 수 있습니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>  </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제5조 (쯩 for 공공기관 서비스 이용 절차) </span></b></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>①  <span style='background:white'>회사는
사용자가 되고자 하는 자가 본 약관 및 이용하고자 하는 쯩 for 공공기관 서비스의 종류에 따라 개별 약관이 존재하는 경우 그 개별 약관에 동의하고
본인확인을 거쳐 PIN 또는 생체인식 정보 등록을 마친 후, 쯩 for 공공기관 서비스의 이용을 승낙함으로써 쯩 for 공공기관 서비스 이용계약을
체결하는 것을 원칙으로 합니다.  </span></span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>②  <span style='background:white'>사용자는
쯩 for 공공기관 서비스 이용에 필요한 정보를 회사 또는 발급기관 또는 이용기관에 제공함으로써 쯩 for 공공기관 서비스를 이용할 수 있습니다.
</span></span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>③  <span style='background:white'>쯩
for 공공기관 서비스 이용에 필요한 정보는 서비스 내용 변경, 회사나 발급기관 또는 이용기관의 정책 변경 및 관련 법령에 따라 달라질 수 있습니다.</span></span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>④  사용자가 제1항이나 제2항에서 요청하는 정보를 사실대로
정확하게 제공하지 않은 경우 사전적 또는 사후적으로 서비스 이용에 제한을 받을 수 있습니다.</span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>⑤  타인의 명의나 정보를 도용하여 이용신청을 한 사용자는
사전적 또는 사후적으로 회사가 제공하는 서비스 전체 또는 일부가 제한될 수 있으며 관계법령에 따라 처벌을 받을 수 있습니다.</span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>⑥  회사는 사용자가 본 조의 절차에 위반하여 이용신청을 한
경우 이로 인해 발생한 피해에 대하여 책임을 지지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:54.0pt;text-indent:-18.0pt'><span
lang=KO style='font-family:"IBM Plex Sans KR"'>⑦  회사는 사용자의 신청에 대하여 승낙함을 원칙으로 합니다.
다만, 회사는 다음 각 호의 어느 하나에 해당하는 이용 신청에 대해서는 승낙을 거절할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-top:19.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:72.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
조의 절차에 위반하여 이용신청을 한 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>기재
내용에 허위, 기재누락, 오기 등이 있거나 이용신청 요건을 충족하지 못한 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>회사가
서비스를 제공하지 않은 국가에서 비정상적이거나 우회적인 방법을 통해 서비스를 이용하는 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>4.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>사회의
안녕과 질서 또는 미풍양속을 저해할 목적으로 신청한 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>5.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
약관에 위배되거나 위법 또는 부당한 목적의 이용신청임이 확인된 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>6.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>영리를
추구할 목적으로 쯩 for 공공기관 서비스를 이용하고자 하는 경우</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:19.0pt;
margin-left:72.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:
-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>7.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
lang=KO style='font-family:"IBM Plex Sans KR";color:black'>그 밖에 각 호에 준하는 사유로서 승낙이
부적절하다고 판단되는 경우</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>        <span style='background:white'>⑧</span> 회사는 다음 각 호의 어느 하나에
해당하는 경우 그 사유가 해소될 때까지 승낙을 유보할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:72.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>회사의
설비에 여유가 없거나, 특정 모바일 기기의 지원이 어렵거나, 기술적 장애가 발생한  경우</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:10.0pt;
margin-left:72.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:
-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>2.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
lang=KO style='font-family:"IBM Plex Sans KR";color:black'>그 밖의 각 호에 준하는 사유로서 이용신청의
승낙이 어렵다고 판단되는 경우</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>          </span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black;background:white'>⑨</span><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> 회사는 일부 서비스 이용에 대해서 사용자에게 수수료를 부과할 수 있습니다. 회사는 건당 과금, 무료이용 조건 설정, 월
이용료 등 수수료 정책을 사전에 앱과 홈페이지를  통해 고지하고 시행합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제6조 (개인정보의 보호 및 사용)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>① 회사는 관련 법령이 정하는 바에 따라 사용자의 개인정보를 보호하기 위해 노력하며, 개인정보의 보호 및 사용에 대해서는
관련 법령에 따릅니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>② 사용자 저장 데이터는 사용자 동의 하에  쯩 for 공공기관 서비스 내에 저장됩니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③ 쯩 for 공공기관 사용자가 크레덴셜을 받기 위해 발급기관에 직접 제출하는 개인정보의 수집 및 보관에 대한 책임은 발급기관에
있으며 회사는 이에 대한 일체의 책임을 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>④ 쯩 for 공공기관 사용자가 검증 받기 위해 이용기관에 직접 제출하는 크레덴셜 및 개인정보의 수집, 보관 및 활용에
대한 책임은 이용기관에 있으며 회사는 이에 대한 일체의 책임을 부담하지 않습니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>⑤ 회사는 사용자의 귀책사유로 사용자 저장 데이터 및 개인정보가 유출되어 발생한 피해에 대하여 책임을 지지 않습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제7조  (자기주권형 개인정보 관리) </span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>① 쯩 for 공공기관 서비스는 정보 주체인 사용자가 크레덴셜와 크레덴셜에 담긴 신원 등에 관한 개인정보를 사용자 저장
데이터 형태로 본인이 제어할 수 있는  개인 저장공간에 직접 저장, 관리, 제출하는 자기주권형 신원증명 서비스입니다. 사용자는 사용자 저장 데이터의
안전한 보관 및 관리에 대한 책임이 있으며 제3자에게 데이터가 유출되거나 도용되지 않도록 할 책임이 있습니다. 사용자의 고의 또는 과실로 사용자
저장 데이터가 유출 또는 도용되어 발생한 책임에 대해 회사는 책임을 부담하지 않습니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>② 사용자 모바일 기기의 바이러스 감염,<span style='background:white'> 해킹, </span>비밀번호
유출 또는 생체인식 오류 등 각종 원인으로 사용자가 사용자 저장 데이터를 이용할 수 없게 되거나 제3자에게 노출된 경우 회사는 이에 대한 일체의
책임을 부담하지 않습니다. 단, 회사의 고의 또는 중과실의 경우에는 그렇지 아니합니다.  </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③ <span style='background:white'> 사용자는 블록체인 저장 데이터에 대한 소유권, 이동권, 삭제권
등의 권리를 주장할 수 없습니다.</span></span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제8조 (회사의 의무)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>①  회사는 관련 법령 및 본 약관에서 정하는 권리의 행사 및 의무의 이행을 신의에 따라 성실하게 준수합니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>②  회사는 사용자가 안전하게 쯩 for 공공기관 서비스를 이용할 수 있도록 개인정보(사용자 저장 데이터 포함)보호를 위해
필요한 보안시스템을 갖추어야 합니다. 회사는 사용자의 개인정보가 사용자의 동의없이 제 3자에게 제공되지 않도록 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③ 회사는 계속적이고 안정적인 쯩 for 공공기관 서비스의 제공을 위하여 최선을 다하여 노력합니다. 서비스 또는 설비에
장애가 생겼을 경우 천재지변, 비상사태, 현재의 기술로는 해결이 불가능한 장애나 결함 등 부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구하도록
최선의 노력을  다합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>④ 회사는 쯩 for 공공기관 서비스 이용과 관련하여 사용자가 장애나 개선사항에 대해 회사에 전달할 수 있는 방법을 서비스
내에 고지합니다. </span></p>

<p class=MsoNormal style='margin-left:18.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제9조 (사용자의 의무)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>①</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> 사용자는 본 약관 및 개정약관, 회사가 쯩 for 공공기관 서비스 화면에서 고지하는 내용을 확인하고 준수하여야 하며,
본 약관, 개정약관 및 고지 내용을 위반하거나 이행하지 아니하여 발생하는 손실 및 손해에 대하여 책임을 부담합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>②</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>  사용자는 쯩 for 공공기관 서비스 내에서 발급기관 또는 이용기관이 제공하는 상품 등을 가입 또는 구매 시 스스로의
책임 하에 가입 또는 구매하여야 하며, 회사는 상품 등의 내용과 거래 조건에 대해서 어떠한 보증이나 책임도 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>  사용자는 자신의 명의가 도용되거나 제3자에게 부정하게 사용된 것을 인지한 경우 즉시 그 사실을 회사에 통보하여야 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>④</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> 사용자는 쯩 for 공공기관 서비스를 이용하여 얻은 정보를 회사의 사전 동의 없이 영리목적으로 이용하거나 제3자에게 이용하게
하는 행위를 할 수 없으며, 쯩 for 공공기관 서비스의 이용권한 및 기타 이용계약상 지위를 타인에게 양도, 증여할 수 없습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>⑤</span></b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>  사용자는 회사가 쯩 for 공공기관 서비스를 안전하게 제공할 수 있도록 회사에 협조하여야 하며, 회사가 사용자의 본
약관 위반행위를 발견하여 회원에게 해당 위반행위에 대하여 소명을 요청할 경우 회사의 요청에 적극 응하여야 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:54.0pt;text-align:justify;text-justify:inter-ideograph;
text-indent:-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'> <b><span style='background:white'>제10조 (사용자의 금지행위)</span></b></span></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR";background:white'>① 회사는 쯩 for 공공기관 서비스의 신뢰성을 제공하고 안전한 쯩 for 공공기관
서비스 이용이 이루어 질 수 있도록 아래와 같은 사용자의 행위를 금지합니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>1. 회사가 제공하는 쯩 for 공공기관 서비스
이용방법에 의하지 아니하고 비정상적인 방법으로 쯩 for 공공기관 서비스를 이용하거나 시스템에 접근하는 행위 </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>2. 회사에서 제공하는 서비스를 본래의 이용 목적 이외의 용도로 사용하는
행위. </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>3. 타인의 명의, 휴대폰 정보, 계좌 정보,
생체인식 정보, 신분증 등을 도용하여 쯩 for 공공기관 </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>서비스를 이용신청하거나 이용하는 행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'> 4. 회사 및 기타 제3자의 명예를 손상시키거나
업무를 방해하는 행위. </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>5. 회사 및 기타 제3자의 저작권, 초상권
등 지적재산권에 대한 침해행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>6. 회사가 제공하는 쯩 for 공공기관 서비스를
이용하여 얻은 회사 또는 제3자의 정보를 정보 소유자의 사전 동의 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-indent:36.0pt'><span lang=KO
style='font-family:"IBM Plex Sans KR";background:white'>7. </span><span
lang=KO style='font-family:"IBM Plex Sans KR"'>회사의 동의 없이 영리, 영업, 광고, 정치활동, 불법선거운동
등을 목적으로 서비스를 이용하는 행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR";background:white'>           8. 기타 </span><span lang=KO
style='font-family:"IBM Plex Sans KR"'>공공질서 및 미풍양속을 위반하거나 불법적, 부당한 행위 및 법령에 위배되는
행위</span></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR";background:white'>&nbsp;</span></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR";background:white'>② 회사는 사용자가 본 조의 금지행위를 행하는 경우</span><span
lang=KO style='font-family:"IBM Plex Sans KR"'> 제11조에 <span style='background:
white'>따라 쯩 for 공공기관 서비스 이용을 제한할 수 있으며, 회사는 필요한 경우 사용자의 금지행위 사실을 관련 정부기관 또는 사법기관에
통지할 수 있습니다.</span></span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제11조 (사용자에 대한 서비스 이용 제한)  </span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>① 사용자는 다음 각 호의 어느하나에 해당하는 사유가 발생하는 경우 사용자의 서비스 이용제한 및 기타 조치를 포함한 이용제한
조치를 할 수 있습니다. </span></p>

<p class=MsoNormal style='margin-top:19.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:72.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
약관 제5조 제4항 및 제5항에 해당하는 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
약관 제9조의 사용자의 의무를 이행하지 않은 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>3.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>본
약관 제10조 제2항에 해당하는 경우</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:19.0pt;
margin-left:72.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:
-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>4.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
lang=KO style='font-family:"IBM Plex Sans KR";color:black'>기타 사용자가 본 약관을 위반하거나 부당한
행위를 한 경우</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>② 제1항의 이용제한이 정당한 경우에 회사는 이용제한으로 인하여 사용자가 입은 손해를 배상하지 않습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제12조 (서비스의 변경 및 중단)</span></b></p>

<p class=MsoNormal style='margin-left:36.0pt'><span lang=KO style='font-family:
"IBM Plex Sans KR"'>① 회사는 다음 각 호의 경우에는 서비스의 전부 또는 일부를 일시 중단할 수 있습니다. 이 경우 회사는 사전에
그 정지의 사유와 기간을 쯩 for 공공기관 초기화면이나 서비스 공지사항 등에 공지합니다. 다만, 사전에 공지할 수 없는 부득이한 사정이 있는
경우 사후에 공지할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
0cm;margin-left:72.0pt;margin-bottom:.0001pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>1.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>회사
또는 발급기관 또는 이용기관의 시스템 정기점검, 서버의 증설 및 교체, 네트워크의 불안정 등의 시스템 운영상 필요한 경우</span></p>

<p class=MsoNormal style='margin-left:72.0pt;text-align:justify;text-justify:
inter-ideograph;text-indent:-18.0pt;background:white'><span lang=KO
style='font-family:"IBM Plex Sans KR"'>2.<span style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp;
</span></span><span lang=KO style='font-family:"IBM Plex Sans KR";color:black'>정전,
서비스 설비의 장애, 서비스 이용 폭주, 기간통신사업자의 설비 보수 또는 장애 및 점검 등으로 인하여 정상적인 서비스 제공이 불가능한 경우</span></p>

<p class=MsoNormal style='margin-top:0cm;margin-right:0cm;margin-bottom:19.0pt;
margin-left:72.0pt;text-align:justify;text-justify:inter-ideograph;text-indent:
-18.0pt;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>3.<span
style='font:7.0pt "Times New Roman"'>&nbsp;&nbsp;&nbsp; </span></span><span
lang=KO style='font-family:"IBM Plex Sans KR";color:black'>천재지변, 전쟁, 폭동, 테러, 해킹,
DDOS, 또는 이에 준하는 국가비상사태 등 회사가 통제할 수 없는 상황이 발생한 경우</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>② 쯩 for 공공기관
서비스는 관련 법령이나 정책 변경에 따라 달라질 수 있습니다. 회사는 쯩 for 공공기관 서비스 제공을 위해 계약을 체결하고 있는 발급기관 또는
이용기관 등의 시스템 운영 상황이나 계약 체결 상황에 따라서 쯩 for 공공기관 서비스 운영상 상당한 이유가 있는 경우에는 쯩 for 공공기관
서비스의 전체 또는 일부의 제공을 일시적으로 중단할 수 있습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>③ 회사는 파산 신청,
기업회생절차 개시 신청, 현저한 수익 악화 등 정상적인 영업활동이 곤란하여 쯩 for 공공기관 서비스를 지속할 수 <span
style='background:white'>없는 때에는 사용자에게 이를 통지한 날로부터 30일이 경과한 때부터 쯩 for 공공기관 서비스를 중단할
수 있습니다.</span></span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>&nbsp;</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>④ <span
style='background:white'>회사는 원활한 서비스 제공을 위해 운영상 또는 기술상의 필요에 따라 서비스를 변경할 수 있으며, 변경
전에 해당 내용을 쯩 for 공공기관 서비스 내에 공지합니다. 다만, 버그․오류 등의 수정이나 긴급 업데이트 등 부득이하게 변경할 필요가 있는
경우 또는 중대한 변경에 해당하지 않는 경우에는 사후에 공지할 수 있습니다.</span></span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제13조 (정보의 제공 및 광고의 게재)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>① 회사는 사용자가 서비스 이용을 위해 필요하다고 인정되는 다양한 정보를 쯩 for 공공기관 서비스 내 혹은 별도의 홈페이지에
게시하거나 기타 방법으로 사용자에게 제공할 수 있습니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>② 회사는 본 서비스 등을 유지하기 위하여 광고를 게재할 수 있으며, 사용자는 서비스 이용 시 노출되는 광고게재에 대하여
동의합니다. </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:36.0pt;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>③ 쯩 for 공공기관 내에 노출되는 제3자가 주체인 제2항의 광고에 사용자가 참여하거나 거래를 함으로써 발생하는 손실과
손해에 대해서 회사는 어떠한 책임도 부담하지 않습니다, </span></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><b><span
lang=KO style='font-family:"IBM Plex Sans KR"'> </span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제14조 (손해배상)</span></b></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>① 회사 또는 사용자는
본 약관을 위반하여 상대방에게 손해를 입힌 경우에는 그 손해를 배상할 책임이 있습니다. 다만, 고의 또는 과실이 없는 경우에는 그러하지 아니 합니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>② 사용자가 서비스를
이용함에 있어 행한 불법행위 또는 본 약관을 위반한 행위로 회사가 당해 사용자 외의 제3자로부터 손해배상청구 또는 소송 등 각종 이의제기를 받는
경우 당해 사용자는 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 당해 사용자는 그로 인하여 회사에 발생한 모든 손해를
배상할 책임이 있습니다.</span></p>

<p class=MsoNormal style='margin-bottom:19.0pt;text-align:justify;text-justify:
inter-ideograph;background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제15조 (회사의 면책)</span></b></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>① 회사는 사용자와
발급기관 또는 이용기관 상호간의 거래에 대한 어떠한 책임도 부담하지 않으며, 회사의 귀책사유가 아닌 사유로 발생한 서비스의 이용장애에 대하여 책임을
부담하지 않습니다. 또한<span style='background:white'> 회사는 사용자 또는 발급기관 또는 이용기관의 귀책사유로 인하여
발생한 손해에 대하여 회사의 귀책 사유가 없는 경우 책임을 부담하지 않습니다</span></span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>② 회사는 사용자가 쯩 for 공공기관 서비스를 이용하여 기대하는 수익을 달성하지 못했거나 상실한 것에 대해서
책임을 지지 않으며, 그 밖에 쯩 for 공공기관 서비스를 통하여 얻은 정보로 인하여 발생한 손해에 대하여도 책임을 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>③ 사용자가 자신의 개인정보, 사용자 저장 데이터, 비밀번호 (생체등록 정보 포함), 쯩 for 공공기관 서비스
이용 관련 정보 등을 타인에게 제공하거나, 사용자의 관리소홀로 유출됨으로써 발생하는 피해에 대해서 회사는 책임을 지지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>④ 회사는 사용자가 본인의 모바일 기기 내에 있는 사용자 저장 데이터의 전부나 일부를 삭제하여 서비스 이용에 제한이
되는 경우  회사는 이에 대해 책임을 지지 않습니다. </span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>⑤ 회사는 발급기관이 크레덴셜을 발급하는 과정에서 발급기관의 고의 또는 과실로 인한 서비스의 이용장애 및 이로
인해 발생한 피해에 대해서 책임을 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>⑥ 회사는 이용기관이 크레덴셜을 검증하는 과정에서 이용기관의 고의 또는 과실로 인한 서비스의 이용장애 및 이로
인해 발생한 피해에 대해서 책임을 부담하지 않습니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>⑦ 회사는 서비스용 설비의 보수, 교체, 정기점검, 공사 등 기타 이에 준하는 사유로 발생한 손해에 대하여 </span><span
lang=KO style='font-family:"IBM Plex Sans KR"'>책임을 지지 않습니다. 다만, 회사의 고의 또는 과실에 의한
경우에는 그러하지 아니합니다.</span></p>

<p class=MsoNormal style='margin-left:36.0pt;text-align:justify;text-justify:
inter-ideograph'><span lang=KO style='font-family:"IBM Plex Sans KR"'>⑧ 사용자가 모바일
기기의 변경, 모바일 기기의 번호 변경, 운영체제(OS) 버전의 변경, 해외 로밍, 통신사 변경 등으로 인해 콘텐츠 전부나 일부의 기능을 이용할
수 없는 경우 회사는 이에 대해 책임을 지지 않습니다<span style='background:white'>.</span></span></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph'><span
lang=KO style='font-family:"IBM Plex Sans KR"'> </span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>제16조 (재판권 및 준거법)</span></b></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR";
color:black'>이 약관은 대한민국 법률에 따라 규율되고 해석됩니다. 회사와 사용자 간에 발생한 분쟁으로 소송이 제기되는 경우에는 법령에
정한 절차에 따른 법원을 관할 법원으로 합니다.</span></p>

<p class=MsoNormal style='margin-top:10.0pt;margin-right:0cm;margin-bottom:
10.0pt;margin-left:0cm;text-align:justify;text-justify:inter-ideograph;
background:white'><span lang=KO style='font-family:"IBM Plex Sans KR"'>&nbsp;</span></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
line-height:112%'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>v1.1.0</span></b></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
line-height:112%'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>개정일자 : 2025.01.14</span></b></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
line-height:112%'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>시행일자 : 2025.01.21</span></b></p>

<p class=MsoNormal style='text-align:justify;text-justify:inter-ideograph;
line-height:150%'><b><span lang=KO style='font-family:"IBM Plex Sans KR";
background:white'>&nbsp;</span></b></p>


</div>

</body>

</html>
    `,
   },
   {
      title: "[필수] 쯩 개인정보 수집 및 이용 동의",
      desc: `
    <h1>[필수] 쯩 개인정보 수집 및 이용 동의</h1>
    <div class="mg-26"></div>
    <div class="title-2">
      <span class="bold">1. 수집 및 이용 목적</span><br />
      <span>만 14세 미만 여부 확인</span>
    </div>
    <div class="title-2">
      <span class="bold">2. 수집하는 항목</span><br />
      <span>이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인</span>
    </div>
    <div class="title-2">
      <span class="bold">3. 보유 및 이용 기간</span><br />
      <span class="bold blue">만 14세 미만 여부 확인 후 즉시 파기하며, 정보를 저장하지 않음</span>
    </div>
    <div class="title-2">
        <span>4. 귀하는 개인정보 수집 동의를 거부할 권리가 있으며, 동의 거부 시 쯩 서비스를 이용하실 수 없습니다.</span>
    </div>
    `,
   },
   {
      title: "쯩 보호자 정보 수집 및 이용 동의",
      desc: `
    <h1>쯩 보호자 정보 수집 및 이용 동의</h1>
    <div class="mg-26"></div>
    <div class="title-2">
      <span class="bold">1. 수집 및 이용 목적 </span><br />
      <span>만 14세 미만 아동과의 법정대리인 여부 관계확인</span>
      </div>
    <div class="title-2">
      <span class="bold">2. 수집하는 항목</span><br />
      <span>보호자 이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인</span>
    </div>
    <div class="title-2">
      <span class="bold">3. 보유 및 이용 기간</span><br />
      <span class="bold blue">법정대리인 여부 확인 후 즉시 파기하며, 정보를 저장하지 않음</span>
    </div>
    <div class="title-2">
        <span>4. 귀하는 보호자 정보 수집 동의를 거부할 권리가 있으며, 동의 거부 시 대상 아동은 쯩 서비스를 이용할 수 없습니다.</span>
    </div>
    `,
   },
   //  방역 패스 3 ~ 5
   {
      title: "[필수] 쯩 개인정보 수집 및 이용 동의",
      desc: `
  <h1>[필수] 쯩 개인정보 수집 및 이용 동의</h1>
  <p></p>
  <div class="mg-26" ></div>
  <div class="title-2">
    <span class="bold">1. 수집 및 이용 목적</span> <br />
    <span>방역패스 보유 여부 조회</span>
  </div>
  <div class="title-2">
    <span class="bold">2. 수집하는 항목</span><br />
    <span>정보 주체가 본인 인증 후 생성되는 값(CI)</span>
  </div>
  <div class="title-2">
    <span class="bold">3. 보유 및 이용기간</span><br />
    <span class=" bold blue">증명정보 확인 후 즉시 파기 / 사용자의 단말에 저장하며, 파라메타는 개인정보를 저장하지 않음 </span>
  </div>
  <div class="title-2">* 귀하는 개인정보 수집 동의를 거부할 권리가 있으며, 동의 거부 시 방역패스 정보를 받을 수 없습니다.
  </div>
  `,
   },
   {
      title: "[필수] 개인정보 제3자 제공 동의",
      desc: `
  <h1>[필수] 개인정보 제3자 제공 동의</h1>
  <p></p>
  <div class="mg-26" ></div>
  <div class="title-2">
  <span class="bold">1. 제공받는 자</span> <br />
  <span class="bold blue">질병관리청</span>
  </div>
  <div class="title-2">
  <span class="bold">2. 개인정보 이용 목적</span><br />
  <span class="bold blue">방역패스 보유 여부 조회</span>
  </div>
  <div class="title-2">
  <span class="bold">3. 개인정보 항목</span><br />
  <span>정보 주체가 본인 인증 후 생성되는 값(CI)</span>
  </div>
  <div class="title-2">
  <span class="bold">4. 보유 및 이용기간</span><br />
  <span class="bold blue">증명정보 확인 후 즉시 파기 </span>
  </div>
  <div class="title-2">* 귀하는 개인정보 수집 동의를 거부할 권리가 있으며, 동의 거부 시 방역패스 정보를 받을 수 없습니다.
  </div>
  `,
   },
   {
      title: "[필수] 질병관리청에서 제공하는 민감정보의 제3자 제공 동의",
      desc: `
  <h1>[필수] 질병관리청에서 제공하는 민감정보의 제3자 제공 동의</h1>
  <p></p>
  <div class="mg-26" ></div>
  <div class="title-2">
  <span class="bold">1. 제공받는 자</span><br />
  <span class="bold blue">아이콘루프</span>
  </div>
  <div class="title-2">
  <span class="bold">2. 민감정보 이용목적</span><br />
  <span class="bold blue">방역패스 보유 여부 확인</span><br />
  <span class="bold blue">국내 다중이용시설 등 이용 시, 코로나19 방역패스 정보 제출 및 검증</span>
  </div>
  <div class="title-2">
  <span class="bold">3. 민감정보 항목</span><br/>
  <span>방역패스 항목별 보유 여부</span><br />
  <span> * 제공 시점을 기준으로 항목별 유효성 여부(코로나19 예방접종, 확진, PCR 음성, 접종 예외)</span>
  </div>
  <div class="title-2">
  <span class="bold">4. 민감정보 보유 및 이용기간</span><br />
  <span class="bold blue"> 정보 주체의 방역패스 보유 여부 확인 후 즉시 파기</span>
  </div>
  <div class="title-2">* 귀하는 민감정보 제공 동의를 거부할 권리가 있으며, 동의 거부 시 방역패스 정보를 받을 수 없습니다.
  </div>
  `,
   },
   // 제주안심코드 6 ~ 7
   {
      title: "[필수] 개인정보 수집 및 이용 동의",
      desc: `
      <h1>[필수] 개인정보 수집 및 이용 동의</h1>
      <div class="divider"></div>
      <p>제주특별자치도(이하 ‘도’)는 개인정보를 아래와 같이 수집 및 이용합니다.</p>
      <table>
      <tbody>
        <tr>
          <td style="width: 30%;"><strong>수집·이용 목적</strong></td>
          <td style="width: 45%"><strong>수집·이용 항목</strong></td>
          <td style="width: 25%"><strong>보유 기간</strong></td>
        </tr>
        <tr>
          <td style="width: 30%" rowspan="2">제주안심코드를 통한 전자출입명부 이용</td>
          <td style="width: 45%">(필수) 휴대폰번호, CI, 성명, 생년월일, 성별, DID</td>
          <td style="width: 25%">정보주체가 동의한 날로부터 70일(10주) 보관 후 파기</td>
        </tr>
        <tr>
          <td style="width: 45%">(필수) 방문시설명, 방문일시</td>
          <td style="width: 25%">목적 달성 후 지체없이 파기</td>
        </tr>
      </tbody>
    </table>
    <p>위의 개인정보 수집 및 이용에 대한 동의를 거부할 권리가 있습니다. 그러나 위 동의를 거부할 경우 본 서비스 이용이 제한됩니다.</p>
    `,
   },
   {
      title: "[필수] 개인정보 제3자 제공 동의",
      desc: `
    <h1>[필수] 개인정보 제3자 제공 동의</h1>
    <div class="divider"></div>
    <p>제주특별자치도는 확진자 발생 시 역학조사를 위해 질병관리청으로 QR 체크인에서 수집한 개인정보를 제공합니다.</p>
    <table>
      <tbody>
        <tr>
          <td style="width: 15%;"><strong>제공받는 자</strong></td>
          <td style="width: 35%"><strong>제공 목적</strong></td>
          <td style="width: 25%"><strong>제공하는 개인정보 항목</strong></td>
          <td style="width: 25%"><strong>보유 기간</strong></td>
        </tr>
        <tr>
          <td style="width: 15%;">질병관리청</td>
          <td style="width: 35%">코로나-19 감염병 예방 · 감염 전파의 차단을 위한 역학조사</td>
          <td style="width: 25%">(필수) 휴대폰번호, 방문시설명, 방문일시</td>
          <td style="width: 25%">역학조사 필요시에만 요청하여 제공, 역학조사 실시 후 즉시 파기</td>
        </tr>
      </tbody>
    </table>
    <p>위의 개인정보 제3자 제공에 대한 동의를 거부할 권리가 있습니다. 그러나 위 동의를 거부할 경우 본 서비스 이용이 제한됩니다.</p>
    `,
   },

   {
      title: "개인정보 수집 및 이용 동의",
      desc: `
      <body style="font-family: Arial, sans-serif; line-height: 1.6; margin: 20px; color: #333;">
    <h1 style="text-align: center; margin-bottom: 18px">개인정보 수집 및 이용 동의</h1>
    <p style="color: #000;margin-bottom: 18px">① 이용자는 쯩 for 공공기관 서비스를 이용하기 위해 이용자가 실명인증 크레덴셜을 발급기관으로부터 발급 받거나 발급받은 실명인증 크레덴셜을 제출하고자 하는 검증기관이 다음과 같이 이용자의 개인정보를 수집 및 이용하는 것에 동의합니다.
</p>
    
    <div style="text-align; ">1. 수집항목</h2>
    <table style="width: 100%; border-collapse: collapse; margin: 20px 0; color: #333;">
        <thead>
            <tr>
                <th style="border: 1px solid #ddd; padding: 10px; text-align: left; background-color: #f4f4f4; color: #000;">서비스</th>
                <th style="border: 1px solid #ddd; padding: 10px; text-align: left; background-color: #f4f4f4; color: #000;">수집·이용 목적</th>
                <th style="border: 1px solid #ddd; padding: 10px; text-align: left; background-color: #f4f4f4; color: #000;">수집·이용 항목</th>
                <th style="border: 1px solid #ddd; padding: 10px; text-align: left; background-color: #f4f4f4; color: #000;">보유 기간</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td style="border: 1px solid #ddd; padding: 10px; text-align: left; background-color: white; color: #000; ">서비스 가입</td>
                <td style="border: 1px solid #ddd; padding: 10px; text-align: left; background-color: white; color: #000;">휴대폰 본인확인</td>
                <td style="border: 1px solid #ddd; padding: 10px; text-align: left; background-color: white; color: #000;">(필수) 이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인</td>
                <td style="border: 1px solid #ddd; padding: 10px; text-align: left; background-color: white; color: #000;">
                    - 통신사 중개 업체에 제공함<br>
                    - 사용자 휴대폰 본인인증 파기 혹은 앱 탈퇴 시 정보 삭제
                </td>
            </tr>
            <tr>
                <td style="border: 1px solid #ddd; padding: 10px; text-align: left; color: #000;">간편로그인</td>
                <td style="border: 1px solid #ddd; padding: 10px; text-align: left; color: #000;">간편로그인 본인 확인</td>
                <td style="border: 1px solid #ddd; padding: 10px; text-align: left; color: #000;">(필수) Google, Apple 이용자 고유 식별자(이메일)
</td>
                <td style="border: 1px solid #ddd; padding: 10px; text-align: left; color: #000;">- 앱 탈퇴 시 정보삭제</td>
            </tr>
        </tbody>
    </table>
    
    <div style="text-align; ">2. 이용 목적</div>
     <ul style="color: #000; margin: 20px 0; padding-left: 20px; list-style-type: none;">
        <li>- 이용자가 발급기관의 서비스 이용 시 본인 확인 정보 자동 입력</li>
        <li>- 이용자가 발급기관의 서비스 이용을 위해 제공한 개인정보의 정확성 여부 확인</li>
        <li>- 이용자가 제공한 개인정보를 발급기관이 크레덴셜의 형태로 발급하여 사용자의 단말기에 전달</li>
        <li>- 이용자가 발급 받은 실명인증 크레덴셜을 검증기관에 제출 시, 해당 검증기관 내 서비스 이용 목적으로 수집 및 이용</li>
    </ul>
    
    <div style="text-align; ">3. 개인정보 보유 및 이용기간</div>
    <ul style="color: #000; margin: 20px 0; padding-left: 20px; list-style-type: none;">
        <li>- 해당 발급기관 또는 검증기관의 개인정보취급방침에 따름</li>
        <li>- 해당 발급기관이 발급한 실명인증 크레덴셜의 유효기간은 발급일로부터 3개월이며, 유효기간 내 재발급하지 않을 시 만료 처리</li>
    </ul>
    <p style="color: #000;margin-bottom: 18px">② 이용자는 위 목적으로 발급기관(또는 검증기관)이 사용자의 고유식별정보를 수집 및 이용하는 것에 동의합니다.</p>
    <p style="color: #000;margin-bottom: 18px">③ 이용자가 상기 개인정보의 수집 및 이용, 고유식별정보의 수집 및 이용에 동의하지 않는 경우, 
쯩 for 공공기관의 실명인증 서비스를 이용할 수 없습니다.</p>
</body>
    `,
   },
   {
      title: "고유식별정보 수집 및 이용 동의",
      desc: `
      <h1>고유식별정보 수집 및 이용 동의</h1>
      <div class="mg-26"></div>
      <div class="title-2">
        <span class="bold">1. 수집 및 이용 목적</span><br />
        <span>휴대폰 본인확인</span>
      </div>
      <div class="title-2">
        <span class="bold">2. 수집하는 항목</span><br />
        <span class="bold blue">주민등록번호</span>
      </div>
      <div class="title-2">
        <span class="bold">3. 보유 및 이용기간</span><br />
        <span>통신사 중계업체에 제공하며, 정보를 저장하지 않음</span>
      </div>
      <div class="title-2">
        <span>4. 귀하는 고유식별정보 수집 동의를 거부할 권리가 있으며, 동의 거부 시 쯩 서비스를 이용할 수 없습니다.</span>
      </div>
    `,
   },
];

export const tosPrevData: Data[] = [
   {
      title: "개인정보 처리방침",
      desc: `
  <h1>개인정보 처리방침</h1>
  <div class="divider"></div>
  <ol class="sub">
    <li>개인정보 처리 목적 및 보유기간</li>
    <li>개인정보 제3자 제공에 관한 사항</li>
    <li>개인정보 위탁</li>
    <li>개인정보 파기</li>
    <li>개인정보의 안전성 확보조치에 관한 사항</li>
    <li>개인정보 자동 수집 장치의 설치 및 운영 및 그 거부에 관한 사항</li>
    <li>개인정보 보호업무 및 관련 고충 문의</li>
    <li>권익침해 구제방법</li>
    <li>개인정보 처리방침 변경에 관한 사항</li>
  </ol>
  <p>
    본 개인정보처리방침은 파라메타(이하 ‘회사’)의 웹사이트, 모바일 앱 등에서
    처리되는 정보에 대해 설명합니다. 회사는 ‘이용자의 동의’를 기반으로 개인정보를
    처리하고 있으며 관련 국내/외 법령 및 기타 개인정보보호 관련 가이드라인을
    준수하고 있습니다.
  </p>
  <div class="divider"></div>
  <h2>1. 개인정보 처리 목적 및 보유기간</h2>
  <table>
    <tbody>
      <tr>
        <td style="width: 25%">서비스</td>
        <td style="width: 25%">수집·이용 목적</td>
        <td style="width: 25%">수집·이용 항목</td>
        <td style="width: 25%">보유 기간</td>
      </tr>
      <tr>
      <td rowspan="2" style="width: 25%">쯩(휴대폰 본인확인)</td>
      <td style="width: 25%">만 14세 미만 및 법정대리인 여부 확인</td>
      <td style="width: 25%">(필수) 본인 정보(이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인), 법정대리인 정보(보호자 이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인) </td>
      <td style="width: 25%">만 14세 미만 및 법정대리인 여부 확인 후 즉시 파기하며, 정보를 저장하지 않음</td>
    </tr>
    <tr>
    <td style="width: 25%">휴대폰 본인확인</td>
    <td style="width: 25%">(필수) 이름, 생년월일, 성별, 통신사, 전화번호, CI, 내/외국인, 주민등록번호</td>
    <td style="width: 25%">통신사 중계업체에 제공하며, 정보를 저장하지 않음
    </td>
      <tr>
        <td rowspan="2" style="width: 25%">운전면허인증</td>
        <td style="width: 25%">운전면허증 위·변조 판별</td>
        <td style="width: 25%">(필수) 운전면허증 OCR 정보 (이름, 생년월일, 운전면허번호, 운전면허 일련번호)</td>
        <td style="width: 25%">운전면허증 위·변조 판별 후 즉시 파기</td>
      </tr>
      <tr>
        <td style="width: 25%">중복 가입 식별</td>
        <td style="width: 25%">(필수) 개인식별자 (CI를 가공한 값)</td>
        <td style="width: 25%">서비스 탈퇴 시 까지</td>
      </tr>
    </tbody>
  </table>
  <p>
  서비스 제공 시 앱에서 아래와 같은 접근권한을 요구합니다. 
  </p>
  <table>
    <tbody>
      <tr>
        <td style="width: 25%">앱 접근권한</td>
        <td style="width: 25%">이용근거</td>
        <td style="width: 25%">이용목적</td>
        <td style="width: 25%">이용기간</td>
      </tr>
      <tr>
        <td style="width: 25%">CAMERA (필수)</td>
        <td style="width: 25%">정보주체의 동의</td>
        <td style="width: 25%">QR코드 촬영, 신분증 촬영</td>
        <td style="width: 25%">앱 실행 시</td>
      </tr>
    </tbody>
  </table>
  <p>
    <strong>개인정보를 수집하는 방법은 다음과 같습니다.</strong> <br />
    회사는 개인정보 수집 시 반드시 이용자에게 해당 사실을 알리고 동의를 구하고
    있으며, 아래와 같은 방법으로 수집합니다.
  </p>
  <ol>
    <li>
      - 회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해 동의를 하고
      직접 정보를 입력하는 경우
    </li>
    <li>- 제휴 서비스 또는 단체 등으로부터 개인정보를 제공받은 경우</li>
    <li>
      - 고객센터를 통한 상담 과정에서 웹페이지, 메일, 전화 등으로 이용자가 직접
      제공하는 경우
    </li>
    <li>- 온·오프라인에서 진행되는 이벤트/행사 등 참여</li>
  </ol>

  <p>
    <strong
      >서비스 이용 과정에서 자동 생성된 정보를 이용자로부터 수집할 수
      있습니다.</strong
    ><br />
    PC웹, 모바일 웹 이용 과정에서 단말기정보(OS, 화면사이즈, 디바이스 아이디),
    IP주소, 쿠키, 방문일시, 부정이용기록, 서비스 이용 기록 등의 정보가 자동으로
    생성되어 수집될 수 있습니다.
  </p>
  <p>
    <strong
      >수집한 개인정보는 회사의 서비스 제공 등 이용자가 요청한 목적을 위해
      이용합니다.</strong
    ><br />
    회사는 개인정보 보호 관련 법령 및 GDPR 등 각 회원국의 법률을 준수를 위하여
    필요한 최소한의 목적으로 이용자의 정보를 이용합니다. 이용자의 회원가입 및
    서비스 이용 과정에서 수집한 정보를 아래와 같은 서비스를 제공하기 위해
    이용합니다.
  </p>
  <ol>
    <li>- 회원 식별/가입의사 확인, 부정이용 방지</li>
    <li>- 신규 서비스 개발, 다양한 서비스 제공, 문의사항 또는 불만처리</li>
    <li>
      - 서비스 이용 기록, 접속 빈도 및 서비스 이용에 대한 통계, 프라이버시 보호
      측면의 서비스 환경 구축, 맞춤형 서비스, 서비스 개선에 활용
    </li>
    <li>- 준거법 또는 법적 의무의 준수</li>
    <li>
      - 공익적 직무의 실행을 위하여 처리가 필요한 경우 또는 회사에게 부여된 공적
      권한의 행사에 처리가 필요한 경우
    </li>
    <li>
      - 회사나 제3자가 추구하는 정당한 이익 목적을 위하여 처리가 필요한 경우
      (다만, 특히 이용자가 아동인 경우와 같이 개인정보 보호를 요구하는 이용자의
      이익이나 기본권과 자유가 해당 이익에 우선하는 경우에는 그러하지 아니함)
    </li>
  </ol>

  <h2>2. 개인정보 제3자 제공에 관한 사항</h2>

  <p>
    <strong>고객의 별도 동의를 받거나 법령에 규정된 경우에만 고객의 개인정보를 제3자에게 제공하고 있습니다.</strong>
  </p>
  
  <h2>3. 개인정보 위탁</h2>
  <p>
    <strong
      >회사는 편리하고 더 나은 서비스를 제공하기 위해 업무 중 일부를 외부에
      위탁하고 있습니다. </strong
    ><br />
    서비스 향상을 위해서 관계 법령에 따라 위탁계약 시 개인정보가 안전하게 관리될
    수 있도록 필요한 사항을 규정하고 있습니다.<br />
    회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와 같습니다.
  </p>
  <table>
    <tbody>
      <tr>
        <td style="width: 30%">위탁받는 자</td>
        <td style="width: 40%">위탁하는 업무의 내용</td>
        <td style="width: 30%">보유 기간</td>
      </tr>
      <tr>
        <td style="width: 30%">(주)쿠프마케팅</td>
        <td style="width: 40%">교환권 발송 고객 대상 상품 조회 등 CS업무</td>
        <td style="width: 30%">교환권 만료일로부터 30일 보관 후 파기</td>
      </tr>
      <tr>
        <td style="width: 30%">코드에프</td>
        <td style="width: 40%">운전면허인증 위변조 판별</td>
        <td style="width: 30%">운전면허증 위·변조 판별 후 즉시 파기</td>
      </tr>
    </tbody>
  </table>

  <h2>4. 개인정보 파기</h2>

  <p>
    <strong
      >개인정보는 수집 및 이용목적이 달성되면 별도의 동의 및 법령근거가 없는 경우
      지체없이 파기합니다.</strong
    ><br />
    회사는 수집 및 이용 목적이 달성된 개인정보(회원 탈퇴, 서비스 종료 등)는 아래의
    방법에 따라 지체없이 파기합니다.
  </p>
  <ol>
    <li>- 전자적 파일 : 복구 및 재생되지 않도록 안전하게 삭제</li>
    <li>- 그 밖에 기록물, 인쇄물, 서면 등 : 분쇄하거나 소각</li>
  </ol>
  



  <h2>5. 개인정보의 안전성 확보조치에 관한 사항</h2>
  <p>
    <strong
      >이용자의 개인정보를 안전하게 보호하기 위해 필요한 조치를 운영하고
      있습니다.</strong
    >
    <br />회사는 이용자의 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록
    안전성 확보를 위하여 다음과 같은 기술적, 관리적, 물리적 조치를 운영하고
    있습니다
  </p>
  <table>
    <tbody>
      <tr>
        <td style="width: 25%">항목</td>
        <td style="width: 75%">내용</td>
      </tr>
      <tr>
        <td style="width: 25%">기술적 조치</td>
        <td style="width: 75%">
          <ol>
            <li>- 개인정보 암호화 조치</li>
            <li>- 백신 소프트웨어 등 설치 및 운영</li>
            <li>- 접근통제시스템 설치 및 운영</li>
            <li>- 개인정보처리시스템에 대한 접근기록의 보관 등</li>
            <li>- 개인정보처리시스템에 대한 접근권한 차별화</li>
          </ol>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">관리적 조치</td>
        <td style="width: 75%">
          <ol>
            <li>- 개인정보보호 조직 구성</li>
            <li>- 내부관리계획의 수립 및 시행</li>
            <li>- 개인정보처리자의 정기 교육 및 점검</li>
            <li>- 수탁사의 개인정보 처리 업무 관리 감독</li>
          </ol>
        </td>
      </tr>
      <tr>
        <td style="width: 25%">물리적 조치</td>
        <td style="width: 75%">
          <ol>
            <li>- 개인정보를 보관 시설에 대한 출입통제 절차 수립 및 운영</li>
            <li>
            - 개인정보가 포함된 서류나 보조기억매체 등은 잠금장치가 부착되어 있는
              안전한 장소에 보관
            </li>
          </ol>
        </td>
      </tr>
    </tbody>
  </table>
  <h2>6. 개인정보 자동 수집 장치의 설치 및 운영 및 그 거부에 관한 사항</h2>
  <p>
    <strong>이용자에게 편의 제공을 위하여 쿠키 정보를 이용할 수 있습니다.</strong>
    <br />
    쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 작은
    텍스트 파일로 이용자 컴퓨터에 자동 저장됩니다.
  </p>
  <ol>
    <li>
      | 쿠키 사용 목적 <br />
      이용자가 웹사이트를 이용하는 경우 웹 사이트 서버는
      이용자의 디바이스에 저장된 쿠키를 사용하게 됩니다. 회사는 웹 분석 Tool 등을
      통해 쿠키를 활용하여 이용자의 웹사이트 방문 기록, 이용 형태 등을 파악하고
      이용자에 맞는 맞춤형 광고 정보 제공 및 서비스 개선을 수행하고 있습니다. 쿠키
      정보는 이용자의 디바이스 식별용도로만 활용되며 개개인을 식별하지 않습니다.
    </li>
    <li>
      | 쿠키 수집 거부 <br />
      이용자는 웹 브라우저에서 아래와 같이 옵션을 설정함으로써
      쿠키 정보의 저장을 제한할 수 있습니다. 단, 쿠키 정보의 저장을 거부하면
      로그인 정보 저장 및 맞춤형 광고 차단 등 일부 서비스의 이용이 어려울 수
      있습니다. <br />
      1) Internet Explorer <br />
      &nbsp&nbsp&nbsp 웹 브라우저 상단의 도구 메뉴 > 인터넷 옵션 > 개인정보
      > 설정 <br />
      2) Chrome <br />
      &nbsp&nbsp&nbsp 웹 브라우저 우측의 설정 메뉴 > 화면 하단의 고급 설정 표시 >
      개인정보의 콘텐츠 설정 버튼 > 쿠키 <br /><br />
      모바일 앱의 경우 아래의 방법을 통해 맞춤형 광고 설정을 해제할 수 있습니다.
      <br />
      1) Android <br />
      &nbsp&nbsp&nbsp 설정 > Google 설정 > 광고 > ‘광고 맞춤설정 선택 해제’ 활성화
      <br />
      2) IOS<br />
      &nbsp&nbsp&nbsp 설정 > 개인정보보호 > 광고 > ‘광고 추적 제한’ 활성화
    </li>
  </ol>

  <h2>7. 개인정보 보호업무 및 관련 고충 문의</h2>
  <p>
    <strong
      >이용자의 권리를 보호하기 위해 적극적으로 필요한 조치를 운영하고
      있습니다.</strong
    ><br />
    이용자는 언제든지 자신의 개인정보를 조회하거나 수정, 이동, 삭제 등이
    가능합니다. 또, 원하는 때에 동의 철회 또는 가입 해지를 요청할 수도 있습니다.
  </p>

  <p>
    <strong
      >개인정보보호와 관련해서 궁금하신 사항이 있으시면 언제든 문의 주시기
      바랍니다.</strong
    ><br />
    서비스를 이용하면서 발생하는 모든 개인정보보호 관련 문의, 불만, 조언이나 기타
    사항은 개인정보 보호책임자 및 담당부서로 연락해 주시기 바랍니다.
  </p>
  <ol>
    <li>
      | 개인정보보호 책임자(CPO, DPO) 및 담당부서<br />
      책임자: 천경민<br />
      담당부서: 정보보호팀<br />
      문의: privacy@iconloop.com <br />
    </li>
  </ol>

  <h2>8. 권익침해 구제방법</h2>
  <p>
    <strong
      >개인정보가 침해되어 이에 대한 신고나 전문적인 상담이 필요하신 경우에는 아래
      기관에 문의하셔서 도움을 받으실 수 있습니다.</strong
    >
  </p>

  <ol>
    <li>
    | 개인정보침해 신고센터<br />
      (국번없이)118<br />
      https://privacy.kisa.or.kr<br />
    </li>
    <li>
    | 개인정보 분쟁조정위원회<br />
      1833-6972<br />
      https://www.kopico.go.kr<br />
    </li>
    <li>
    | 대검찰청 사이버수사과<br />
      (국번없이)1301<br />
      cid@spo.go.kr
    </li>
    <li>
    | 경찰청 사이버안전국 <br />
      (국번없이)182<br />
      https://cyberbureau.police.go.kr
    </li>
  </ol>

  <h2>9. 개인정보 처리방침 변경에 관한 사항</h2>
  <p>
    <strong>개인정보 처리방침이 변경되는 경우에 홈페이지에 게시됩니다.</strong
    ><br />
    법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인정보 처리방침이
    변경되는 경우, 회사는 변경내용을 홈페이지에 게시하여 이용자가 언제든 확인할 수
    있도록 하겠습니다.
  </p>
  <ol>
    <li>| 공고일자: 2022년 04월 25일</li>
    <li>| 시행일자: 2022년 05월 02일</li>
  </ol>
  `,
   },
   {
      title: "개인정보 처리방침",
      desc: `
 <html
   xmlns:o="urn:schemas-microsoft-com:office:office"
   xmlns:w="urn:schemas-microsoft-com:office:word"
   xmlns:m="http://schemas.microsoft.com/office/2004/12/omml"
   xmlns="http://www.w3.org/TR/REC-html40"
>
   <head>
      <meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="ProgId" content="Word.Document" />
      <meta name="Generator" content="Microsoft Word 15" />
      <meta name="Originator" content="Microsoft Word 15" />
      <link
         rel="File-List"
         href="’쯩%20for%20공공기관’%20개인정보%20처리방침.fld/filelist.xml"
      />
      <link
         rel="Edit-Time-Data"
         href="’쯩%20for%20공공기관’%20개인정보%20처리방침.fld/editdata.mso"
      />
      <link
         rel="themeData"
         href="’쯩%20for%20공공기관’%20개인정보%20처리방침.fld/themedata.thmx"
      />
      <link
         rel="colorSchemeMapping"
         href="’쯩%20for%20공공기관’%20개인정보%20처리방침.fld/colorschememapping.xml"
      />
      <!--[if gte mso 9
         ]><xml>
            <w:WordDocument>
               <w:EmbedTrueTypeFonts />
               <w:SpellingState>Clean</w:SpellingState>
               <w:GrammarState>Clean</w:GrammarState>
               <w:TrackMoves>false</w:TrackMoves>
               <w:TrackFormatting />
               <w:PunctuationKerning />
               <w:ValidateAgainstSchemas />
               <w:SaveIfXMLInvalid>false</w:SaveIfXMLInvalid>
               <w:IgnoreMixedContent>false</w:IgnoreMixedContent>
               <w:AlwaysShowPlaceholderText>false</w:AlwaysShowPlaceholderText>
               <w:DoNotPromoteQF />
               <w:LidThemeOther>EN-US</w:LidThemeOther>
               <w:LidThemeAsian>KO</w:LidThemeAsian>
               <w:LidThemeComplexScript>X-NONE</w:LidThemeComplexScript>
               <w:Compatibility>
                  <w:BreakWrappedTables />
                  <w:SnapToGridInCell />
                  <w:WrapTextWithPunct />
                  <w:UseAsianBreakRules />
                  <w:DontGrowAutofit />
                  <w:SplitPgBreakAndParaMark />
                  <w:EnableOpenTypeKerning />
                  <w:DontFlipMirrorIndents />
                  <w:OverrideTableStyleHps />
                  <w:UseFELayout />
               </w:Compatibility>
               <w:DoNotOptimizeForBrowser />
               <m:mathPr>
                  <m:mathFont m:val="Cambria Math" />
                  <m:brkBin m:val="before" />
                  <m:brkBinSub m:val="&#45;-" />
                  <m:smallFrac m:val="off" />
                  <m:dispDef />
                  <m:lMargin m:val="0" />
                  <m:rMargin m:val="0" />
                  <m:defJc m:val="centerGroup" />
                  <m:wrapIndent m:val="1440" />
                  <m:intLim m:val="subSup" />
                  <m:naryLim m:val="undOvr" /> </m:mathPr
            ></w:WordDocument> </xml
      ><![endif]-->
      <!--[if gte mso 9
         ]><xml>
            <w:LatentStyles
               DefLockedState="false"
               DefUnhideWhenUsed="false"
               DefSemiHidden="false"
               DefQFormat="false"
               DefPriority="99"
               LatentStyleCount="376"
            >
               <w:LsdException
                  Locked="false"
                  Priority="0"
                  QFormat="true"
                  Name="Normal"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  QFormat="true"
                  Name="heading 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="heading 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="heading 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="heading 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="heading 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="heading 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="heading 7"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="heading 8"
               />
               <w:LsdException
                  Locked="false"
                  Priority="9"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="heading 9"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 5"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 6"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 7"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 8"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index 9"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 7"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 8"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toc 9"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Normal Indent"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="footnote text"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="annotation text"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="header"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="footer"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="index heading"
               />
               <w:LsdException
                  Locked="false"
                  Priority="35"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="caption"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="table of figures"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="envelope address"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="envelope return"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="footnote reference"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="annotation reference"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="line number"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="page number"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="endnote reference"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="endnote text"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="table of authorities"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="macro"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="toa heading"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Bullet"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Number"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List 5"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Bullet 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Bullet 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Bullet 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Bullet 5"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Number 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Number 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Number 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Number 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="10"
                  QFormat="true"
                  Name="Title"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Closing"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Signature"
               />
               <w:LsdException
                  Locked="false"
                  Priority="1"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Default Paragraph Font"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Body Text"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Body Text Indent"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Continue"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Continue 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Continue 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Continue 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="List Continue 5"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Message Header"
               />
               <w:LsdException
                  Locked="false"
                  Priority="11"
                  QFormat="true"
                  Name="Subtitle"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Salutation"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Date"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Body Text First Indent"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Body Text First Indent 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Note Heading"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Body Text 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Body Text 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Body Text Indent 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Body Text Indent 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Block Text"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Hyperlink"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="FollowedHyperlink"
               />
               <w:LsdException
                  Locked="false"
                  Priority="22"
                  QFormat="true"
                  Name="Strong"
               />
               <w:LsdException
                  Locked="false"
                  Priority="20"
                  QFormat="true"
                  Name="Emphasis"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Document Map"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Plain Text"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="E-mail Signature"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Top of Form"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Bottom of Form"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Normal (Web)"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Acronym"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Address"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Cite"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Code"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Definition"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Keyboard"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Preformatted"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Sample"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Typewriter"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="HTML Variable"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Normal Table"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="annotation subject"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="No List"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Outline List 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Outline List 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Outline List 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Simple 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Simple 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Simple 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Classic 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Classic 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Classic 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Classic 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Colorful 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Colorful 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Colorful 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Columns 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Columns 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Columns 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Columns 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Columns 5"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Grid 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Grid 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Grid 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Grid 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Grid 5"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Grid 6"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Grid 7"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Grid 8"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table List 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table List 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table List 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table List 4"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table List 5"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table List 6"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table List 7"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table List 8"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table 3D effects 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table 3D effects 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table 3D effects 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Contemporary"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Elegant"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Professional"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Subtle 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Subtle 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Web 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Web 2"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Web 3"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Balloon Text"
               />
               <w:LsdException Locked="false" Priority="39" Name="Table Grid" />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Table Theme"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  Name="Placeholder Text"
               />
               <w:LsdException
                  Locked="false"
                  Priority="1"
                  QFormat="true"
                  Name="No Spacing"
               />
               <w:LsdException
                  Locked="false"
                  Priority="60"
                  Name="Light Shading"
               />
               <w:LsdException Locked="false" Priority="61" Name="Light List" />
               <w:LsdException Locked="false" Priority="62" Name="Light Grid" />
               <w:LsdException
                  Locked="false"
                  Priority="63"
                  Name="Medium Shading 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="64"
                  Name="Medium Shading 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="65"
                  Name="Medium List 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="66"
                  Name="Medium List 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="67"
                  Name="Medium Grid 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="68"
                  Name="Medium Grid 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="69"
                  Name="Medium Grid 3"
               />
               <w:LsdException Locked="false" Priority="70" Name="Dark List" />
               <w:LsdException
                  Locked="false"
                  Priority="71"
                  Name="Colorful Shading"
               />
               <w:LsdException
                  Locked="false"
                  Priority="72"
                  Name="Colorful List"
               />
               <w:LsdException
                  Locked="false"
                  Priority="73"
                  Name="Colorful Grid"
               />
               <w:LsdException
                  Locked="false"
                  Priority="60"
                  Name="Light Shading Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="61"
                  Name="Light List Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="62"
                  Name="Light Grid Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="63"
                  Name="Medium Shading 1 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="64"
                  Name="Medium Shading 2 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="65"
                  Name="Medium List 1 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  Name="Revision"
               />
               <w:LsdException
                  Locked="false"
                  Priority="34"
                  QFormat="true"
                  Name="List Paragraph"
               />
               <w:LsdException
                  Locked="false"
                  Priority="29"
                  QFormat="true"
                  Name="Quote"
               />
               <w:LsdException
                  Locked="false"
                  Priority="30"
                  QFormat="true"
                  Name="Intense Quote"
               />
               <w:LsdException
                  Locked="false"
                  Priority="66"
                  Name="Medium List 2 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="67"
                  Name="Medium Grid 1 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="68"
                  Name="Medium Grid 2 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="69"
                  Name="Medium Grid 3 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="70"
                  Name="Dark List Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="71"
                  Name="Colorful Shading Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="72"
                  Name="Colorful List Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="73"
                  Name="Colorful Grid Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="60"
                  Name="Light Shading Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="61"
                  Name="Light List Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="62"
                  Name="Light Grid Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="63"
                  Name="Medium Shading 1 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="64"
                  Name="Medium Shading 2 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="65"
                  Name="Medium List 1 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="66"
                  Name="Medium List 2 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="67"
                  Name="Medium Grid 1 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="68"
                  Name="Medium Grid 2 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="69"
                  Name="Medium Grid 3 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="70"
                  Name="Dark List Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="71"
                  Name="Colorful Shading Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="72"
                  Name="Colorful List Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="73"
                  Name="Colorful Grid Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="60"
                  Name="Light Shading Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="61"
                  Name="Light List Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="62"
                  Name="Light Grid Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="63"
                  Name="Medium Shading 1 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="64"
                  Name="Medium Shading 2 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="65"
                  Name="Medium List 1 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="66"
                  Name="Medium List 2 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="67"
                  Name="Medium Grid 1 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="68"
                  Name="Medium Grid 2 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="69"
                  Name="Medium Grid 3 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="70"
                  Name="Dark List Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="71"
                  Name="Colorful Shading Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="72"
                  Name="Colorful List Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="73"
                  Name="Colorful Grid Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="60"
                  Name="Light Shading Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="61"
                  Name="Light List Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="62"
                  Name="Light Grid Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="63"
                  Name="Medium Shading 1 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="64"
                  Name="Medium Shading 2 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="65"
                  Name="Medium List 1 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="66"
                  Name="Medium List 2 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="67"
                  Name="Medium Grid 1 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="68"
                  Name="Medium Grid 2 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="69"
                  Name="Medium Grid 3 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="70"
                  Name="Dark List Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="71"
                  Name="Colorful Shading Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="72"
                  Name="Colorful List Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="73"
                  Name="Colorful Grid Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="60"
                  Name="Light Shading Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="61"
                  Name="Light List Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="62"
                  Name="Light Grid Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="63"
                  Name="Medium Shading 1 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="64"
                  Name="Medium Shading 2 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="65"
                  Name="Medium List 1 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="66"
                  Name="Medium List 2 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="67"
                  Name="Medium Grid 1 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="68"
                  Name="Medium Grid 2 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="69"
                  Name="Medium Grid 3 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="70"
                  Name="Dark List Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="71"
                  Name="Colorful Shading Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="72"
                  Name="Colorful List Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="73"
                  Name="Colorful Grid Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="60"
                  Name="Light Shading Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="61"
                  Name="Light List Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="62"
                  Name="Light Grid Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="63"
                  Name="Medium Shading 1 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="64"
                  Name="Medium Shading 2 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="65"
                  Name="Medium List 1 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="66"
                  Name="Medium List 2 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="67"
                  Name="Medium Grid 1 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="68"
                  Name="Medium Grid 2 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="69"
                  Name="Medium Grid 3 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="70"
                  Name="Dark List Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="71"
                  Name="Colorful Shading Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="72"
                  Name="Colorful List Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="73"
                  Name="Colorful Grid Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="19"
                  QFormat="true"
                  Name="Subtle Emphasis"
               />
               <w:LsdException
                  Locked="false"
                  Priority="21"
                  QFormat="true"
                  Name="Intense Emphasis"
               />
               <w:LsdException
                  Locked="false"
                  Priority="31"
                  QFormat="true"
                  Name="Subtle Reference"
               />
               <w:LsdException
                  Locked="false"
                  Priority="32"
                  QFormat="true"
                  Name="Intense Reference"
               />
               <w:LsdException
                  Locked="false"
                  Priority="33"
                  QFormat="true"
                  Name="Book Title"
               />
               <w:LsdException
                  Locked="false"
                  Priority="37"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Bibliography"
               />
               <w:LsdException
                  Locked="false"
                  Priority="39"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  QFormat="true"
                  Name="TOC Heading"
               />
               <w:LsdException
                  Locked="false"
                  Priority="41"
                  Name="Plain Table 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="42"
                  Name="Plain Table 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="43"
                  Name="Plain Table 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="44"
                  Name="Plain Table 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="45"
                  Name="Plain Table 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="40"
                  Name="Grid Table Light"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="Grid Table 1 Light"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="Grid Table 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="Grid Table 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="Grid Table 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="Grid Table 5 Dark"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="Grid Table 6 Colorful"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="Grid Table 7 Colorful"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="Grid Table 1 Light Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="Grid Table 2 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="Grid Table 3 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="Grid Table 4 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="Grid Table 5 Dark Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="Grid Table 6 Colorful Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="Grid Table 7 Colorful Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="Grid Table 1 Light Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="Grid Table 2 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="Grid Table 3 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="Grid Table 4 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="Grid Table 5 Dark Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="Grid Table 6 Colorful Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="Grid Table 7 Colorful Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="Grid Table 1 Light Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="Grid Table 2 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="Grid Table 3 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="Grid Table 4 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="Grid Table 5 Dark Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="Grid Table 6 Colorful Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="Grid Table 7 Colorful Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="Grid Table 1 Light Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="Grid Table 2 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="Grid Table 3 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="Grid Table 4 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="Grid Table 5 Dark Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="Grid Table 6 Colorful Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="Grid Table 7 Colorful Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="Grid Table 1 Light Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="Grid Table 2 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="Grid Table 3 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="Grid Table 4 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="Grid Table 5 Dark Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="Grid Table 6 Colorful Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="Grid Table 7 Colorful Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="Grid Table 1 Light Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="Grid Table 2 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="Grid Table 3 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="Grid Table 4 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="Grid Table 5 Dark Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="Grid Table 6 Colorful Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="Grid Table 7 Colorful Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="List Table 1 Light"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="List Table 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="List Table 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="List Table 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="List Table 5 Dark"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="List Table 6 Colorful"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="List Table 7 Colorful"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="List Table 1 Light Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="List Table 2 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="List Table 3 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="List Table 4 Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="List Table 5 Dark Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="List Table 6 Colorful Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="List Table 7 Colorful Accent 1"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="List Table 1 Light Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="List Table 2 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="List Table 3 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="List Table 4 Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="List Table 5 Dark Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="List Table 6 Colorful Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="List Table 7 Colorful Accent 2"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="List Table 1 Light Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="List Table 2 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="List Table 3 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="List Table 4 Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="List Table 5 Dark Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="List Table 6 Colorful Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="List Table 7 Colorful Accent 3"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="List Table 1 Light Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="List Table 2 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="List Table 3 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="List Table 4 Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="List Table 5 Dark Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="List Table 6 Colorful Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="List Table 7 Colorful Accent 4"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="List Table 1 Light Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="List Table 2 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="List Table 3 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="List Table 4 Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="List Table 5 Dark Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="List Table 6 Colorful Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="List Table 7 Colorful Accent 5"
               />
               <w:LsdException
                  Locked="false"
                  Priority="46"
                  Name="List Table 1 Light Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="47"
                  Name="List Table 2 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="48"
                  Name="List Table 3 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="49"
                  Name="List Table 4 Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="50"
                  Name="List Table 5 Dark Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="51"
                  Name="List Table 6 Colorful Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  Priority="52"
                  Name="List Table 7 Colorful Accent 6"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Mention"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Smart Hyperlink"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Hashtag"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Unresolved Mention"
               />
               <w:LsdException
                  Locked="false"
                  SemiHidden="true"
                  UnhideWhenUsed="true"
                  Name="Smart Link"
               />
            </w:LatentStyles> </xml
      ><![endif]-->
      <![if !supportAnnotations]>
      <style id="dynCom" type="text/css">
         <!-- -->
      </style>
      <script language="JavaScript">
         <!--
         function msoCommentShow(anchor_id, com_id) {
            if (msoBrowserCheck()) {
               c = document.all(com_id);
               a = document.all(anchor_id);
               if (
                  null != c &&
                  null == c.length &&
                  null != a &&
                  null == a.length
               ) {
                  var cw = c.offsetWidth;
                  var ch = c.offsetHeight;
                  var aw = a.offsetWidth;
                  var ah = a.offsetHeight;
                  var x = a.offsetLeft;
                  var y = a.offsetTop;
                  var el = a;
                  while (el.tagName != "BODY") {
                     el = el.offsetParent;
                     x = x + el.offsetLeft;
                     y = y + el.offsetTop;
                  }
                  var bw = document.body.clientWidth;
                  var bh = document.body.clientHeight;
                  var bsl = document.body.scrollLeft;
                  var bst = document.body.scrollTop;
                  if (
                     x + cw + ah / 2 > bw + bsl &&
                     x + aw - ah / 2 - cw >= bsl
                  ) {
                     c.style.left = x + aw - ah / 2 - cw;
                  } else {
                     c.style.left = x + ah / 2;
                  }
                  if (y + ch + ah / 2 > bh + bst && y + ah / 2 - ch >= bst) {
                     c.style.top = y + ah / 2 - ch;
                  } else {
                     c.style.top = y + ah / 2;
                  }
                  c.style.visibility = "visible";
               }
            }
         }
         function msoCommentHide(com_id) {
            if (msoBrowserCheck()) {
               c = document.all(com_id);
               if (null != c && null == c.length) {
                  c.style.visibility = "hidden";
                  c.style.left = -1000;
                  c.style.top = -1000;
               }
            }
         }
         function msoBrowserCheck() {
            ms = navigator.appVersion.indexOf("MSIE");
            vers = navigator.appVersion.substring(ms + 5, ms + 6);
            ie4 = ms > 0 && parseInt(vers) >= 4;
            return ie4;
         }
         if (msoBrowserCheck()) {
            document.styleSheets.dynCom.addRule(
               ".msocomanchor",
               "background: infobackground"
            );
            document.styleSheets.dynCom.addRule(".msocomoff", "display: none");
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "visibility: hidden"
            );
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "position: absolute"
            );
            document.styleSheets.dynCom.addRule(".msocomtxt", "top: -1000");
            document.styleSheets.dynCom.addRule(".msocomtxt", "left: -1000");
            document.styleSheets.dynCom.addRule(".msocomtxt", "width: 33%");
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "background: infobackground"
            );
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "color: infotext"
            );
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "border-top: 1pt solid threedlightshadow"
            );
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "border-right: 2pt solid threedshadow"
            );
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "border-bottom: 2pt solid threedshadow"
            );
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "border-left: 1pt solid threedlightshadow"
            );
            document.styleSheets.dynCom.addRule(
               ".msocomtxt",
               "padding: 3pt 3pt 3pt 3pt"
            );
            document.styleSheets.dynCom.addRule(".msocomtxt", "z-index: 100");
         }
         // -->
      </script>
      <![endif]>
      <style>
         <!--
          /* Font Definitions */
          @font-face
         	{font-family:"Cambria Math";
         	panose-1:2 4 5 3 5 4 6 3 2 4;
         	mso-font-charset:0;
         	mso-generic-font-family:roman;
         	mso-font-pitch:variable;
         	mso-font-signature:-536870145 1107305727 0 0 415 0;}
         @font-face
         	{font-family:"Arial Unicode MS";
         	panose-1:2 11 6 4 2 2 2 2 2 4;
         	mso-font-charset:128;
         	mso-generic-font-family:swiss;
         	mso-font-pitch:variable;
         	mso-font-signature:-134238209 -371195905 63 0 4129279 0;}
         @font-face
         	{font-family:"맑은 고딕";
         	panose-1:2 11 5 3 2 0 0 2 0 4;
         	mso-font-charset:129;
         	mso-generic-font-family:swiss;
         	mso-font-pitch:variable;
         	mso-font-signature:-1879048145 701988091 18 0 524289 0;}
         @font-face
         	{font-family:"IBM Plex Sans KR";
         	mso-font-charset:0;
         	mso-generic-font-family:auto;
         	mso-font-pitch:auto;
         	mso-font-signature:0 0 0 0 0 0;}
         @font-face
         	{font-family:"\@맑은 고딕";
         	mso-font-charset:129;
         	mso-generic-font-family:swiss;
         	mso-font-pitch:variable;
         	mso-font-signature:-1879048145 701988091 18 0 524289 0;}
         @font-face
         	{font-family:"\@Arial Unicode MS";
         	panose-1:2 11 6 4 2 2 2 2 2 4;
         	mso-font-charset:128;
         	mso-generic-font-family:swiss;
         	mso-font-pitch:variable;
         	mso-font-signature:-134238209 -371195905 63 0 4129279 0;}
          /* Style Definitions */
          p.MsoNormal, li.MsoNormal, div.MsoNormal
         	{mso-style-unhide:no;
         	mso-style-qformat:yes;
         	mso-style-parent:"";
         	margin:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan;
         	font-size:11.0pt;
         	font-family:"Arial",sans-serif;
         	mso-fareast-font-family:"맑은 고딕";
         	mso-fareast-theme-font:minor-fareast;
         	mso-ansi-language:#0012;}
         h1
         	{mso-style-priority:9;
         	mso-style-unhide:no;
         	mso-style-qformat:yes;
         	mso-style-next:표준;
         	margin-top:20.0pt;
         	margin-right:0cm;
         	margin-bottom:6.0pt;
         	margin-left:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan lines-together;
         	page-break-after:avoid;
         	mso-outline-level:1;
         	font-size:20.0pt;
         	font-family:"Arial",sans-serif;
         	mso-font-kerning:0pt;
         	mso-ansi-language:#0012;
         	font-weight:normal;}
         h2
         	{mso-style-noshow:yes;
         	mso-style-priority:9;
         	mso-style-qformat:yes;
         	mso-style-next:표준;
         	margin-top:18.0pt;
         	margin-right:0cm;
         	margin-bottom:6.0pt;
         	margin-left:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan lines-together;
         	page-break-after:avoid;
         	mso-outline-level:2;
         	font-size:16.0pt;
         	font-family:"Arial",sans-serif;
         	mso-ansi-language:#0012;
         	font-weight:normal;}
         h3
         	{mso-style-noshow:yes;
         	mso-style-priority:9;
         	mso-style-qformat:yes;
         	mso-style-next:표준;
         	margin-top:16.0pt;
         	margin-right:0cm;
         	margin-bottom:4.0pt;
         	margin-left:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan lines-together;
         	page-break-after:avoid;
         	mso-outline-level:3;
         	font-size:14.0pt;
         	font-family:"Arial",sans-serif;
         	color:#434343;
         	mso-ansi-language:#0012;
         	font-weight:normal;}
         h4
         	{mso-style-noshow:yes;
         	mso-style-priority:9;
         	mso-style-qformat:yes;
         	mso-style-next:표준;
         	margin-top:14.0pt;
         	margin-right:0cm;
         	margin-bottom:4.0pt;
         	margin-left:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan lines-together;
         	page-break-after:avoid;
         	mso-outline-level:4;
         	font-size:12.0pt;
         	font-family:"Arial",sans-serif;
         	color:#666666;
         	mso-ansi-language:#0012;
         	font-weight:normal;}
         h5
         	{mso-style-noshow:yes;
         	mso-style-priority:9;
         	mso-style-qformat:yes;
         	mso-style-next:표준;
         	margin-top:12.0pt;
         	margin-right:0cm;
         	margin-bottom:4.0pt;
         	margin-left:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan lines-together;
         	page-break-after:avoid;
         	mso-outline-level:5;
         	font-size:11.0pt;
         	font-family:"Arial",sans-serif;
         	color:#666666;
         	mso-ansi-language:#0012;
         	font-weight:normal;}
         h6
         	{mso-style-noshow:yes;
         	mso-style-priority:9;
         	mso-style-qformat:yes;
         	mso-style-next:표준;
         	margin-top:12.0pt;
         	margin-right:0cm;
         	margin-bottom:4.0pt;
         	margin-left:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan lines-together;
         	page-break-after:avoid;
         	mso-outline-level:6;
         	font-size:11.0pt;
         	font-family:"Arial",sans-serif;
         	color:#666666;
         	mso-ansi-language:#0012;
         	font-weight:normal;
         	font-style:italic;
         	mso-bidi-font-style:normal;}
         p.MsoCommentText, li.MsoCommentText, div.MsoCommentText
         	{mso-style-noshow:yes;
         	mso-style-priority:99;
         	mso-style-link:"메모 텍스트 Char";
         	margin:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan;
         	font-size:11.0pt;
         	font-family:"Arial",sans-serif;
         	mso-fareast-font-family:"맑은 고딕";
         	mso-fareast-theme-font:minor-fareast;
         	mso-ansi-language:#0012;}
         span.MsoCommentReference
         	{mso-style-noshow:yes;
         	mso-style-priority:99;
         	mso-ansi-font-size:9.0pt;
         	mso-bidi-font-size:9.0pt;}
         p.MsoTitle, li.MsoTitle, div.MsoTitle
         	{mso-style-priority:10;
         	mso-style-unhide:no;
         	mso-style-qformat:yes;
         	mso-style-next:표준;
         	margin-top:0cm;
         	margin-right:0cm;
         	margin-bottom:3.0pt;
         	margin-left:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan lines-together;
         	page-break-after:avoid;
         	font-size:26.0pt;
         	font-family:"Arial",sans-serif;
         	mso-fareast-font-family:"맑은 고딕";
         	mso-fareast-theme-font:minor-fareast;
         	mso-ansi-language:#0012;}
         p.MsoSubtitle, li.MsoSubtitle, div.MsoSubtitle
         	{mso-style-priority:11;
         	mso-style-unhide:no;
         	mso-style-qformat:yes;
         	mso-style-next:표준;
         	margin-top:0cm;
         	margin-right:0cm;
         	margin-bottom:16.0pt;
         	margin-left:0cm;
         	line-height:115%;
         	mso-pagination:widow-orphan lines-together;
         	page-break-after:avoid;
         	font-size:15.0pt;
         	font-family:"Arial",sans-serif;
         	mso-fareast-font-family:Arial;
         	color:#666666;
         	mso-ansi-language:#0012;}
         span.Char
         	{mso-style-name:"메모 텍스트 Char";
         	mso-style-noshow:yes;
         	mso-style-priority:99;
         	mso-style-unhide:no;
         	mso-style-locked:yes;
         	mso-style-link:"메모 텍스트";}
         span.SpellE
         	{mso-style-name:"";
         	mso-spl-e:yes;}
         .MsoChpDefault
         	{mso-style-type:export-only;
         	mso-default-props:yes;
         	font-size:11.0pt;
         	mso-ansi-font-size:11.0pt;
         	mso-bidi-font-size:11.0pt;
         	mso-ascii-font-family:Arial;
         	mso-hansi-font-family:Arial;
         	mso-bidi-font-family:Arial;
         	mso-font-kerning:0pt;
         	mso-ligatures:none;
         	mso-ansi-language:#0012;}
         .MsoPapDefault
         	{mso-style-type:export-only;
         	line-height:115%;}
          /* Page Definitions */
          @page
         	{mso-page-border-surround-header:no;
         	mso-page-border-surround-footer:no;}
         @page WordSection1
         	{size:595.45pt 841.7pt;
         	margin:72.0pt 72.0pt 72.0pt 72.0pt;
         	mso-header-margin:36.0pt;
         	mso-footer-margin:36.0pt;
         	mso-page-numbers:1;
         	mso-paper-source:0;}
         div.WordSection1
         	{page:WordSection1;}
         -->
      </style>
      <!--[if gte mso 10]>
         <style>
            /* Style Definitions */
            table.MsoNormalTable {
               mso-style-name: "표준 표";
               mso-tstyle-rowband-size: 0;
               mso-tstyle-colband-size: 0;
               mso-style-noshow: yes;
               mso-style-priority: 99;
               mso-style-parent: "";
               mso-padding-alt: 0cm 5.4pt 0cm 5.4pt;
               mso-para-margin: 0cm;
               line-height: 115%;
               mso-pagination: widow-orphan;
               font-size: 11pt;
               font-family: "Arial", sans-serif;
               mso-ansi-language: #0012;
            }
            table.TableNormal {
               mso-style-name: "Table Normal";
               mso-tstyle-rowband-size: 0;
               mso-tstyle-colband-size: 0;
               mso-style-unhide: no;
               mso-style-parent: "";
               mso-padding-alt: 0cm 0cm 0cm 0cm;
               mso-para-margin: 0cm;
               line-height: 115%;
               mso-pagination: widow-orphan;
               font-size: 11pt;
               font-family: "Arial", sans-serif;
               mso-ansi-language: #0012;
            }
            table.a {
               mso-style-name: "";
               mso-tstyle-rowband-size: 1;
               mso-tstyle-colband-size: 1;
               mso-style-unhide: no;
               mso-style-parent: "Table Normal";
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-para-margin: 0cm;
               line-height: 115%;
               mso-pagination: widow-orphan;
               font-size: 11pt;
               font-family: "Arial", sans-serif;
               mso-ansi-language: #0012;
            }
            table.a0 {
               mso-style-name: "";
               mso-tstyle-rowband-size: 1;
               mso-tstyle-colband-size: 1;
               mso-style-unhide: no;
               mso-style-parent: "Table Normal";
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-para-margin: 0cm;
               line-height: 115%;
               mso-pagination: widow-orphan;
               font-size: 11pt;
               font-family: "Arial", sans-serif;
               mso-ansi-language: #0012;
            }
            table.a1 {
               mso-style-name: "";
               mso-tstyle-rowband-size: 1;
               mso-tstyle-colband-size: 1;
               mso-style-unhide: no;
               mso-style-parent: "Table Normal";
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-para-margin: 0cm;
               line-height: 115%;
               mso-pagination: widow-orphan;
               font-size: 11pt;
               font-family: "Arial", sans-serif;
               mso-ansi-language: #0012;
            }
            table.a2 {
               mso-style-name: "";
               mso-tstyle-rowband-size: 1;
               mso-tstyle-colband-size: 1;
               mso-style-unhide: no;
               mso-style-parent: "Table Normal";
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-para-margin: 0cm;
               line-height: 115%;
               mso-pagination: widow-orphan;
               font-size: 11pt;
               font-family: "Arial", sans-serif;
               mso-ansi-language: #0012;
            }
            table.a3 {
               mso-style-name: "";
               mso-tstyle-rowband-size: 1;
               mso-tstyle-colband-size: 1;
               mso-style-unhide: no;
               mso-style-parent: "Table Normal";
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-para-margin: 0cm;
               line-height: 115%;
               mso-pagination: widow-orphan;
               font-size: 11pt;
               font-family: "Arial", sans-serif;
               mso-ansi-language: #0012;
            }
         </style>
      <![endif]-->
   </head>

   <body lang="KO" style="tab-interval: 36pt; word-wrap: break-word">
      <div class="WordSection1">
         <p
            class="MsoNormal"
            align="center"
            style="text-align: center; background: white"
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-size: 14pt;
                     line-height: 115%;
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >’</span
               ></b
            ><span class="SpellE"
               ><b style="mso-bidi-font-weight: normal"
                  ><span
                     style="
                        font-size: 14pt;
                        line-height: 115%;
                        font-family: 'IBM Plex Sans KR';
                        mso-fareast-font-family: 'IBM Plex Sans KR';
                        mso-bidi-font-family: 'IBM Plex Sans KR';
                        color: black;
                        mso-color-alt: windowtext;
                     "
                     >쯩</span
                  ></b
               ></span
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-size: 14pt;
                     line-height: 115%;
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
               >
                  <span class="SpellE">for</span>
               </span></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-size: 14pt;
                     line-height: 115%;
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >공공기관<span lang="ko">’ </span>개인정보 처리방침</span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-size: 14pt;
                     line-height: 115%;
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            align="center"
            style="text-align: center; background: white"
         >
            <span
               lang="ko"
               style="
                  font-size: 10.5pt;
                  line-height: 115%;
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: #1919ff;
               "
               ><span style="mso-spacerun: yes"> </span><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >1. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 처리 목적 및 보유기간</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >2. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 제<span lang="ko">3</span>자 제공에 관한 사항</span
            ><s
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></s>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >3. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 위탁</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >4. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 파기</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >5. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보의 안전성 확보조치에 관한 사항</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >6. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 자동 수집 장치의 설치 및 운영 및 그 거부에 관한
               사항</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >7.<span style="mso-spacerun: yes">  </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 보호업무 및 관련 고충 문의</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >8. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >권익침해 구제방법</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >9. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 처리방침 변경에 관한 사항</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >본 개인정보처리방침은 <span class="SpellE">파라메타</span
               ><span lang="ko">(</span>이하<span lang="ko"> ‘</span>회사<span
                  lang="ko"
                  >’)</span
               >의 웹사이트<span lang="ko">, </span>모바일 앱 등에서 처리되는
               정보에 대해 설명합니다<span lang="ko">. </span>회사는<span
                  lang="ko"
               >
                  ‘</span
               >이용자의 동의<span lang="ko">’</span
               ><span class="SpellE">를</span> 기반으로 개인정보를 처리하고
               있으며 관련 국내<span lang="ko">/</span>외 법령 및 기타
               개인정보보호 관련 가이드라인을 준수하고 있습니다<span lang="ko"
                  >.</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >1. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 처리 목적 및 보유기간</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <table
            class="a"
            border="1"
            cellspacing="0"
            cellpadding="0"
            width="602"
            style="
               border-collapse: collapse;
               mso-table-layout-alt: fixed;
               border: none;
               mso-border-alt: solid black 1pt;
               mso-yfti-tbllook: 1536;
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-border-insideh: 1pt solid black;
               mso-border-insidev: 1pt solid black;
            "
         >
            <tr style="mso-yfti-irow: 0; mso-yfti-firstrow: yes">
               <td
                  width="124"
                  valign="top"
                  style="
                     width: 93pt;
                     border: solid black 1pt;
                     background: #d9d9d9;
                     padding: 5pt 5pt 5pt 5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; line-height: 162%"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >서비스</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="122"
                  valign="top"
                  style="
                     width: 91.5pt;
                     border: solid black 1pt;
                     border-left: none;
                     mso-border-left-alt: solid black 1pt;
                     background: #d9d9d9;
                     padding: 5pt 5pt 5pt 5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; line-height: 162%"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >수집<span lang="ko">·</span>이용 목적</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="204"
                  valign="top"
                  style="
                     width: 153pt;
                     border: solid black 1pt;
                     border-left: none;
                     background: #d9d9d9;
                     padding: 5pt 5pt 5pt 5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; line-height: 162%"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >수집<span lang="ko">·</span>이용<span lang="ko"
                              ><span style="mso-spacerun: yes">  </span></span
                           >항목</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="152"
                  valign="top"
                  style="
                     width: 114pt;
                     border: solid black 1pt;
                     border-left: none;
                     background: #d9d9d9;
                     padding: 5pt 5pt 5pt 5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; line-height: 162%"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >보유 기간</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 1; height: 19.5pt">
               <td
                  width="124"
                  valign="top"
                  style="
                     width: 93pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 19.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <span class="SpellE"
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                              "
                              >온보딩</span
                           ></b
                        ></span
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                        >
                           시<span lang="ko"><o:p></o:p></span></span
                     ></b>
                  </p>
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p>&nbsp;</o:p></span
                        ></b
                     >
                  </p>
               </td>
               <td
                  width="122"
                  valign="top"
                  style="
                     width: 91.5pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 19.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >만<span lang="ko"> 14</span>세 미만<span lang="ko"
                           ><o:p></o:p></span
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >여부 확인<span lang="ko"><o:p></o:p></span
                     ></span>
                  </p>
               </td>
               <td
                  width="204"
                  valign="top"
                  style="
                     width: 153pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 19.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >(</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >필수<span lang="ko">)<o:p></o:p></span
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >본인 정보<span lang="ko">(</span>이름<span lang="ko"
                           >, </span
                        >생년월일<span lang="ko">, </span>성별<span lang="ko"
                           >, </span
                        >통신사<span lang="ko">, </span>전화번호<span lang="ko"
                           >, CI, </span
                        >내<span lang="ko">/</span>외국인<span lang="ko"
                           >)<o:p></o:p></span
                     ></span>
                  </p>
               </td>
               <td
                  width="152"
                  valign="top"
                  style="
                     width: 114pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 19.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >만<span lang="ko"> 14</span>세 미만 여부<span lang="ko"
                           ><o:p></o:p></span
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >확인 후 즉시 파기하며<span lang="ko">, </span>정보를
                        저장하지 않음<span lang="ko"><o:p></o:p></span
                     ></span>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 2; height: 19.5pt">
               <td
                  width="124"
                  valign="top"
                  style="
                     width: 93pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 19.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >휴대폰 본인 확인<span lang="ko"
                              ><o:p></o:p></span></span
                     ></b>
                  </p>
               </td>
               <td
                  width="122"
                  valign="top"
                  style="
                     width: 91.5pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 19.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >휴대폰 본인확인<span lang="ko"><o:p></o:p></span
                     ></span>
                  </p>
               </td>
               <td
                  width="204"
                  valign="top"
                  style="
                     width: 153pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 19.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >(</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >필수<span lang="ko">) </span>이름<span lang="ko"
                           >, </span
                        >생년월일<span lang="ko">, </span>성별<span lang="ko"
                           >, </span
                        >통신사<span lang="ko">, </span>전화번호<span lang="ko"
                           >, CI, </span
                        >내<span lang="ko">/</span>외국인<span lang="ko"
                           ><o:p></o:p></span
                     ></span>
                  </p>
               </td>
               <td
                  width="152"
                  valign="top"
                  style="
                     width: 114pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 19.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >통신사 중개 업체에 제공함<span lang="ko"
                           ><br />
                           - </span
                        >사용자 휴대폰 본인인증 파기 혹은 앱 탈퇴 시 정보
                        삭제<span lang="ko"><o:p></o:p></span
                     ></span>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 3; height: 18.5pt">
               <td
                  width="124"
                  valign="top"
                  style="
                     width: 93pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 18.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >운전면허인증<span lang="ko"><o:p></o:p></span></span
                     ></b>
                  </p>
               </td>
               <td
                  width="122"
                  valign="top"
                  style="
                     width: 91.5pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 18.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >운전면허증<span lang="ko"><br /> </span>위<span
                           lang="ko"
                           >·</span
                        >변조 판별<span lang="ko"><o:p></o:p></span
                     ></span>
                  </p>
               </td>
               <td
                  width="204"
                  valign="top"
                  style="
                     width: 153pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 18.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >(</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >필수<span lang="ko">) </span>운전면허증<span lang="ko">
                           OCR </span
                        >정보<span lang="ko"><o:p></o:p></span
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >(</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >이름<span lang="ko">, </span>생년월일<span lang="ko"
                           >, </span
                        >운전면허번호<span lang="ko">, </span>운전면허
                        일련번호<span lang="ko">, </span>운전면허증
                        <span class="SpellE">촬영이미지</span
                        ><span lang="ko">)<o:p></o:p></span
                     ></span>
                  </p>
               </td>
               <td
                  width="152"
                  valign="top"
                  style="
                     width: 114pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 18.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >- API </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >중개 업체에 제공함<span lang="ko"
                           ><br />
                           - </span
                        >사용자 운전면허인증 파기 혹은 앱 탈퇴 시 정보 삭제<span
                           lang="ko"
                           ><o:p></o:p></span
                     ></span>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 4; mso-yfti-lastrow: yes; height: 18.5pt">
               <td
                  width="124"
                  valign="top"
                  style="
                     width: 93pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 18.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >여권</span
                        ></b
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="122"
                  valign="top"
                  style="
                     width: 91.5pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 18.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >여권 위<span lang="ko">·</span>변조 판별<span lang="ko"
                           ><o:p></o:p></span
                     ></span>
                  </p>
               </td>
               <td
                  width="204"
                  valign="top"
                  style="
                     width: 153pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 18.5pt;
                  "
               >
                  <p class="MsoNormal" style="line-height: normal">
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >(</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >필수<span lang="ko">) </span>여권<span lang="ko">
                           MRZ </span
                        >정보<span lang="ko"><o:p></o:p></span
                     ></span>
                  </p>
                  <p class="MsoNormal" style="line-height: normal">
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >(</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >여권종류<span lang="ko">, </span>영문성명<span
                           lang="ko"
                           >, </span
                        >발행국가<span lang="ko">, </span>국적<span lang="ko"
                           >, </span
                        >성별<span lang="ko">, </span>기간만료일<span lang="ko"
                           >, </span
                        >생년월일<span lang="ko">, </span>여권번호<span
                           lang="ko"
                           >)<o:p></o:p></span
                     ></span>
                  </p>
               </td>
               <td
                  width="152"
                  valign="top"
                  style="
                     width: 114pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid black 1pt;
                     mso-border-left-alt: solid black 1pt;
                     padding: 5pt 5pt 5pt 5pt;
                     height: 18.5pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="line-height: normal; mso-pagination: none"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >- API </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >중개 업체에 제공함<span lang="ko"
                           ><br />
                           - </span
                        >사용자 여권 파기 혹은 앱 탈퇴 시 정보 삭제<span
                           lang="ko"
                           ><o:p></o:p></span
                     ></span>
                  </p>
               </td>
            </tr>
         </table>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p>&nbsp;</o:p></span
            >
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p>&nbsp;</o:p></span
            >
         </p>

         <p
            class="MsoNormal"
            style="text-align: justify; text-justify: inter-ideograph"
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               >서비스 제공 시 앱에서 아래와 같은 접근권한을 요구합니다<span
                  lang="ko"
                  >. <o:p></o:p></span
            ></span>
         </p>

         <div align="center">
            <table
               class="a0"
               border="1"
               cellspacing="0"
               cellpadding="0"
               width="603"
               style="
                  border-collapse: collapse;
                  mso-table-layout-alt: fixed;
                  border: none;
                  mso-border-alt: solid black 1pt;
                  mso-yfti-tbllook: 1536;
                  mso-padding-alt: 5pt 5pt 5pt 5pt;
                  mso-border-insideh: 1pt solid black;
                  mso-border-insidev: 1pt solid black;
               "
            >
               <tr
                  style="
                     mso-yfti-irow: 0;
                     mso-yfti-firstrow: yes;
                     height: 22.5pt;
                  "
               >
                  <td
                     width="170"
                     style="
                        width: 127.5pt;
                        border: solid black 1pt;
                        background: #d9d9d9;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 22.5pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center"
                     >
                        <b style="mso-bidi-font-weight: normal"
                           ><span
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                                 color: black;
                                 mso-color-alt: windowtext;
                              "
                              >앱 접근권한</span
                           ></b
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              lang="ko"
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                              "
                              ><o:p></o:p></span
                        ></b>
                     </p>
                  </td>
                  <td
                     width="110"
                     style="
                        width: 82.5pt;
                        border: solid black 1pt;
                        border-left: none;
                        mso-border-left-alt: solid black 1pt;
                        background: #d9d9d9;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 22.5pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center"
                     >
                        <b style="mso-bidi-font-weight: normal"
                           ><span
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                                 color: black;
                                 mso-color-alt: windowtext;
                              "
                              >이용근거</span
                           ></b
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              lang="ko"
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                              "
                              ><o:p></o:p></span
                        ></b>
                     </p>
                  </td>
                  <td
                     width="175"
                     style="
                        width: 131.25pt;
                        border: solid black 1pt;
                        border-left: none;
                        mso-border-left-alt: solid black 1pt;
                        background: #d9d9d9;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 22.5pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center"
                     >
                        <b style="mso-bidi-font-weight: normal"
                           ><span
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                                 color: black;
                                 mso-color-alt: windowtext;
                              "
                              >이용목적</span
                           ></b
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              lang="ko"
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                              "
                              ><o:p></o:p></span
                        ></b>
                     </p>
                  </td>
                  <td
                     width="148"
                     style="
                        width: 111pt;
                        border: solid black 1pt;
                        border-left: none;
                        mso-border-left-alt: solid black 1pt;
                        background: #d9d9d9;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 22.5pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center"
                     >
                        <b style="mso-bidi-font-weight: normal"
                           ><span
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                                 color: black;
                                 mso-color-alt: windowtext;
                              "
                              >이용기간</span
                           ></b
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              lang="ko"
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                              "
                              ><o:p></o:p></span
                        ></b>
                     </p>
                  </td>
               </tr>
               <tr style="mso-yfti-irow: 1; height: 49.35pt">
                  <td
                     width="170"
                     style="
                        width: 127.5pt;
                        border: solid black 1pt;
                        border-top: none;
                        mso-border-top-alt: solid black 1pt;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 49.35pt;
                     "
                  >
                     <p class="MsoNormal">
                        <span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >CAMERA (</span
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >필수<span lang="ko">) <o:p></o:p></span
                        ></span>
                     </p>
                  </td>
                  <td
                     width="110"
                     style="
                        width: 82.5pt;
                        border-top: none;
                        border-left: none;
                        border-bottom: solid black 1pt;
                        border-right: solid black 1pt;
                        mso-border-top-alt: solid black 1pt;
                        mso-border-left-alt: solid black 1pt;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 49.35pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >정보주체의 동의<span lang="ko"><o:p></o:p></span
                        ></span>
                     </p>
                  </td>
                  <td
                     width="175"
                     style="
                        width: 131.25pt;
                        border-top: none;
                        border-left: none;
                        border-bottom: solid black 1pt;
                        border-right: solid black 1pt;
                        mso-border-top-alt: solid black 1pt;
                        mso-border-left-alt: solid black 1pt;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 49.35pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >QR</span
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >코드 촬영<span lang="ko">, </span>신분증 촬영<span
                              lang="ko"
                              ><o:p></o:p></span
                        ></span>
                     </p>
                  </td>
                  <td
                     width="148"
                     style="
                        width: 111pt;
                        border-top: none;
                        border-left: none;
                        border-bottom: solid black 1pt;
                        border-right: solid black 1pt;
                        mso-border-top-alt: solid black 1pt;
                        mso-border-left-alt: solid black 1pt;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 49.35pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >앱 실행 시<span lang="ko"><o:p></o:p></span
                        ></span>
                     </p>
                  </td>
               </tr>
               <tr
                  style="
                     mso-yfti-irow: 2;
                     mso-yfti-lastrow: yes;
                     height: 49.35pt;
                  "
               >
                  <td
                     width="170"
                     style="
                        width: 127.5pt;
                        border: solid black 1pt;
                        border-top: none;
                        mso-border-top-alt: solid black 1pt;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 49.35pt;
                     "
                  >
                     <p class="MsoNormal">
                        <span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >BLUETOOTH (</span
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >선택<span lang="ko">)<o:p></o:p></span
                        ></span>
                     </p>
                  </td>
                  <td
                     width="110"
                     style="
                        width: 82.5pt;
                        border-top: none;
                        border-left: none;
                        border-bottom: solid black 1pt;
                        border-right: solid black 1pt;
                        mso-border-top-alt: solid black 1pt;
                        mso-border-left-alt: solid black 1pt;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 49.35pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >정보주체의 동의<span lang="ko"><o:p></o:p></span
                        ></span>
                     </p>
                  </td>
                  <td
                     width="175"
                     style="
                        width: 131.25pt;
                        border-top: none;
                        border-left: none;
                        border-bottom: solid black 1pt;
                        border-right: solid black 1pt;
                        mso-border-top-alt: solid black 1pt;
                        mso-border-left-alt: solid black 1pt;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 49.35pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >블루투스 연결<span lang="ko"><o:p></o:p></span
                        ></span>
                     </p>
                  </td>
                  <td
                     width="148"
                     style="
                        width: 111pt;
                        border-top: none;
                        border-left: none;
                        border-bottom: solid black 1pt;
                        border-right: solid black 1pt;
                        mso-border-top-alt: solid black 1pt;
                        mso-border-left-alt: solid black 1pt;
                        padding: 0cm 4pt 0cm 4pt;
                        height: 49.35pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           >블루투스 권한 허용 시<span lang="ko"
                              ><o:p></o:p></span
                        ></span>
                     </p>
                  </td>
               </tr>
            </table>
         </div>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p>&nbsp;</o:p></span
            >
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >개인정보를 수집하는 방법은 다음과 같습니다<span lang="ko"
                     >.</span
                  ></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >회사는 개인정보 수집 시 반드시 이용자에게 해당 사실을 알리고
               동의를 구하고 있으며<span lang="ko">, </span>아래와 같은 방법으로
               수집합니다<span lang="ko">.</span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >회원가입 및 서비스 이용 과정에서 이용자가 개인정보 수집에 대해
               동의를 하고 직접 정보를 입력하는 경우</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >제휴 서비스 또는 단체 등으로부터 개인정보를 제공받은 경우</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >고객센터를 통한 상담 과정에서 웹페이지<span lang="ko">, </span
               >메일<span lang="ko">, </span>전화 등으로 이용자가 직접 제공하는
               경우</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >온<span lang="ko">·</span>오프라인에서 진행되는 이벤트<span
                  lang="ko"
                  >/</span
               >행사 등 참여</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 14pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >서비스 이용 과정에서 자동 생성된 정보를 이용자로부터 수집할
                  수 있습니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >PC</span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >웹<span lang="ko">, </span>모바일 웹 이용 과정에서
               단말기정보<span lang="ko">(OS, </span>화면사이즈<span lang="ko"
                  >, </span
               >디바이스 아이디<span lang="ko">), IP</span>주소<span lang="ko"
                  >, </span
               >쿠키<span lang="ko">, </span>방문일시<span lang="ko">, </span
               >부정이용기록<span lang="ko">, </span>서비스 이용 기록 등의
               정보가 자동으로 생성되어 수집될 수 있습니다<span lang="ko"
                  >.</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >수집한 개인정보는 회사의 서비스 제공 등 이용자가 요청한
                  목적을 위해 이용합니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >회사는 개인정보 보호 관련 법령 및<span lang="ko"> GDPR </span>등
               각 회원국의 법률을 준수를 위하여 필요한 최소한의 목적으로
               이용자의 정보를 이용합니다<span lang="ko">.</span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >이용자의 회원가입 및 서비스 이용 과정에서 수집한 정보를 아래와
               같은 서비스를 제공하기 위해 이용합니다<span lang="ko"
                  >.</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >회원 식별<span lang="ko">/</span>가입의사 확인<span lang="ko"
                  >, </span
               >부정이용 방지</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >신규 서비스 개발<span lang="ko">, </span>다양한 서비스 제공<span
                  lang="ko"
                  >, </span
               >문의사항 또는 불만처리</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >서비스 이용 기록<span lang="ko">, </span>접속 빈도 및 서비스
               이용에 대한 통계<span lang="ko">, </span>프라이버시 보호 측면의
               서비스 환경 구축<span lang="ko">, </span>맞춤형 서비스<span
                  lang="ko"
                  >, </span
               >서비스 개선에 활용</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >준거법 또는 법적 의무의 준수</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >공익적 직무의 실행을 위하여 처리가 필요한 경우 또는 회사에게
               부여된 공적 권한의 행사에 처리가 필요한 경우</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 55pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -13pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >-<span style="mso-spacerun: yes">   </span
               ><span style="mso-tab-count: 1"> </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >회사나 제<span lang="ko">3</span>자가 추구하는 정당한 이익
               목적을 위하여 처리가 필요한 경우<span lang="ko"> (</span
               >다만<span lang="ko">, </span>특히 이용자가 아동인 경우와 같이
               개인정보 보호를 요구하는 이용자의 이익이나 기본권과 자유가 해당
               이익에 우선하는 경우에는 그러하지 아니함<span lang="ko"
                  >)</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >2. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 제<span lang="ko">3</span>자 제공에 관한 사항</span
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >이용자의 별도 동의가 있는 경우나 법령에 규정된 경우를
                  제외하고는 이용자의 개인정보를
                  <a
                     style="
                        mso-comment-reference: _1;
                        mso-comment-date: 20240814T0500;
                     "
                     >제<span lang="ko">2</span>자</a
                  ></span
               ></b
            ><span lang="ko" style="color: black; mso-color-alt: windowtext"
               ><![if !supportAnnotations]><a
                  class="msocomanchor"
                  id="_anchor_1"
                  onmouseover="msoCommentShow('_anchor_1','_com_1')"
                  onmouseout="msoCommentHide('_com_1')"
                  href="#_msocom_1"
                  language="JavaScript"
                  name="_msoanchor_1"
                  >[1]</a
               ><![endif]><span style="mso-special-character: comment"
                  >&nbsp;</span
               ></span
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >에게 제공하지 않습니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p>&nbsp;</o:p></span
               ></b
            >
         </p>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >3. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 위탁</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >회사는 편리하고 더 나은 서비스를 제공하기 위해 업무 중 일부를
                  외부에 위탁하고 있습니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >서비스 향상을 위해서 관계 법령에 따라 위탁계약 시 개인정보가
               안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다<span
                  lang="ko"
                  >.</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >회사의 개인정보 위탁처리 기관 및 위탁업무 내용은 아래와
               같습니다<span lang="ko">.</span></span
            ><i style="mso-bidi-font-style: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></i>
         </p>

         <table
            class="a1"
            border="1"
            cellspacing="0"
            cellpadding="0"
            width="611"
            style="
               margin-left: -0.1pt;
               border-collapse: collapse;
               mso-table-layout-alt: fixed;
               border: none;
               mso-border-alt: solid black 0.75pt;
               mso-yfti-tbllook: 1536;
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-border-insideh: 0.75pt solid black;
               mso-border-insidev: 0.75pt solid black;
            "
         >
            <thead>
               <tr
                  style="mso-yfti-irow: 0; mso-yfti-firstrow: yes; height: 18pt"
               >
                  <td
                     width="100"
                     valign="top"
                     style="
                        width: 75pt;
                        border: solid black 1pt;
                        mso-border-alt: solid black 0.75pt;
                        background: #d9d9d9;
                        padding: 4pt 4pt 4pt 4pt;
                        height: 18pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <span class="SpellE"
                           ><b style="mso-bidi-font-weight: normal"
                              ><span
                                 style="
                                    font-family: 'IBM Plex Sans KR';
                                    mso-fareast-font-family: 'IBM Plex Sans KR';
                                    mso-bidi-font-family: 'IBM Plex Sans KR';
                                    color: black;
                                    mso-color-alt: windowtext;
                                 "
                                 >위탁받는</span
                              ></b
                           ></span
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                                 color: black;
                                 mso-color-alt: windowtext;
                              "
                           >
                              자</span
                           ></b
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              lang="ko"
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                              "
                              ><o:p></o:p></span
                        ></b>
                     </p>
                  </td>
                  <td
                     width="217"
                     valign="top"
                     style="
                        width: 162.75pt;
                        border: solid black 1pt;
                        border-left: none;
                        mso-border-left-alt: solid #bfbfbf 0.75pt;
                        mso-border-alt: solid black 0.75pt;
                        mso-border-left-alt: solid #bfbfbf 0.75pt;
                        background: #d9d9d9;
                        padding: 4pt 4pt 4pt 4pt;
                        height: 18pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <b style="mso-bidi-font-weight: normal"
                           ><span
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                                 color: black;
                                 mso-color-alt: windowtext;
                              "
                              >위탁하는 업무의 내용</span
                           ></b
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              lang="ko"
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                              "
                              ><o:p></o:p></span
                        ></b>
                     </p>
                  </td>
                  <td
                     width="294"
                     valign="top"
                     style="
                        width: 220.5pt;
                        border: solid black 1pt;
                        border-left: none;
                        mso-border-left-alt: solid #bfbfbf 0.75pt;
                        mso-border-alt: solid black 0.75pt;
                        mso-border-left-alt: solid #bfbfbf 0.75pt;
                        background: #d9d9d9;
                        padding: 4pt 4pt 4pt 4pt;
                        height: 18pt;
                     "
                  >
                     <p
                        class="MsoNormal"
                        align="center"
                        style="text-align: center; line-height: 162%"
                     >
                        <b style="mso-bidi-font-weight: normal"
                           ><span
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                                 color: black;
                                 mso-color-alt: windowtext;
                              "
                              >보유 기간</span
                           ></b
                        ><b style="mso-bidi-font-weight: normal"
                           ><span
                              lang="ko"
                              style="
                                 font-family: 'IBM Plex Sans KR';
                                 mso-fareast-font-family: 'IBM Plex Sans KR';
                                 mso-bidi-font-family: 'IBM Plex Sans KR';
                              "
                              ><o:p></o:p></span
                        ></b>
                     </p>
                  </td>
               </tr>
            </thead>
            <tr style="mso-yfti-irow: 1; height: 27.75pt">
               <td
                  width="100"
                  valign="top"
                  style="
                     width: 75pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 27.75pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <span class="SpellE"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >다날</span
                        ></span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="217"
                  valign="top"
                  style="
                     width: 162.75pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 27.75pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >휴대폰 본인확인 서비스</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="294"
                  valign="top"
                  style="
                     width: 220.5pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 27.75pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >위탁 계약 종료 시 까지</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
            </tr>
            <tr
               style="mso-yfti-irow: 2; mso-yfti-lastrow: yes; height: 27.75pt"
            >
               <td
                  width="100"
                  valign="top"
                  style="
                     width: 75pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 27.75pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <span class="SpellE"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >헥토데이터</span
                        ></span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="217"
                  valign="top"
                  style="
                     width: 162.75pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 27.75pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >운전면허인증<span lang="ko">, </span>여권
                        <span class="SpellE">위변조</span> 판별</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="294"
                  valign="top"
                  style="
                     width: 220.5pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 27.75pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="
                        text-align: center;
                        line-height: normal;
                        mso-pagination: none;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        >운전면허증<span lang="ko">, </span>여권 위<span
                           lang="ko"
                           >·</span
                        >변조 판별 후 즉시 파기<span lang="ko"><o:p></o:p></span
                     ></span>
                  </p>
               </td>
            </tr>
         </table>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p>&nbsp;</o:p></span
            >
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >4. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 파기</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  ><span style="mso-spacerun: yes"> </span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >개인정보는 수집 및 이용목적이 달성되면 별도의 동의 및
                  법령근거가 없는 경우 지체없이 파기합니다<span lang="ko"
                     >.</span
                  ></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >회사는 수집 및 이용 목적이 달성된 개인정보<span lang="ko"
                  >(</span
               >회원 탈퇴<span lang="ko">, </span>서비스 종료 등<span lang="ko"
                  >)</span
               >는 아래의 방법에 따라 지체없이 파기합니다<span lang="ko"
                  >.</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: 4pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >- </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >전자적 파일<span lang="ko"> : </span>복구 및 재생되지 않도록
               안전하게 삭제</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: 4pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >- </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >그 밖에 기록물<span lang="ko">, </span>인쇄물<span lang="ko"
                  >, </span
               >서면 등<span lang="ko"> : </span>분쇄하거나 소각</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: 4pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p>&nbsp;</o:p></span
            >
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >이 외에 법령에 따라 일정기간 보관해야 하는 개인정보 및 해당
               법령은 아래 표와 같습니다<span lang="ko">.</span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <table
            class="a2"
            border="1"
            cellspacing="0"
            cellpadding="0"
            width="604"
            style="
               margin-left: -0.1pt;
               border-collapse: collapse;
               mso-table-layout-alt: fixed;
               border: none;
               mso-border-alt: solid black 0.75pt;
               mso-yfti-tbllook: 1536;
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-border-insideh: 0.75pt solid black;
               mso-border-insidev: 0.75pt solid black;
            "
         >
            <tr style="mso-yfti-irow: 0; mso-yfti-firstrow: yes; height: 18pt">
               <td
                  width="213"
                  valign="top"
                  style="
                     width: 159.75pt;
                     border: solid black 1pt;
                     mso-border-alt: solid black 0.75pt;
                     background: #d9d9d9;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >보존항목</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="287"
                  valign="top"
                  style="
                     width: 215.25pt;
                     border: solid black 1pt;
                     border-left: none;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     background: #d9d9d9;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >근거법령</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="104"
                  valign="top"
                  style="
                     width: 78pt;
                     border: solid black 1pt;
                     border-left: none;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     background: #d9d9d9;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >보존기간</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 1; height: 18pt">
               <td
                  width="213"
                  valign="top"
                  style="
                     width: 159.75pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >소비자의 불만 또는 분쟁처리에 관한 기록</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="287"
                  valign="top"
                  style="
                     width: 215.25pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >전자상거래 등에서의 소비자 보호에 관한 법률</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="104"
                  valign="top"
                  style="
                     width: 78pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >3</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >년</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 2; height: 18pt">
               <td
                  width="213"
                  valign="top"
                  style="
                     width: 159.75pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >세법이 규정하는 모든 거래에 관한 장부 및 증빙서류</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="287"
                  valign="top"
                  style="
                     width: 215.25pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >국세기본법</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="104"
                  valign="top"
                  style="
                     width: 78pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >5</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >년</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 3; mso-yfti-lastrow: yes; height: 18pt">
               <td
                  width="213"
                  valign="top"
                  style="
                     width: 159.75pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >서비스 방문 기록</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="287"
                  valign="top"
                  style="
                     width: 215.25pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >통신비밀보호법</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
               <td
                  width="104"
                  valign="top"
                  style="
                     width: 78pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >3</span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >개월</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
            </tr>
         </table>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >5. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보의 안전성 확보조치에 관한 사항</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >이용자의 개인정보를 안전하게 보호하기 위해 필요한 조치를
                  운영하고 있습니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >회사는 이용자의 개인정보가 분실<span lang="ko">, </span
               >도난<span lang="ko">, </span>유출<span lang="ko">, </span>변조
               또는 훼손되지 않도록 안전성 확보를 위하여 다음과 같은 기술적<span
                  lang="ko"
                  >, </span
               >관리적<span lang="ko">, </span>물리적 조치를 운영하고
               있습니다</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <table
            class="a3"
            border="1"
            cellspacing="0"
            cellpadding="0"
            width="610"
            style="
               margin-left: -0.1pt;
               border-collapse: collapse;
               mso-table-layout-alt: fixed;
               border: none;
               mso-border-alt: solid black 0.75pt;
               mso-yfti-tbllook: 1536;
               mso-padding-alt: 5pt 5pt 5pt 5pt;
               mso-border-insideh: 0.75pt solid black;
               mso-border-insidev: 0.75pt solid black;
            "
         >
            <tr style="mso-yfti-irow: 0; mso-yfti-firstrow: yes; height: 18pt">
               <td
                  width="118"
                  valign="top"
                  style="
                     width: 88.5pt;
                     border: solid black 1pt;
                     mso-border-alt: solid black 0.75pt;
                     background: #d9d9d9;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >항 목</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="492"
                  valign="top"
                  style="
                     width: 369pt;
                     border: solid black 1pt;
                     border-left: none;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     background: #d9d9d9;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 18pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >내<span lang="ko"
                              ><span style="mso-spacerun: yes">  </span></span
                           >용</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 1; height: 57pt">
               <td
                  width="118"
                  valign="top"
                  style="
                     width: 88.5pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 57pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >기술적 조치</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="492"
                  valign="top"
                  style="
                     width: 369pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 57pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >개인정보 암호화 조치</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >백신 소프트웨어 등 설치<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        >및<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        >운영<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        ></span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >접근통제시스템 설치 및 운영</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >개인정보처리시스템에 대한 접근기록의 보관 등 </span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >개인정보처리시스템에<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        >대한<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        >접근권한<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        >차별화</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
            </tr>
            <tr style="mso-yfti-irow: 2; height: 47.25pt">
               <td
                  width="118"
                  valign="top"
                  style="
                     width: 88.5pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 47.25pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >관리적 조치</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="492"
                  valign="top"
                  style="
                     width: 369pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 47.25pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >개인정보보호 조직 구성<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        ></span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >내부관리계획의 수립 및 시행<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        ></span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >개인정보처리자의 정기 교육 및 점검 </span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >수탁사의 개인정보 처리 업무 관리 감독</span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
            </tr>
            <tr
               style="mso-yfti-irow: 3; mso-yfti-lastrow: yes; height: 27.75pt"
            >
               <td
                  width="118"
                  valign="top"
                  style="
                     width: 88.5pt;
                     border: solid black 1pt;
                     border-top: none;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-alt: solid black 0.75pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 27.75pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     align="center"
                     style="text-align: center; background: white"
                  >
                     <b style="mso-bidi-font-weight: normal"
                        ><span
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                              color: black;
                              mso-color-alt: windowtext;
                           "
                           >물리적 조치</span
                        ></b
                     ><b style="mso-bidi-font-weight: normal"
                        ><span
                           lang="ko"
                           style="
                              font-family: 'IBM Plex Sans KR';
                              mso-fareast-font-family: 'IBM Plex Sans KR';
                              mso-bidi-font-family: 'IBM Plex Sans KR';
                           "
                           ><o:p></o:p></span
                     ></b>
                  </p>
               </td>
               <td
                  width="492"
                  valign="top"
                  style="
                     width: 369pt;
                     border-top: none;
                     border-left: none;
                     border-bottom: solid black 1pt;
                     border-right: solid black 1pt;
                     mso-border-top-alt: solid #bfbfbf 0.75pt;
                     mso-border-left-alt: solid #bfbfbf 0.75pt;
                     mso-border-top-alt: #bfbfbf;
                     mso-border-left-alt: #bfbfbf;
                     mso-border-bottom-alt: black;
                     mso-border-right-alt: black;
                     mso-border-style-alt: solid;
                     mso-border-width-alt: 0.75pt;
                     padding: 4pt 4pt 4pt 4pt;
                     height: 27.75pt;
                  "
               >
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >개인정보를 보관 시설에 대한 출입통제 절차 수립 및
                        운영<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        ></span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
                  <p
                     class="MsoNormal"
                     style="
                        text-align: justify;
                        text-justify: inter-ideograph;
                        background: white;
                     "
                  >
                     <span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >- </span
                     ><span
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                           color: black;
                           mso-color-alt: windowtext;
                        "
                        >개인정보가 포함된 서류나 보조기억매체 등은
                        <span class="SpellE">잠금장치가</span> 부착되어 있는
                        안전한 장소에 보관<span lang="ko"
                           ><span style="mso-spacerun: yes">  </span></span
                        ></span
                     ><span
                        lang="ko"
                        style="
                           font-family: 'IBM Plex Sans KR';
                           mso-fareast-font-family: 'IBM Plex Sans KR';
                           mso-bidi-font-family: 'IBM Plex Sans KR';
                        "
                        ><o:p></o:p
                     ></span>
                  </p>
               </td>
            </tr>
         </table>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: 11pt;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >6. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 자동 수집 장치의 설치 및 운영 및 그 거부에 관한
               사항</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >이용자에게 편의 제공을 위하여 쿠키 정보를 이용할 수
                  있습니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span class="SpellE"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >쿠키란</span
               ></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
            >
               웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는
               작은 텍스트 파일로 이용자 컴퓨터에 자동 저장됩니다<span lang="ko"
                  >.</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span class="SpellE"
               ><b style="mso-bidi-font-weight: normal"
                  ><span
                     lang="ko"
                     style="
                        font-family: 'IBM Plex Sans KR';
                        mso-fareast-font-family: 'IBM Plex Sans KR';
                        mso-bidi-font-family: 'IBM Plex Sans KR';
                        color: black;
                        mso-color-alt: windowtext;
                     "
                     >l</span
                  ></b
               ></span
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  ><span style="mso-spacerun: yes">  </span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >쿠키 사용 목적</span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >이용자가 웹사이트를 이용하는 경우 웹 사이트 서버는 이용자의
               디바이스에 저장된 쿠키를 사용하게 됩니다<span lang="ko">. </span
               >회사는 웹 분석<span lang="ko">
                  Tool<i style="mso-bidi-font-style: normal"><u> </u></i></span
               >등을 통해 쿠키를 활용하여 이용자의 웹사이트 방문 기록<span
                  lang="ko"
                  >, </span
               >이용 형태 등을 파악하고 이용자에 맞는 맞춤형 광고 정보 제공 및
               서비스 개선을 수행하고 있습니다<span lang="ko">. </span>쿠키
               정보는 이용자의 디바이스 식별용도로만 활용되며 개개인을 식별하지
               않습니다<span lang="ko">.</span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span class="SpellE"
               ><b style="mso-bidi-font-weight: normal"
                  ><span
                     lang="ko"
                     style="
                        font-family: 'IBM Plex Sans KR';
                        mso-fareast-font-family: 'IBM Plex Sans KR';
                        mso-bidi-font-family: 'IBM Plex Sans KR';
                        color: black;
                        mso-color-alt: windowtext;
                     "
                     >l</span
                  ></b
               ></span
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  ><span style="mso-spacerun: yes">  </span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >쿠키 수집 거부</span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >이용자는 웹 브라우저에서 아래와 같이 옵션을 설정함으로써 쿠키
               정보의 저장을 제한할 수 있습니다<span lang="ko">. </span>단<span
                  lang="ko"
                  >, </span
               >쿠키 정보의 저장을 거부하면 로그인 정보 저장 및 맞춤형 광고 차단
               등 일부 서비스의 이용이 어려울 수 있습니다<span lang="ko"
                  >.</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >1) <span class="SpellE">Internet</span> Explorer</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 43pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >웹 브라우저 상단의 도구 메뉴<span lang="ko"> &gt; </span>인터넷
               옵션<span lang="ko"> &gt; </span>개인정보<span lang="ko">
                  &gt; </span
               >설정</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >2) <span class="SpellE">Chrome</span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 43pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >웹 브라우저 우측의 설정 메뉴<span lang="ko"> &gt; </span>화면
               하단의 고급 설정 표시<span lang="ko"> &gt; </span>개인정보의
               콘텐츠 설정 버튼<span lang="ko"> &gt; </span>쿠키</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >모바일 앱의 경우 아래의 방법을 통해 맞춤형 광고 설정을 해제할 수
               있습니다</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >1) <span class="SpellE">Android</span>: </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >설정<span lang="ko"> &gt; Google </span>설정<span lang="ko">
                  &gt; </span
               >광고<span lang="ko"> &gt; ‘</span>광고 맞춤설정 선택 해제<span
                  lang="ko"
                  >’ </span
               >활성화</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >2) IOS: </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >설정<span lang="ko"> &gt; </span>개인정보보호<span lang="ko">
                  &gt; </span
               >광고<span lang="ko"> &gt; ‘</span>광고 추적 제한<span lang="ko"
                  >’ </span
               >활성화 </span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p>&nbsp;</o:p></span
            >
         </p>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >7.<span style="mso-spacerun: yes">  </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 보호업무 및 관련 고충 문의</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >이용자의 권리를 보호하기 위해 적극적으로 필요한 조치를
                  운영하고 있습니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >이용자는 언제든지 자신의 개인정보를 조회하거나 수정<span
                  lang="ko"
                  >, </span
               >이동<span lang="ko">, </span>삭제 등이 가능합니다<span lang="ko"
                  >. </span
               >또<span lang="ko">, </span>원하는 때에 동의 철회 또는 가입
               해지를 요청할 수도 있습니다<span lang="ko">.</span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p>&nbsp;</o:p></span
            >
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                     mso-ansi-language: EN-US;
                  "
                  >사용자 계정 삭제 요청방법</span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="EN-US"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     mso-ansi-language: EN-US;
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="EN-US"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
                  mso-ansi-language: EN-US;
                  mso-bidi-font-weight: bold;
               "
               >* </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
                  mso-ansi-language: EN-US;
                  mso-bidi-font-weight: bold;
               "
               >앱 실행<span lang="EN-US">
                  →<span style="mso-spacerun: yes">  </span></span
               >설정 메뉴<span lang="EN-US"> → '</span>멤버탈퇴<span
                  lang="EN-US"
                  >'</span
               ><span class="SpellE">를</span> 선택할 수 있습니다<span
                  lang="EN-US"
                  >.</span
               ></span
            ><span
               lang="EN-US"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  mso-ansi-language: EN-US;
                  mso-bidi-font-weight: bold;
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
                  mso-ansi-language: EN-US;
                  mso-bidi-font-weight: bold;
               "
               >회원탈퇴 시 계정이 삭제되고<span lang="EN-US">, </span>사용자의
               가입 정보가 모두 삭제 처리됩니다<span lang="EN-US">. </span>탈퇴
               계정은 다시 사용 불가하며<span lang="EN-US">, </span>계정 복구
               불가합니다<span lang="EN-US">.</span></span
            ><span
               lang="EN-US"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  mso-ansi-language: EN-US;
                  mso-bidi-font-weight: bold;
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-weight: bold;
               "
               ><o:p>&nbsp;</o:p></span
            >
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >개인정보보호와 관련해서 궁금하신 사항이 있으시면 언제든 문의
                  주시기 바랍니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >서비스를 이용하면서 발생하는 모든 개인정보보호 관련 문의<span
                  lang="ko"
                  >, </span
               >불만<span lang="ko">, </span>조언이나 기타 사항은 개인정보
               보호책임자 및 담당부서로 연락해 주시기 바랍니다<span lang="ko"
                  >.</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span class="SpellE"
               ><b style="mso-bidi-font-weight: normal"
                  ><span
                     lang="ko"
                     style="
                        font-family: 'IBM Plex Sans KR';
                        mso-fareast-font-family: 'IBM Plex Sans KR';
                        mso-bidi-font-family: 'IBM Plex Sans KR';
                        color: black;
                        mso-color-alt: windowtext;
                     "
                     >l</span
                  ></b
               ></span
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  ><span style="mso-spacerun: yes">  </span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >개인정보보호 책임자<span lang="ko">(CPO, DPO) </span>및
                  담당부서</span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >책임자<span lang="ko">: </span
               ><span class="SpellE">천경민</span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >담당부서<span lang="ko">: </span>정보보호팀</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >문의<span lang="ko">: privacy@parametacorp.com</span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 32pt;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >8. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >권익침해 구제방법</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >개인정보가 침해되어 이에 대한 신고나 전문적인 상담이 필요하신
                  경우에는 아래 기관에 문의하셔서 도움을 받으실 수 있습니다<span
                     lang="ko"
                     >.</span
                  ></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes"> </span></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 60pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -15pt;
               background: white;
            "
         >
            <span class="SpellE"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >l</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes">  </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보침해 신고센터<span lang="ko">: (</span>국번없이<span
                  lang="ko"
                  >)118, https://privacy.kisa.or.kr</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 60pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -15pt;
               background: white;
            "
         >
            <span class="SpellE"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >l</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes">  </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 분쟁조정위원회<span lang="ko"
                  >: 1833-6972, https://www.kopico.go.kr</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 60pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -15pt;
               background: white;
            "
         >
            <span class="SpellE"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >l</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes">  </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >대검찰청 사이버수사과<span lang="ko">: (</span>국번없이<span
                  lang="ko"
                  >)1301, cid@spo.go.kr</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 60pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -15pt;
               background: white;
            "
         >
            <span class="SpellE"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >l</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes">  </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >경찰청 사이버안전국<span lang="ko">: (</span>국번없이<span
                  lang="ko"
                  >)182, https://cyberbureau.police.go.kr</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  ><span style="mso-spacerun: yes"> </span></span
               ></b
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-top: 9pt;
               margin-right: 0cm;
               margin-bottom: 9pt;
               margin-left: 0cm;
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >9. </span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >개인정보 처리방침 변경에 관한 사항</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <b style="mso-bidi-font-weight: normal"
               ><span
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >개인정보 처리방침이 변경되는 경우에 홈페이지에
                  게시됩니다<span lang="ko">.</span></span
               ></b
            ><b style="mso-bidi-font-weight: normal"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                  "
                  ><o:p></o:p></span
            ></b>
         </p>

         <p
            class="MsoNormal"
            style="
               text-align: justify;
               text-justify: inter-ideograph;
               background: white;
            "
         >
            <span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >법률이나 서비스의 변경사항을 반영하기 위한 목적 등으로 개인정보
               처리방침이 변경되는 경우<span lang="ko">, </span>회사는
               변경내용을 홈페이지에 게시하여 이용자가 언제든 확인할 수 있도록
               하겠습니다<span lang="ko"
                  >.<br />
                  <br style="mso-special-character: line-break" />
                  <![if !supportLineBreakNewLine]><br
                     style="mso-special-character: line-break"
                  />
                  <![endif]></span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 60pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -15pt;
               background: white;
            "
         >
            <span class="SpellE"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >l</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes">  </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >공고일자<span lang="ko">: 2024</span>년<span lang="ko"> 08</span
               >월<span lang="ko"> 14</span>일</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>

         <p
            class="MsoNormal"
            style="
               margin-left: 60pt;
               text-align: justify;
               text-justify: inter-ideograph;
               text-indent: -15pt;
               background: white;
            "
         >
            <span class="SpellE"
               ><span
                  lang="ko"
                  style="
                     font-family: 'IBM Plex Sans KR';
                     mso-fareast-font-family: 'IBM Plex Sans KR';
                     mso-bidi-font-family: 'IBM Plex Sans KR';
                     color: black;
                     mso-color-alt: windowtext;
                  "
                  >l</span
               ></span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               ><span style="mso-spacerun: yes">  </span></span
            ><span
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
                  color: black;
                  mso-color-alt: windowtext;
               "
               >시행일자<span lang="ko">: 2024</span>년<span lang="ko"> 08</span
               >월<span lang="ko"> 21</span>일</span
            ><span
               lang="ko"
               style="
                  font-family: 'IBM Plex Sans KR';
                  mso-fareast-font-family: 'IBM Plex Sans KR';
                  mso-bidi-font-family: 'IBM Plex Sans KR';
               "
               ><o:p></o:p
            ></span>
         </p>
      </div>

      <div style="mso-element: comment-list">
         <![if !supportAnnotations]>

         <hr class="msocomoff" align="left" size="1" width="33%" />

         <![endif]>

         <div style="mso-element: comment">
            <![if !supportAnnotations]>

            <div
               id="_com_1"
               class="msocomtxt"
               language="JavaScript"
               onmouseover="msoCommentShow('_anchor_1','_com_1')"
               onmouseout="msoCommentHide('_com_1')"
            >
               <![endif]><span
                  style="mso-comment-author: '홍치경\(ChiKyung Hong\)'"
                  ><![if !supportAnnotations]><a name="_msocom_1"></a
                  ><![endif]></span
               >

               <p
                  class="MsoNormal"
                  style="
                     line-height: normal;
                     mso-pagination: none;
                     border: none;
                     mso-padding-alt: 31pt 31pt 31pt 31pt;
                     mso-border-shadow: yes;
                  "
               >
                  <span
                     style="
                        font-family: 'Arial Unicode MS', sans-serif;
                        color: black;
                     "
                  ></span
                  ><span lang="ko" style="color: black"><o:p></o:p></span>
               </p>

               <![if !supportAnnotations]>
            </div>

            <![endif]>
         </div>
      </div>
   </body>
</html>

  `,
   },
];

export default { tosData, tosPrevData };
